export default {
  reminder_trigger: {
    start_date: 'Startdatum',
    expiry_date: 'Ablaufdatum',
    start_date_required: 'Startdatum ist erforderlich!',
    expiry_date_required: 'Ablaufdatum ist erforderlich!',
    select_start_date: 'Startdatum auswählen',
    select_expiry_date: 'Ablaufdatum auswählen',
    title: 'Erinnerungsauslöser & Häufigkeit',
    expand_all: 'Alle erweitern',
    recurrence_by_date: 'Wiederholung nach Datum',
    mandatory_course: 'Pflichtkurs',
    by_failed_attempts: 'Nach fehlgeschlagenen Versuchen',
    every: 'Alle',
    due_date: 'Fälligkeitsdatum',
    select_interval: 'Intervall auswählen',
    select_duration: 'Dauer auswählen',
    select_date: 'Datum auswählen',
    day: 'Tag',
    week: 'Woche',
    month: 'Monat',
    year: 'Jahr',
    tooltip_start_date: 'Startdatum',
    tooltip_start_date_description: 'Diese Regel verwendet das globale Startdatum des Kurses, das links festgelegt ist.',
  },
  tour: {
    take_a_tour: 'Rundgang machen',
    // Add Content Tour
    add_content_generation_name: 'Inhalt erweitern',
    add_content_generation_desc: 'Erweitern Sie Ihren Kurs intelligent mit ergänzenden Inhalten, die das Lernerlebnis bereichern.',
    add_content_generation_step_0_title: 'Zugriff auf Inhaltsgenerierungstools',
    add_content_generation_step_0_content: "Klicken Sie hier, um das Menü zur Inhaltsgenerierung zu erweitern und die KI-gestützten Autorentools von Sharelook freizuschalten.",
    add_content_generation_step_1_title: 'Zusätzliche Inhalte generieren',
    add_content_generation_step_1_content_prefix: 'Wählen Sie ',
    add_content_generation_step_1_content_bold: 'Inhalt hinzufügen',
    add_content_generation_step_1_content_suffix: " um Ihren Kurs mit unterstützenden Materialien zu erweitern. Die KI von Sharelook analysiert Ihre vorhandenen Inhalte, um relevante, hochwertige Ergänzungen zu generieren.",
    add_content_generation_step_2_title: 'Referenzmaterial auswählen',
    add_content_generation_step_2_content: 'Wählen Sie die Seiten aus, die als Grundlage für neue Inhalte dienen sollen. Die KI identifiziert Möglichkeiten, das Verständnis zu vertiefen und Wissenslücken zu schließen.',
    add_content_generation_step_3_title: 'Komplementäre Inhalte generieren',
    add_content_generation_step_3_content_prefix: 'Klicken Sie auf ',
    add_content_generation_step_3_content_bold: 'Inhalt hinzufügen',
    add_content_generation_step_3_content_suffix: ' um den Erweiterungsprozess zu starten. Sharelook produziert kontextuell relevante Materialien, die sich nahtlos in Ihren bestehenden Kurs integrieren.',

    // Interactive Tour
    interactive_generation_name: 'Interaktive Simulationen',
    interactive_generation_desc: 'Verwandeln Sie Ihre statischen Inhalte in immersive, praxisnahe Lernerlebnisse mit KI-gestützten interaktiven Simulationen.',
    interactive_generation_step_0_title: 'Zugriff auf Inhaltsgenerierungstools',
    interactive_generation_step_0_content: "Klicken Sie hier, um das Menü zur Inhaltsgenerierung zu erweitern und die KI-gestützten Autorentools von Sharelook freizuschalten.",
    interactive_generation_step_1_title: 'Interaktive Simulationen erstellen',
    interactive_generation_step_1_content_prefix: 'Wählen Sie ',
    interactive_generation_step_1_content_bold: 'Interaktive Simulation',
    interactive_generation_step_1_content_suffix: " um Ihre Kursseiten in ansprechende, szenariobasierte Lernerlebnisse zu verwandeln. Die KI von Sharelook generiert realistische Simulationen, die die aktive Teilnahme der Lernenden fördern.",
    interactive_generation_step_2_title: 'Quellinhalt wählen',
    interactive_generation_step_2_content: "Wählen Sie die Seiten aus Ihrem Kurs aus, die Sie mit interaktiven Elementen verbessern möchten. Die KI analysiert Ihren Inhalt und erstellt kontextuell relevante Simulationen.",
    interactive_generation_step_3_title: 'Ihre Simulation generieren',
    interactive_generation_step_3_content_prefix: 'Klicken Sie auf ',
    interactive_generation_step_3_content_bold: 'Interaktive Lektion',
    interactive_generation_step_3_content_suffix: ' um den KI-Generierungsprozess zu starten. Sharelook erstellt innerhalb von Sekunden eine immersive Simulation, die auf Ihre Lernziele zugeschnitten ist.',

    // Background Color Tour
    background_color_settings_name: 'Anpassung der Hintergrundfarbe',
    background_color_settings_desc: 'Wenden Sie Markenfarben an und schaffen Sie visuelle Konsistenz in Ihren Lerninhalten.',
    background_color_settings_step_0_title: 'Hintergrundfarbeinstellungen',
    background_color_settings_step_0_content: 'Dieses Panel ermöglicht es Ihnen, die Hintergrundfarbe Ihrer Seite anzupassen. Wählen Sie Farben, die zu Ihrer Marke passen und das Lernerlebnis verbessern.',
    background_color_settings_step_1_title: 'Farbe wählen',
    background_color_settings_step_1_content: 'Wählen Sie aus der Palette oder geben Sie einen spezifischen Hex-Code ein, um Ihren Markenrichtlinien zu entsprechen. Konsistente Farbverwendung stärkt die Markenidentität.',
    background_color_settings_step_2_title: 'Auswahl anwenden',
    background_color_settings_step_2_content: 'Bestätigen Sie, um die Hintergrundfarbe auf Ihre Seite anzuwenden. Ihre Änderungen sind sofort im Editor sichtbar.',

    // Background Image Tour
    background_image_settings_name: 'Anpassung des Hintergrundbildes',
    background_image_settings_desc: 'Erstellen Sie visuell beeindruckende Seiten mit professionellen Hintergrundbildern und präziser Deckkraftsteuerung.',
    background_image_settings_step_0_title: 'Hintergrundbildeinstellungen',
    background_image_settings_step_0_content: "Dieses Panel bietet vollständige Kontrolle über das Hintergrundbild Ihrer Seite. Erstellen Sie visuell beeindruckende Seiten mit professionellen Bildern und präziser Anpassung.",
    background_image_settings_step_1_title: 'Hintergrundbild auswählen',
    background_image_settings_step_1_content: 'Wählen Sie aus Ihrer Medienbibliothek oder laden Sie ein neues Bild hoch. Hochwertige Hintergründe schaffen professionelle, ansprechende Seiten.',
    background_image_settings_step_2_title: 'Deckkraft feinabstimmen',
    background_image_settings_step_2_content: 'Passen Sie die Transparenz an, um eine optimale Lesbarkeit des Vordergrundinhalts zu gewährleisten. Dezente Hintergründe verbessern, ohne abzulenken.',
    background_image_settings_step_3_title: 'Hintergrund entfernen',
    background_image_settings_step_3_content: 'Löschen Sie das aktuelle Hintergrundbild, um zu einer sauberen Leinwand zurückzukehren oder eine andere visuelle Behandlung anzuwenden.',
    background_image_settings_step_4_title: 'Änderungen abschließen',
    background_image_settings_step_4_content: 'Wenden Sie Ihre Hintergrundeinstellungen an, um die Seite zu aktualisieren. Änderungen werden gespeichert und sind für Lernende sofort sichtbar.',

    // Create Course Tour
    create_course_name: 'Kurserstellung Rundgang',
    create_course_desc: 'Lernen Sie, umfassende, unternehmensgerechte Lernprogramme mit Sharelook zu erstellen.',
    create_course_step_0_title: 'Willkommen im Kurs-Builder',
    create_course_step_0_content: 'Willkommen im erstklassigen Kurs-Builder von Sharelook. Dieser Arbeitsbereich ist darauf ausgelegt, Ihnen bei der Gestaltung hochwirksamer Lernerlebnisse zu helfen. Lassen Sie uns einen kurzen Rundgang durch die wesentlichen Tools machen, die Ihnen zur Verfügung stehen.',
    create_course_step_1_title: 'Kernkonfiguration',
    create_course_step_1_content:
      'Dieses Konfigurationspanel ermöglicht es Ihnen, das Fundament Ihres Kurses zu definieren. Die genaue Festlegung dieser Attribute stellt sicher, dass Ihre Inhalte organisiert, durchsuchbar und professionell präsentiert werden.',
    create_course_step_2_title: 'Überzeugender Titel',
    create_course_step_2_content:
      'Ein großartiger Kurs beginnt mit einem starken Titel. Zielen Sie auf etwas Klares und Ansprechendes ab, das Ihrem Publikum sofort die Lernergebnisse signalisiert.',
    create_course_step_3_title: 'Professionelle Bildsprache',
    create_course_step_3_content:
      'Visuals sind wichtig. Ein professionelles Titelbild gibt den Ton an und schafft sofortige Glaubwürdigkeit. Wählen Sie ein Bild, das zu Ihrem Thema passt und Lernende inspiriert.',
    create_course_step_4_title: 'Lehrplanstruktur',
    create_course_step_4_content:
      'Ihr Lehrplan ist das Herzstück des Kurses. Hier können Sie Ihre Lektionen strukturieren, reichhaltige Medien hinzufügen und eine Reise gestalten, die Ihre Lernenden von der Theorie zur Meisterschaft führt.',
    create_course_step_5_title: 'Ihren Kurs veröffentlichen',
    create_course_step_5_content: 'Bereit, Ihr Fachwissen zu teilen? Sobald Sie Ihre Inhalte finalisiert haben, verwenden Sie die Schaltfläche „Veröffentlichen“, um Ihren Kurs bereitzustellen. Sharelook übernimmt die Bereitstellung und macht ihn sofort in Ihrer gesamten Organisation verfügbar.',
    create_course_ai_step_title: 'KI-Kurserstellung',
    create_course_ai_step_content: 'Klicken Sie hier, um zum nächsten Schritt überzugehen. Die KI von Sharelook generiert automatisch relevante Themen und Lektionen basierend auf Ihrer Kurskonfiguration, was Ihnen Zeit und Mühe spart.',

    // Create Lesson Tour
    create_lesson_name: 'Lektionserstellung Rundgang',
    create_lesson_desc: 'Meistern Sie die Grundlagen der Erstellung professioneller, wirkungsvoller Lektionen in Sharelook.',
    create_lesson_step_0_title: 'Lektions-Builder',
    create_lesson_step_0_content: "Willkommen im Lektions-Builder von Sharelook – Ihrem Arbeitsbereich für die Gestaltung ansprechender, strukturierter Lernerlebnisse. Lassen Sie uns die wesentlichen Elemente effektiven Lektionsdesigns durchgehen.",
    create_lesson_step_1_title: 'Lektion definieren',
    create_lesson_step_1_content: "Beginnen Sie mit einem klaren, beschreibenden Titel, der das Lernziel der Lektion erfasst. Effektive Titel setzen klare Erwartungen und helfen Lernenden, Ihre Kursstruktur zu navigieren.",
    create_lesson_step_2_title: 'Visuelle Identität',
    create_lesson_step_2_content: 'Laden Sie ein professionelles Titelbild hoch, das Ihren Lektionsinhalt repräsentiert. Hochwertige Visuals verbessern das Engagement der Lernenden und machen Ihre Inhalte einprägsamer.',
    create_lesson_step_3_title: 'Inhalt aufbauen',
    create_lesson_step_3_content: 'Bereit, Inhalt hinzuzufügen? Klicken Sie hier, um Seiten zu erstellen und Ihre Lektion aufzubauen. Sharelook bietet leistungsstarke Tools, um Ihre Vision zum Leben zu erwecken.',

    // Infographics Tour
    infographics_generation_name: 'Visuelle Datengeschichten',
    infographics_generation_desc: 'Wandeln Sie komplexe Informationen in visuell überzeugende Infografiken um, die Verständnis und Behalten verbessern.',
    infographics_generation_step_0_title: 'Zugriff auf Inhaltsgenerierungstools',
    infographics_generation_step_0_content: "Klicken Sie hier, um das Menü zur Inhaltsgenerierung zu erweitern und die KI-gestützten Autorentools von Sharelook freizuschalten.",
    infographics_generation_step_1_title: 'Visuelle Inhalte gestalten',
    infographics_generation_step_1_content_prefix: 'Wählen Sie ',
    infographics_generation_step_1_content_bold: 'Infografiken',
    infographics_generation_step_1_content_suffix: " um Daten und Konzepte in professionelle visuelle Darstellungen zu verwandeln. Die KI von Sharelook identifiziert wichtige Informationen und organisiert sie für maximale visuelle Wirkung.",
    infographics_generation_step_2_title: 'Inhalt zur Visualisierung auswählen',
    infographics_generation_step_2_content: 'Wählen Sie die Seiten mit Daten oder Konzepten aus, die Sie visualisieren möchten. Die KI extrahiert kritische Informationen und entwirft eine ansprechende Infografik.',
    infographics_generation_step_3_title: 'Infografik generieren',
    infographics_generation_step_3_content_prefix: 'Klicken Sie auf ',
    infographics_generation_step_3_content_bold: 'Infografik generieren',
    infographics_generation_step_3_content_suffix: ' um den Visualisierungsprozess zu beginnen. Sharelook erstellt eine professionelle Infografik, die Ihre Botschaft klar und effektiv kommuniziert.',

    // Quiz Tour
    quiz_generation_name: 'Intelligente Bewertungen',
    quiz_generation_desc: 'Erstellen Sie adaptive Quizze, die das Verständnis genau messen und Schlüsselkonzepte verstärken.',
    quiz_generation_step_0_title: 'Zugriff auf Inhaltsgenerierungstools',
    quiz_generation_step_0_content: "Klicken Sie hier, um das Menü zur Inhaltsgenerierung zu erweitern und die KI-gestützten Autorentools von Sharelook freizuschalten.",
    quiz_generation_step_1_title: 'Smarte Quizze erstellen',
    quiz_generation_step_1_content_prefix: 'Wählen Sie ',
    quiz_generation_step_1_content_bold: 'KI-Quiz',
    quiz_generation_step_1_content_suffix: " um Bewertungsfragen zu generieren, die präzise auf Ihre Lernziele abzielen. Die KI von Sharelook erstellt abwechslungsreiche, pädagogisch fundierte Fragen, die wahres Verständnis testen.",
    quiz_generation_step_2_title: 'Bewertungsumfang definieren',
    quiz_generation_step_2_content: 'Wählen Sie die Seiten mit dem Inhalt aus, den Sie bewerten möchten. Die KI analysiert Ihr Material, um kontextuell relevante Fragen zu generieren.',
    quiz_generation_step_3_title: 'Bewertung generieren',
    quiz_generation_step_3_content_prefix: 'Klicken Sie auf ',
    quiz_generation_step_3_content_bold: 'Quiz generieren',
    quiz_generation_step_3_content_suffix: ' um den Quiz-Builder zu starten. Sharelook generiert innerhalb von Augenblicken hochwertige Fragen, die auf Ihre Inhalte abgestimmt sind.',

    // Scenario Tour
    scenario_generation_name: 'Szenariobasiertes Training',
    scenario_generation_desc: 'Erstellen Sie realistische, entscheidungsgetriebene Szenarien, die Lernende auf Herausforderungen in der realen Welt vorbereiten.',
    scenario_generation_step_0_title: 'Zugriff auf Inhaltsgenerierungstools',
    scenario_generation_step_0_content: "Klicken Sie hier, um das Menü zur Inhaltsgenerierung zu erweitern und die KI-gestützten Autorentools von Sharelook freizuschalten.",
    scenario_generation_step_1_title: 'Entscheidungsszenarien aufbauen',
    scenario_generation_step_1_content_prefix: 'Wählen Sie ',
    scenario_generation_step_1_content_bold: 'Szenario',
    scenario_generation_step_1_content_suffix: " um verzweigte, konsequenzbasierte Lernpfade zu erstellen. Die KI von Sharelook generiert authentische Szenarien, die kritisches Denken fördern.",
    scenario_generation_step_2_title: 'Grundlageninhalt auswählen',
    scenario_generation_step_2_content: 'Wählen Sie die Seiten, die die Konzepte für Ihr Szenario enthalten. Die KI baut realistische Entscheidungspunkte basierend auf Ihren Inhalten auf.',
    scenario_generation_step_3_title: 'Ihr Szenario generieren',
    scenario_generation_step_3_content_prefix: 'Klicken Sie auf ',
    scenario_generation_step_3_content_bold: 'Szenario generieren',
    scenario_generation_step_3_content_suffix: ' um die Szenariogenerierung zu initiieren. Sharelook erstellt eine immersive, verzweigte Erzählung, die auf Ihre Lernziele zugeschnitten ist.',

    // Story Tour
    story_generation_name: 'Storybasiertes Lernen',
    story_generation_desc: 'Verwandeln Sie trockene Inhalte in fesselnde Erzählungen, die emotionale Bindung und Wissensretention fördern.',
    story_generation_step_0_title: 'Zugriff auf Inhaltsgenerierungstools',
    story_generation_step_0_content: "Klicken Sie hier, um das Menü zur Inhaltsgenerierung zu erweitern und die KI-gestützten Autorentools von Sharelook freizuschalten.",
    story_generation_step_1_title: 'Erzählerische Inhalte erstellen',
    story_generation_step_1_content_prefix: 'Wählen Sie ',
    story_generation_step_1_content_bold: 'Geschichten schreiben',
    story_generation_step_1_content_suffix: " um Ihr Kursmaterial in überzeugende Erzählungen zu verwandeln. Die KI von Sharelook ist hervorragend darin, Bildungsinhalte in unvergessliche, geschichtengetriebene Erlebnisse zu verweben.",
    story_generation_step_2_title: 'Quellmaterial auswählen',
    story_generation_step_2_content: "Wählen Sie die Seiten mit den Konzepten aus, die Sie in eine Geschichte verwandeln möchten. Die KI extrahiert wichtige Lernpunkte und baut eine Erzählung um sie herum auf.",
    story_generation_step_3_title: 'Story-Builder starten',
    story_generation_step_3_content_prefix: 'Klicken Sie auf ',
    story_generation_step_3_content_bold: 'Geschichte erstellen',
    story_generation_step_3_content_suffix: " um auf die Story-Generierungsoberfläche von Sharelook zuzugreifen, wo Sie Ihre Erzählung präzise gestalten können.",
    story_generation_step_4_title: 'Erzählung gestalten',
    story_generation_step_4_content: 'Nutzen Sie unseren intelligenten Story-Builder, um Ihre Erzählung zu verfeinern. Arbeiten Sie mit der KI durch konversationelle Eingabeaufforderungen oder strukturierte Eingaben zusammen, um Ihr gewünschtes Ergebnis zu erzielen.',
    story_generation_step_5_title: 'Geschichte generieren',
    story_generation_step_5_content_prefix: 'Klicken Sie auf ',
    story_generation_step_5_content_bold: 'Ihre erste Geschichte erstellen',
    story_generation_step_5_content_suffix: " um Ihre Erzählung zu erstellen. Die KI von Sharelook erstellt eine ansprechende Geschichte, die Ihre Lernziele nahtlos integriert.",

    // Toolbar Tour
    toolbar_guide_name: 'Inhalts-Autorentools',
    toolbar_guide_desc: "Meistern Sie das umfassende Toolkit von Sharelook zur Erstellung reichhaltiger, multimedialer Lernerlebnisse.",
    toolbar_guide_step_0_title: 'Präzisionsausrichtung',
    toolbar_guide_step_0_content: 'Aktivieren Sie das Raster-Overlay, um eine pixelgenaue Ausrichtung der Elemente zu gewährleisten. Professionelle Layouts beginnen mit präziser Positionierung.',
    toolbar_guide_step_1_title: 'Textinhalt',
    toolbar_guide_step_1_content: 'Fügen Sie formatierte Textblöcke hinzu, um Konzepte und Anweisungen zu vermitteln. Beinhaltet vollständige Rich-Text-Bearbeitungsfunktionen, Hyperlinks und Typografiekontrollen.',
    toolbar_guide_step_2_title: 'Visuelle Medien',
    toolbar_guide_step_2_content: 'Integrieren Sie Bilder, um Verständnis und Engagement zu verbessern. Laden Sie aus Ihrer Bibliothek oder von Ihrem Gerät hoch, um Ihren Lektionen visuellen Kontext hinzuzufügen.',
    toolbar_guide_step_3_title: 'Video-Integration',
    toolbar_guide_step_3_content: 'Betten Sie Videos von YouTube, Vimeo oder Ihren eigenen Uploads ein. Videoinhalte fördern das Engagement und unterstützen vielfältige Lernpräferenzen.',
    toolbar_guide_step_4_title: 'Audio-Elemente',
    toolbar_guide_step_4_content: 'Fügen Sie Voiceovers, Podcasts oder Umgebungsgeräusche hinzu, um immersive Lernumgebungen zu schaffen. Audio unterstützt Barrierefreiheit und multisensorisches Lernen.',
    toolbar_guide_step_5_title: 'Augmented Reality',
    toolbar_guide_step_5_content: 'Integrieren Sie AR-Erlebnisse, um Konzepte zum Leben zu erwecken. Erstellen Sie hochmoderne, immersive Lerninhalte, die digitale und physische Welten verbinden.',
    toolbar_guide_step_6_title: 'Wissensüberprüfungen',
    toolbar_guide_step_6_content: 'Betten Sie interaktive Quizze ein, um das Lernen zu validieren und Schlüsselkonzepte zu verstärken. Verfolgen Sie den Fortschritt der Lernenden und identifizieren Wissenslücken.',
    toolbar_guide_step_7_title: 'Interaktive Anmerkungen',
    toolbar_guide_step_7_content: 'Legen Sie interaktive Anmerkungen über Bilder und Medien. Erstellen Sie anklickbare Hotspots, die zusätzliche Informationen offenbaren und die Erkundung fördern.',
    toolbar_guide_step_8_title: 'Seitenstyling',
    toolbar_guide_step_8_content: 'Passen Sie Seitenhintergründe an Ihre Marke an oder erstellen Sie eine visuelle Hierarchie. Professionelles Design erhöht die Glaubwürdigkeit der Inhalte.',
    toolbar_guide_step_9_title: 'Lernenden-Vorschau',
    toolbar_guide_step_9_content: 'Erleben Sie Ihren Kurs genau so, wie ihn die Lernenden sehen werden. Der Vorschaumodus gewährleistet die Qualitätskontrolle vor der Veröffentlichung.',

    // World Scenario Tour
    world_scenario_generation_name: 'Anwendungen in der realen Welt',
    world_scenario_generation_desc: 'Verbinden Sie Theorie und Praxis mit authentischen Arbeitsplatzszenarien, die berufsrelevante Fähigkeiten aufbauen.',
    world_scenario_generation_step_0_title: 'Zugriff auf Inhaltsgenerierungstools',
    world_scenario_generation_step_0_content: 'Klicken Sie hier, um das Menü zur Inhaltsgenerierung zu erweitern und die KI-gestützten Autorentools von Sharelook freizuschalten.',
    world_scenario_generation_step_1_title: 'Arbeitsplatzszenarien erstellen',
    world_scenario_generation_step_1_content_prefix: 'Wählen Sie ',
    world_scenario_generation_step_1_content_bold: 'Reales Weltszenario',
    world_scenario_generation_step_1_content_suffix: ' um authentische, branchenspezifische Situationen zu generieren. Die KI von Sharelook entwirft Szenarien, die tatsächliche Arbeitsplatzherausforderungen und Entscheidungskontexte widerspiegeln.',
    world_scenario_generation_step_2_title: 'Kontextuelle Inhalte auswählen',
    world_scenario_generation_step_2_content: 'Wählen Sie die Seiten aus, die die anzuwendenden Fähigkeiten oder Konzepte enthalten. Die KI entwirft realistische Szenarien, die die praktische Anwendung in professionellen Umgebungen demonstrieren.',
    world_scenario_generation_step_3_title: 'Reales Weltszenario generieren',
    world_scenario_generation_step_3_content_prefix: 'Klicken Sie auf ',
    world_scenario_generation_step_3_content_bold: 'Szenario generieren',
    world_scenario_generation_step_3_content_suffix: ' um Ihr Arbeitsplatzszenario aufzubauen. Sharelook erstellt ein authentisches, branchenrelevantes Erlebnis, das Lernende auf echte Herausforderungen vorbereitet.',

    // Match Image Tour
    match_image_generation_name: 'Bild abgleichen Konsistenz',
    match_image_generation_desc: 'Erhalten Sie visuelle Harmonie auf Ihren Kursseiten, indem Sie Stile und Charaktere abgleichen.',
    match_image_generation_step_0_title: 'Zugriff auf Inhaltsgenerierungstools',
    match_image_generation_step_0_content: "Klicken Sie hier, um das Menü zur Inhaltsgenerierung zu erweitern und die KI-gestützten Autorentools von Sharelook freizuschalten.",
    match_image_generation_step_1_title: 'Bild abgleichen Konsistenz',
    match_image_generation_step_1_content_prefix: 'Wählen Sie ',
    match_image_generation_step_1_content_bold: 'Bild abgleichen',
    match_image_generation_step_1_content_suffix: " um Bilder zu generieren, die einen konsistenten Stil und Charakter über Ihren Kurs hinweg beibehalten.",
    match_image_generation_step_2_title: 'Referenzseiten auswählen',
    match_image_generation_step_2_content: 'Wählen Sie Seiten aus, deren Bildstil Sie abgleichen möchten.',
    match_image_generation_step_3_title: 'Passende Bilder generieren',
    match_image_generation_step_3_content_prefix: 'Klicken Sie auf ',
    match_image_generation_step_3_content_bold: 'Bild abgleichen',
    match_image_generation_step_3_content_suffix: ' um Bilder zu generieren, die perfekt mit Ihren ausgewählten Referenzen harmonieren.',
    match_image_generation_step_4_title: 'Generierung konfigurieren',
    match_image_generation_step_4_content: 'Passen Sie Einstellungen und Referenz Bilder in diesem Modal an, um das Endergebnis fein abzustimmen.',
    match_image_generation_step_5_title: 'Generierung starten',
    match_image_generation_step_5_content_prefix: 'Klicken Sie auf ',
    match_image_generation_step_5_content_bold: 'Für ausgewählte Seiten generieren',
    match_image_generation_step_5_content_suffix: ' um Ihre konsistenten Bilder zu erstellen.'
  },
  matchimage: {
    title: "Bild abgleichen",
    consistency_subtitle: "Wahre visuelle Harmonie über alle Kursseiten hinweg",
    consistency: "Bildkonsistenz abgleichen",
    visual_style: "Visueller Stil",
    select_style: "Visuellen Stil auswählen...",
    reference_images: "Referenzbilder",
    reference_images_tip: "Diese Bilder dienen der KI als visuelle Orientierung und stellen sicher, dass Charaktere, Farben und Stile über mehrere Seiten hinweg konsistent bleiben.",
    add: "Hinzufügen",
    max_9_reference_images: "Das System verwendet die relevantesten Bilder aus deinen ausgewählten Seiten als Kontext, um den visuellen Fokus und die Generierungsgeschwindigkeit zu erhalten.",
    generation_progress: "Generierungsfortschritt",
    no_images_generated_yet: "Noch keine Bilder generiert",
    click_generate_to_start: "Klicke auf „Generieren“, um den mehrseitigen Prozess zu starten.",
    page: "Seite",
    completed: "Abgeschlossen",
    failed: "Fehlgeschlagen",
    generating: "Wird generiert...",
    generate_selected_pages: "Für ausgewählte Seiten generieren",
    apply_to_all_pages: "Auf alle Seiten anwenden",
    applied: "Angewendet",
    cancel: "Abbrechen",
    apply_success: "Bilder erfolgreich angewendet!",
    select_at_least_one_page: "Bitte wähle mindestens eine Seite zur Generierung aus.",
    fetching_references: "Referenzen werden abgerufen...",
    fetching: "Wird geladen...",
    no_references_found: "Keine Referenzen gefunden",
    loading_references: "Referenzbilder werden geladen...",
    apply_confirmation_content: "Dies ersetzt vorhandene Bilder auf den ausgewählten Seiten und fügt neue hinzu, wo keine existieren. Möchtest du fortfahren?",
    uploaded: "Hochgeladen",
    style_photorealistic_label: "Fotorealistisch",
    style_photorealistic_prompt: "Ultra-fotorealistisches Bild, DSLR-Qualität, natürliche Beleuchtung, scharfer Fokus, realistische Texturen, professionelle Fotografie.",
    style_product_label: "Kommerzielle Produktaufnahme",
    style_product_prompt: "Hochwertige kommerzielle Produktfotografie, Studiobeleuchtung, sauberer Hintergrund, scharfe Details, Premium-Werbestil.",
    style_lifestyle_label: "Lifestyle-Fotografie",
    style_lifestyle_prompt: "Natürliche Lifestyle-Fotografie, spontane Komposition, weiches Tageslicht, echte Menschen, authentischer moderner Werbestil.",
    style_corporate_portrait_label: "Business-Porträt",
    style_corporate_portrait_prompt: "Professionelles Business-Porträt, neutraler Hintergrund, weiche Studiobeleuchtung, scharfe Gesichtsdetails, Business-Headshot-Stil.",
    style_3d_modern_label: "Moderne 3D-Illustration",
    style_3d_modern_prompt: "Moderne 3D-Illustration, glatte Geometrie, weiche globale Beleuchtung, realistische Materialien, sauberes professionelles Erscheinungsbild.",
    style_3d_isometric_label: "3D-isometrische Szene",
    style_3d_isometric_prompt: "3D-isometrische Szene, klare Geometrie, ausgewogene Beleuchtung, weiche Schatten, moderner Corporate-Illustrationsstil.",
    style_flat_corporate_label: "Flache Corporate-Illustration",
    style_flat_corporate_prompt: "Saubere flache Illustration, Corporate-Branding-Stil, minimale Formen, ausgewogene professionelle Farbpalette.",
    style_ui_brand_label: "Minimales UI-/Brand-Visual",
    style_ui_brand_prompt: "Minimales UI-Visual, weißer oder heller Hintergrund, einfaches Layout, modernes Tech-Branding, präzise und sauber.",
    style_editorial_label: "Redaktionelle Fotografie",
    style_editorial_prompt: "Redaktioneller Fotostil, natürliches Licht, realistische Umgebung, dokumentarisches Gefühl, hochauflösende Details.",
    style_technical_diagram_label: "Technisches Diagramm",
    style_technical_diagram_prompt: "Sauberes technisches Diagramm, präzise Linien, flache Farben, professioneller Infografik-Stil, leicht verständliches Layout.",
    style_abstract_corporate_label: "Abstrakter Corporate-Hintergrund",
    style_abstract_corporate_prompt: "Abstrakter Corporate-Hintergrund, weiche Farbverläufe, subtile geometrische Formen, modernes professionelles Branding.",
    style_saas_marketing_label: "SaaS-Marketing-Visual",
    style_saas_marketing_prompt: "Modernes SaaS-Marketing-Visual, saubere Komposition, helle professionelle Farben, technologieorientiert und hochwertig.",
    generating_image: "Bild wird generiert...",
    ready: "Bereit",
    generating_page: "Generierung für Seite"
  },
  infographic: {
    title: 'Infografik erstellen',
    custom_prompt: 'Benutzerdefinierte Anweisungen (optional)',
    prompt_placeholder:
      'z. B.: Verwende blaue Farben, Diagramme einfügen, Fokus auf Statistiken...',
    generating: 'Infografik wird erstellt...',
    generated: 'Infografik erfolgreich erstellt!',
    generation_failed: 'Erstellung der Infografik fehlgeschlagen',
    no_content: 'Kein Inhalt verfügbar, um eine Infografik zu erstellen',
    no_image: 'Keine Infografik zum Anwenden',
    empty_state: 'Klicken Sie auf „Erstellen“, um Ihre Infografik zu erstellen',
    generate: 'Infografik erstellen',
    regenerate: 'Erneut erstellen',
    apply_question: 'Wie möchten Sie diese Infografik verwenden?',
    replace_option: 'Vorhandenes Bild ersetzen',
    add_option: 'Als neues Bild hinzufügen',
    replace_success: 'Infografik erfolgreich ersetzt!',
    add_success: 'Infografik erfolgreich hinzugefügt!',
    page_content: 'Seiteninhalt',
    generated_infographic: 'Erstellte Infografik',
    title_label: 'Titel',
    text_label: 'Textinhalt',
    aspect_ratio: 'Seitenverhältnis',
    replace_the_existing_image_on_the_page:
      'Ersetzen Sie das vorhandene Bild auf der Seite durch diese Infografik',
    add_this_infographic:
      'Diese Infografik als neues Element auf der Seite hinzufügen',
    square: '1:1 (Quadrat)',
    portrait: '2:3 (Hochformat)',
    landscape: '3:2 (Querformat)',
    three_four_Portrait: '3:4 (Hochformat)',
    four_three_landscape: '4:3 (Querformat)',
    four_five_portrait: '4:5 (Hochformat)',
    four_five_landscape: '5:4 (Querformat)',
    mobile_portrait: '9:16 (Hochformat Mobil)',
    widescreen: '16:9 (Breitbild)',
    ultrawide: '21:9 (Ultrabreitbild)'
  },

  helplist: {
    // MISC
    main_categories: 'Hauptkategorien',
    my_workshop: 'Mein Workshop',
    basic_course_controls: 'Grundlegende Kurssteuerung',
    scorm_courses: 'SCORM-Kurse',
    user_management: 'Benutzerverwaltung',
    virtual_coach_title: 'Virtueller Coach',
    sharelook_trivia: 'Sharelook-Quiz',
    leaderboard_title: 'Sharelook Bestenliste',
    live_events: 'Live-Events',
    podcasts_music_story: 'Podcasts, Musik und Geschichten',
    whats_new: 'Was ist neu',
    whats_new_sharelook: 'Was ist neu bei ShareLook',
    whats_new_desc:
      'Wussten Sie, dass die Erstellung eines lernstil-orientierten Lernerlebnisses in kurzer Zeit und kostengünstig möglich ist? Sie sollten den ShareLook Kurs-Ersteller mit Ihren jeweiligen Talenten kombinieren. Fragen Sie uns wie.',
    no_video_found: 'Keine passenden Videos gefunden',
    uploaded_on: 'Hochgeladen am',
    no_video_available: 'Derzeit sind keine neuen Videos verfügbar.',
    no_videos_available: 'Keine Videos verfügbar',
    user_view: 'Benutzeransicht',
    admin_view: 'Admin-Ansicht',

    welcome: 'Willkommen im ShareLook Hilfezentrum',
    video_filter:
      'Wählen Sie ein Video aus der linken Navigation aus, um zu beginnen, oder verwenden Sie die Suche, um spezifische Inhalte zu finden.',

    // HELP CENTER
    sharelook: 'Was ist Sharelook',
    sharelook_desc: 'Einführung in Sharelook und seine Funktionen',

    course_summary: 'Kurserstellung Zusammenfassung',
    course_summary_desc:
      'Überblick und Zusammenfassung des Kurserstellungsprozesses',

    ai_course_creation: 'Vollständiger Prozess – KI-Kurserstellung',
    ai_course_creation_desc: 'Lerne, wie du mit KI einen Kurs erstellst.',

    scenario_based_assessment:
      'Vollständiger Prozess – Erstellung einer szenariobasierten Bewertung (Metamaze)',
    scenario_based_assessment_desc:
      'Lerne, wie du eine szenariobasierte Bewertung mit KI erstellst.',

    skill_leaderboard_creation:
      'Vollständiger Prozess – Erstellung einer Skill Journey und Bestenliste',
    skill_leaderboard_creation_desc:
      'Lerne, wie du eine Skill Journey und eine Bestenliste mit KI erstellst.',

    skill_journey: 'Was ist eine Skill Journey',
    skill_journey_desc:
      'Verstehen Sie, was eine Skill Journey ist und wie sie Lernenden hilft',

    metamaze: 'Was ist ein Metamaze',
    metamaze_desc:
      'Einführung in Metamaze und seine Rolle beim szenariobasierten Lernen',

    share_shorts: 'Sharelook Share Shorts',
    share_shorts_desc:
      'Überblick über Share Shorts und wie man sie effektiv nutzt',

    // TRAINING
    view_channel: 'Video-Kanal ansehen',
    view_channel_desc:
      'Lernen Sie, wie Sie Inhalte in einem Video-Kanal ansehen und erkunden können',

    take_course: 'Wie nimmt man an einem Kurs teil - Lernender',
    take_course_desc:
      'Verstehen Sie, wie Lernende einen Kurs belegen und navigieren können',

    take_metamaze: 'Wie nimmt man an einem Metamaze teil',
    take_metamaze_desc:
      'Lernen Sie, wie Lernende an einem Metamaze szenariobasierten Lernmodul teilnehmen können',

    take_skill_journey: 'Wie nimmt man an einer Skill Journey teil',
    take_skill_journey_desc:
      'Lernen Sie, wie Sie als Lernender eine Skill Journey starten und abschließen können',

    listen_podcast: 'Wie man einen Podcast anhört',
    listen_podcast_desc:
      'Lernen Sie, wie Sie Podcast-Inhalte anhören und navigieren können',

    // COURSES
    create_course:
      'Hinzufügen eines Zertifikats, Abzeichens und Kurscovers zu einem Kurs',
    create_course_desc:
      'Erstellen Sie einen Kurs und passen Sie ihn mit Abzeichen, Zertifikaten und Titelbildern an',

    create_course_simulation:
      'Simulation (Sandbox-Umgebung) innerhalb des Kurses',
    create_course_simulation_desc:
      'Schritt-für-Schritt-Anleitung zur Erstellung von Simulationen innerhalb eines Kurses.',

    create_interactive_lesson: 'Interaktive Lektion',
    create_interactive_lesson_desc:
      'Schritt-für-Schritt-Anleitung zur Erstellung interaktiver Lektionen innerhalb eines Kurses.',

    interactive_lesson_learner:
      'Wie nimmt man an einer interaktiven Lektion teil',
    interactive_lesson_learner_desc:
      'Erleben Sie interaktive Lektionen aus der Perspektive der Lernenden',

    interactive_lesson_admin: 'Interaktive Lektion - Admin-Ansicht',
    interactive_lesson_admin_desc:
      'Schritt-für-Schritt-Anleitung zum Erstellen und Verwalten interaktiver Lektionen',

    create_lesson: 'Wie man eine Lektion erstellt',
    create_lesson_desc:
      'Schritt-für-Schritt-Anleitung zum Erstellen von Lektionen innerhalb eines Kurses',

    create_course_complete_tutorial: 'Erstelle ein vollständiges Kurs-Tutorial',
    create_course_complete_tutorial_desc:
      'Ein umfassender Leitfaden, wie man mit KI auf Sharelook einen Lehrplan erstellt und einen Kurs entwickelt.',

    // COURSES AI
    ai_curriculum: 'KI-Lehrplan-Generierung',
    ai_curriculum_desc:
      'Lernen Sie, wie Sie KI verwenden, um automatisch Kurslehrpläne zu generieren',

    // COURSES BUILDER
    intro_gen: 'Einführungs-Generierung',
    intro_gen_desc: 'Generieren Sie überzeugende Kurseinführungen mit KI',

    intro_generation: 'Generierung einer Kurseinführung',
    intro_generation_desc:
      'Generieren Sie überzeugende Kurseinführungen mit KI',

    story_gen: 'KI-Geschichten & echte Geschichten-Generierung',
    story_gen_desc:
      'Erstellen Sie ansprechende Geschichten und reale Szenarien mit KI',

    ai_story_generation: 'KI-Geschichten & echte Geschichten-Generierung',
    ai_story_generation_desc:
      'Erstellen Sie ansprechende Geschichten und reale Szenarien mit KI',

    scenario_gen: 'Szenario-Generierung',
    scenario_gen_desc:
      'Erstellen Sie interaktive Szenarien für immersives Lernen',

    scenario_generation: 'Szenario-Generierung',
    scenario_generation_desc:
      'Erstellen Sie interaktive Szenarien für immersives Lernen',

    quiz_ai: 'KI-Quiz-Generierung',
    quiz_ai_desc: 'Erstellen Sie automatisch Quizze mit KI-Technologie',

    ai_quiz_generation: 'KI-Quiz-Generierung',
    ai_quiz_generation_desc:
      'Erstellen Sie automatisch Quizze mit KI-Technologie',

    bullet_gen: 'Aufzählungspunkte-Generierung',
    bullet_gen_desc:
      'Erstellen Sie strukturierte Aufzählungspunkte für Ihre Lektionen',

    bullet_points: 'Aufzählungspunkte-Generierung',
    bullet_points_desc:
      'Erstellen Sie strukturierte Aufzählungspunkte für Ihre Lektionen',

    summary_gen: 'Zusammenfassungs-Generierung',
    summary_gen_desc:
      'Generieren Sie automatisch Lektionszusammenfassungen mit KI',

    summary_generation: 'Zusammenfassungs-Generierung',
    summary_generation_desc:
      'Generieren Sie automatisch Lektionszusammenfassungen mit KI',

    add_content: 'Inhalt zur Lektion hinzufügen',
    add_content_desc:
      'Fügen Sie verschiedene Arten von Inhalten hinzu, um Ihre Lektionen zu bereichern',

    add_lesson_content: 'Inhalt zur Lektion hinzufügen',
    add_lesson_content_desc:
      'Fügen Sie verschiedene Arten von Inhalten hinzu, um Ihre Lektionen zu bereichern',

    layout_change: 'Lektions-Layout ändern',
    layout_change_desc: 'Passen Sie das Layout Ihrer Lektionsseiten an',

    change_lesson_layout: 'Lektions-Layout ändern',
    change_lesson_layout_desc: 'Passen Sie das Layout Ihrer Lektionsseiten an',

    voiceover_gen: 'Voiceover-Generierung',
    voiceover_gen_desc:
      'Fügen Sie professionelle Voiceovers zu Ihrem Kursinhalt hinzu',

    voiceover_generation: 'Voiceover-Generierung',
    voiceover_generation_desc:
      'Fügen Sie professionelle Voiceovers zu Ihrem Kursinhalt hinzu',

    manual_quiz: 'Manuelle Quiz-Erstellung',
    manual_quiz_desc:
      'Lernen Sie, wie Sie Quizze manuell erstellen und anpassen können',

    manual_quiz_creation: 'Manuelle Quiz-Erstellung',
    manual_quiz_creation_desc:
      'Lernen Sie, wie Sie Quizze manuell erstellen und anpassen können',

    ai_image_gen: 'KI-Bild-Generierung',
    ai_image_gen_desc:
      'Generieren Sie benutzerdefinierte Bilder für Ihren Kurs mit KI',

    ai_image_generation: 'KI-Bild-Generierung',
    ai_image_generation_desc:
      'Generieren Sie benutzerdefinierte Bilder für Ihren Kurs mit KI',

    simulation: 'Simulation erstellen',
    simulation_desc:
      'Erstellen Sie interaktive Simulationen in einer Sandbox-Umgebung',

    simulation_creation: 'Simulation in der Sandbox erstellen',
    simulation_creation_desc:
      'Schritt-für-Schritt-Anleitung zum Aufbau von Simulationen in der Sandbox-Umgebung',

    course_learner_view: 'Kurs-Lernenden-Ansicht',
    course_learner_view_desc:
      'Verstehen Sie die Perspektive und das Erlebnis der Lernenden in Kursen',

    simulation_learner_view: 'Wie nimmt man an einer Simulation teil',
    simulation_learner_view_desc:
      'Erlebe Simulationen aus der Perspektive der Lernenden in der Sandbox-Umgebung.',

    infographic_title: 'Infografiken zu einer Unterrichtsseite hinzufügen',
    infographic_desc:
      'Lerne, interaktive Infografiken für deine Lektionen zu erstellen.',

    // MAZE
    ai_metamaze: 'KI-Metamaze-Erstellung',
    ai_metamaze_desc:
      'Lernen Sie, wie Sie interaktive Metamaze-Erlebnisse mit KI erstellen können',

    ai_metamaze_creation: 'KI-Metamaze-Erstellung',
    ai_metamaze_creation_desc:
      'Lernen Sie, wie Sie interaktive Metamaze-Erlebnisse mit KI erstellen können',

    // LIBRARY
    media_library: 'Media Library',
    media_library_desc:
      'Überblick über die Medienbibliothek und ihre Verwendung',

    file_management: 'File Management',
    file_management_desc:
      'Lernen Sie, wie Sie Ihre Dateien effizient verwalten können',

    upload_files: 'Uploading Files & Adding to AI Repository',
    upload_files_desc:
      'Wie Sie Dateien in das KI-Repository hochladen und integrieren können',

    file_upload_repository:
      'Uploading Files & Adding Files to the AI Repository',
    file_upload_repository_desc:
      'Lerne, wie man Dateien hochlädt und sie dem KI-Repository hinzufügt.',

    document_creation: 'Document Creation (Word, Calc, Impress)',
    document_creation_desc:
      'Lernen Sie, Dokumente in Word-, Calc- und Impress-Formaten zu erstellen',

    file_organization: 'File Organization in Folders',
    file_organization_desc: 'Organisieren Sie Dateien effektiv in Ordnern',

    document_creation_screen: 'Document Creation Using Screen Capture',
    document_creation_screen_desc:
      'Erstellen Sie Dokumente mit der Bildschirmaufnahme-Funktion',

    course_creation_screen: 'Course Creation Using Screen Capture',
    course_creation_screen_desc:
      'Erstellen Sie Kurse mit der Bildschirmaufnahme-Funktion',

    downloads_center: 'Downloads Center',
    downloads_center_desc:
      'Zugriff auf und Verwaltung von heruntergeladenen Inhalten aus dem Download-Center',

    // REPORTS
    reports_analytics: 'Reports and Analytics Overview',
    reports_analytics_desc:
      'Umfassender Leitfaden zu Berichten und Analysen in Sharelook',

    reports_detailed: 'Reports and Analytics Detailed',
    reports_detailed_desc:
      'Detaillierte Übersicht über alle Berichtsfunktionen und Analysefähigkeiten',

    workshop_report: 'Workshop-Bericht',
    workshop_report_desc:
      'Anzeigen und Analysieren von Workshop-Leistungsberichten',

    user_report: 'Benutzer-Bericht',
    user_report_desc:
      'Zugriff auf umfassende Benutzeraktivitäts- und Leistungsberichte',

    course_report: 'Kurs-Bericht',
    course_report_desc:
      'Anzeigen detaillierter Berichte über Kursabschluss und Engagement',

    live_events_report: 'Live-Events-Bericht',
    live_events_report_desc:
      'Analysieren Sie Teilnahme- und Engagement-Metriken für Live-Events',

    metamaze_reports: 'Metamaze-Berichte',
    metamaze_reports_desc:
      'Anzeigen von Leistungs- und Abschlussberichten für Metamaze-Module',

    live_assessments_reports: 'Live-Bewertungsberichte',
    live_assessments_reports_desc:
      'Zugriff auf Berichte über Live-Bewertungsleistung und Ergebnisse',

    skill_journey_reports: 'Skill Journey-Berichte',
    skill_journey_reports_desc:
      'Verfolgen Sie Fortschritts- und Abschlussberichte für Skill Journeys',

    sharesphere_report: 'Sharesphere-Bericht',
    sharesphere_report_desc:
      'Anzeigen von Engagement- und Aktivitätsberichten für ShareSphere-Inhalte',

    // SKILL JOURNEY
    create_skill_journey: 'Skill Journey erstellen',
    create_skill_journey_desc:
      'Lernen Sie, wie Sie Skill Journeys für Lernende erstellen und verwalten können',

    // PODCAST
    podcast_creation: 'Podcast-Erstellung',
    podcast_creation_desc:
      'Lernen Sie, wie Sie Podcast-Kanäle erstellen und verwalten können',

    podcast_listening_learner: 'Wie man einen Podcast anhört',
    podcast_listening_learner_desc:
      'Lernen Sie, wie Sie als Lernender Podcasts anhören und navigieren können',

    // CHANNEL
    video_channel_creation: 'Wie man den Videokanal nutzt',
    video_channel_creation_desc:
      'Erstellen und passen Sie Video-Kanäle für Ihre Inhalte an',

    // REEL
    short_video_creation: 'Share Shorts Video-Beiträge',
    short_video_creation_desc:
      'Lernen Sie, wie Sie ansprechende Kurzform-Videos erstellen können',

    short_video_admin: 'Short video/Shareshorts Admin View',
    short_video_admin_desc:
      'Verwalten und überprüfen Sie Kurzvideos aus der Admin-Perspektive',

    // TRIVIA
    create_trivia: 'How to Create a Trivia on Sharelook',
    create_trivia_desc:
      'Lernen Sie, wie Sie ansprechende Trivia-Spiele erstellen können',

    take_trivia: 'Wie nimmt man an einer Trivia teil',
    take_trivia_desc:
      'Lernen Sie, wie Sie als Lernender an Trivia-Spielen teilnehmen können',

    // MANAGEMENT
    add_users: 'How to add users to an organization',
    add_users_desc:
      'Fügen Sie Benutzer in Ihrer Organisation hinzu und verwalten Sie sie',

    add_group: 'How to create a group in your organization',
    add_group_desc: 'Erstellen und verwalten Sie Benutzergruppen',

    // SKILL JOURNEY
    create_skill_journey: 'Skill Journey Creation',
    create_skill_journey_desc:
      'Lernen Sie, wie Sie Skill Journeys für Lernende erstellen und verwalten können',

    // CHANNEL
    video_channel_creation: 'Video Channel Creation',
    video_channel_creation_desc:
      'Erstellen und passen Sie Video-Kanäle für Ihre Inhalte an',

    // MAZE
    ai_metamaze_creation: 'AI Metamaze Creation',
    ai_metamaze_creation_desc:
      'Lernen Sie, wie Sie interaktive Metamaze-Erlebnisse mit KI erstellen können',

    // COACHING
    virtual_coach: 'Virtual Coach Overview',
    virtual_coach_desc:
      'Lernen Sie, wie Sie die Funktion des virtuellen Coaches verwenden können',

    coaching_creation: 'Coaching-Sitzung-Erstellung',
    coaching_creation_desc: 'Erstellen und planen Sie Coaching-Sitzungen',

    coaching_session_creation: 'Coaching-Sitzung-Erstellung',
    coaching_session_creation_desc:
      'Erstellen und planen Sie Coaching-Sitzungen',

    coaching_booking: 'Coaching-Sitzungsslot buchen',
    coaching_booking_desc:
      'Wie Sie verfügbare Coaching-Sitzungsslots buchen können',

    booking_coaching_slot: 'Wie man einen Coaching-Sitzungsslot bucht',
    booking_coaching_slot_desc:
      'Wie Sie verfügbare Coaching-Sitzungsslots buchen können',

    // WORKSHOP
    my_workshop: 'Mein Workshop',
    my_workshop_desc:
      'Überblick über den Workshop-Bereich und seine Funktionen',

    add_scorm: 'How to Add a SCORM Course on Sharelook',
    add_scorm_desc:
      'Laden Sie einen SCORM-Kurs hoch, passen Sie ihn mit Abzeichen, Zertifikaten und Titelbildern an',

    edit_skill_journey: 'Skill Journey bearbeiten',
    edit_skill_journey_desc:
      'Lernen Sie, wie Sie eine bestehende Skill Journey bearbeiten können',

    edit_live_event: 'Live-Event bearbeiten',
    edit_live_event_desc: 'Bearbeiten und verwalten Sie Live-Events effektiv',

    clone_course: 'Kurs klonen',
    clone_course_desc:
      'Klonen Sie einen bestehenden Kurs zur Wiederverwendung oder Änderung',

    clone_metamaze: 'Metamaze klonen',
    clone_metamaze_desc:
      'Lernen Sie, wie Sie ein Metamaze für neue Lernende oder Updates duplizieren können',

    delete_skill_journey: 'Skill Journey löschen',
    delete_skill_journey_desc:
      'Schritt-für-Schritt-Prozess zum Löschen einer Skill Journey',

    delete_live_event: 'Live-Event löschen',
    delete_live_event_desc:
      'Löschen Sie unerwünschte Live-Events von der Plattform',

    edit_course: 'Kurs bearbeiten',
    edit_course_desc:
      'Bearbeiten Sie bestehende Kurse und aktualisieren Sie deren Inhalte',

    delete_metamaze: 'Metamaze löschen',
    delete_metamaze_desc:
      'Lernen Sie, wie Sie ein Metamaze-Modul sicher löschen können',

    delete_podcast: 'Podcast löschen',
    delete_podcast_desc: 'Entfernen Sie bestehende Podcasts aus Ihrem Kanal',

    delete_video_channel: 'Video-Kanal löschen',
    delete_video_channel_desc: 'Löschen Sie unerwünschte Video-Kanäle einfach',

    edit_video_channel: 'Video-Kanal bearbeiten',
    edit_video_channel_desc:
      'Lernen Sie, wie Sie Details Ihrer Video-Kanäle bearbeiten können',

    delete_course: 'Kurs löschen',
    delete_course_desc: 'Schritte zum dauerhaften Löschen eines Kurses',

    edit_metamaze: 'Metamaze bearbeiten',
    edit_metamaze_desc:
      'Lernen Sie, wie Sie Bearbeitungen an bestehenden Metamaze-Modulen vornehmen können',

    edit_podcast: 'Podcast bearbeiten',
    edit_podcast_desc:
      'Bearbeiten Sie Podcast-Episoden und Details mit Leichtigkeit',

    create_live_event: 'Wie man ein Live-Event erstellt',
    create_live_event_desc:
      'Schritt-für-Schritt-Anleitung zum Erstellen und Planen von Live-Events',

    translate_course: 'Wie man einen Kurs übersetzt',
    translate_course_desc:
      'Lernen Sie, wie Sie Kursinhalte in mehrere Sprachen übersetzen können',

    // LEADERBOARD
    create_competition: 'How to create a competition on the leaderboard',
    create_competition_desc:
      'Richten Sie Wettbewerbe und Bestenlisten ein, um Lernende zu engagieren',

    leaderboard_settings: 'Bestenlisten-Einstellungen',
    leaderboard_settings_desc:
      'Konfigurieren Sie Bestenlisten- und Wettbewerbseinstellungen',

    leaderboard_learner_view: 'Navigation auf der Sharelook Bestenliste',
    leaderboard_learner_view_desc:
      'Anzeigen von Bestenlisten und Wettbewerben aus der Perspektive der Lernenden',

    // MARKETPLACE
    marketplace: 'An overview of The Sharelook Marketplace',
    marketplace_desc:
      'Überblick über den Marktplatz und wie man Inhalte kauft und verkauft',

    buy_course: 'Wie man einen Kurs kauft',
    buy_course_desc: 'Lernen Sie, wie Sie Kurse vom Marktplatz kaufen können',

    book_coaching: 'Wie man eine Coaching-Sitzung bucht',
    book_coaching_desc:
      'Schritt-für-Schritt-Anleitung zum Buchen von Coaching-Sitzungen vom Marktplatz',

    buy_podcast: 'Wie man einen Podcast kauft',
    buy_podcast_desc: 'Lernen Sie, wie Sie Podcast-Abonnements kaufen können',

    subscribe_channel: 'Wie man einen Video-Kanal kauft/abonniert',
    subscribe_channel_desc:
      'Abonnieren Sie Video-Kanäle und greifen Sie auf Premium-Inhalte zu'
  },
  v5: {
    not_attempted: "Nicht versucht",
    unsuccessfull: "Nicht erfolgreich",
    view_document: 'Dokument anzeigen',
    duplicate_folder_name: 'Ein Ordner mit diesem Namen existiert bereits.',
    my_video_shorts: 'MEINE VIDEO SHORTS',
    see_more: 'MEHR ANSEHEN',
    no_shorts_found: 'Keine Shorts gefunden',
    shorts: 'Shorts',
    general_information: 'Allgemeine Informationen',
    gamification: 'Gamification',
    click_to_select_files: 'Klicken, um Dateien auszuwählen',
    selected_files: 'Ausgewählte Dateien',
    uploaded: 'Hochgeladen',
    failed: 'Fehlgeschlagen',
    system_will_automatically_analyze_and_select_the_most_relevant:
      'Das System analysiert automatisch und wählt die relevantesten Dokumente aus der Bibliothek Ihrer Organisation basierend auf den Inhaltsanforderungen aus.',
    select_from_library: ' Aus der Bibliothek auswählen',
    search_document: 'Dokumente durchsuchen...',
    selected: 'Ausgewählt',
    loading_documents: 'Dokumente werden geladen...',
    review_generated_content: 'Generierten Inhalt überprüfen',
    confirm_and_replace_content: 'Inhalt bestätigen und ersetzen',
    the_generate_content_will_replace:
      'Der generierte Inhalt ersetzt den vorhandenen Text auf den ausgewählten Seiten. Wenn Sie diese Änderungen nicht anwenden möchten, können Sie zum vorherigen Schritt zurückkehren.',
    pages_to_be_updated: 'Zu aktualisierende Seiten',
    generated_revisions: 'Generierte Überarbeitungen',
    lesson_preview: 'Lektionen-Vorschau',
    create_new_folder: 'Neuen Ordner erstellen',
    interactive_simulation: 'Interaktive Lektion',
    rename_item: 'Element umbenennen',
    enter_folder_name: 'Ordnernamen eingeben:',
    enter_new_name: 'Neuen Namen eingeben:',
    folder_name: 'Ordnername:',
    new_name: 'Neuer Name',
    move_items: 'Elemente verschieben',
    copy_items: 'Elemente kopieren',
    move_here: 'Hierher verschieben',
    copy_here: 'Hierher kopieren',
    select_destination_library_and_folder:
      'Zielbibliothek und Ordner auswählen:',
    items_selected: 'Elemente ausgewählt',
    version: 'Version',
    modified_by: 'Geändert von',
    size: 'Größe',
    restore: 'Wiederherstellen',
    are_you_sure_you_want_to_restore_this_version:
      'Sind Sie sicher, dass Sie diese Version wiederherstellen möchten?',
    this_will_replce_the_current_version_with_the_selected_one:
      'Dies ersetzt die aktuelle Version durch die ausgewählte.',
    restore_this_version: 'Diese Version wiederherstellen',
    restore_not_available: 'Wiederherstellung nicht verfügbar',
    version_history: 'Versionsverlauf:',
    by_making_items_public:
      'Wenn Sie Elemente öffentlich machen, sind sie für alle sichtbar. Bitte lesen Sie die Allgemeinen Geschäftsbedingungen, bevor Sie fortfahren.',
    the_selected_items_will_be_copied:
      'Die ausgewählten Elemente werden in Ihre öffentliche Bibliothek kopiert und sind für alle sichtbar.',
    the_selected_items_will_be_copied_to_org:
      'Die ausgewählten Elemente werden in Ihre Organisationsbibliothek kopiert und sind für alle Organisationsmitglieder sichtbar.',
    the_selected_items_will_be_copied_to_your_private:
      'Die ausgewählten Elemente werden in Ihre private Bibliothek kopiert und sind nur für Sie sichtbar.',
    loading_organization: 'Organisationsbenutzer werden geladen...',
    click_download_to_view: 'Klicken Sie auf „Herunterladen“, um anzuzeigen',
    archive_file: 'Archivdatei',
    no_preview_available: 'Keine Vorschau verfügbar',
    audit_report: 'Prüfbericht',
    audit_type: 'Aktionstyp',
    i_agree_to_the_terms_and_conditions:
      'Ich stimme den Allgemeinen Geschäftsbedingungen zu.',
    this_file_is_indexed_for_ai: 'Diese Datei ist für KI indexiert.',
    file_is_not_indexed_for_ai: 'Datei ist nicht für KI indexiert.',
    no_users_found: 'Keine Benutzer gefunden',
    no_users_available: 'Keine Benutzer verfügbar',
    add_people: 'Personen hinzufügen',
    people: 'Personen',
    access_type: 'Zugriffsart',
    no_group_found: 'Keine Gruppen gefunden',
    add_group: 'Gruppen hinzufügen',
    groups: 'Gruppen',
    users_top: 'Benutzer',
    confirm_delete: 'Löschen bestätigen',
    do_you_want_remove: 'Möchten Sie wirklich entfernen',
    form_this_documents_permissions: 'aus den Berechtigungen dieses Dokuments?',
    no_users_found_in_this_group: 'Keine Benutzer in dieser Gruppe gefunden',
    add_selected_users: 'Ausgewählte Benutzer hinzufügen',
    choose_users_from_the_list: 'Benutzer aus der Liste auswählen',
    selected_users: 'Ausgewählte Benutzer',
    archived: 'Archiviert',
    request_approval: 'Genehmigung anfordern',
    document_in_review: 'Dokument wird überprüft',
    approve: 'Genehmigen',
    reject: 'Ablehnen',
    comment: 'Kommentar:',
    enter_your_commit: 'Geben Sie Ihren Kommentar ein...',
    confirm_cancel: 'Abbrechen bestätigen',
    upload_3d_zip: '3D-Zip hochladen',
    delete_items: 'Elemente löschen',
    video_upload_request: 'Video-Upload-Anfrage',
    reject_video: 'Video ablehnen',
    enter_rejection_reason: 'Geben Sie den Ablehnungsgrund ein...',
    please_provide_a_reason_for_reejection_this_video:
      'Bitte geben Sie einen Grund für die Ablehnung dieses Videos an:',
    generate_trivia_with_ai: 'Trivia mit KI generieren',
    select_category: 'Kategorie auswählen:',
    number_of_question: 'Anzahl der Fragen',
    generated_questions: 'Generierte Fragen',
    this_will_clear_all_generate_question:
      'Dies löscht alle generierten Fragen. Fortfahren?',
    sure_delete: 'Sind Sie sicher, dass Sie löschen möchten?',
    delete_this_question:
      'Sind Sie sicher, dass Sie diese Frage löschen möchten?',
    loading_quiz: 'Quiz wird geladen...',
    creteing_file: 'Datei wird erstellt',
    opening_desktop_app: 'Desktop-App wird geöffnet',
    this_folder_is_empty: 'Dieser Ordner ist leer',
    select_a_competition: 'Wettbewerb auswählen...',
    activity_badges: 'Aktivitätsabzeichen',
    awarded_every_badges:
      'Verliehen alle 4, 8, 16, 32, 64, 128, 256, 512 Logins',
    learning_badges: 'Lernabzeichen',
    awarded_every_courses:
      'Verliehen alle 1, 4, 8, 16, 32, 64, 128 abgeschlossene Kurse',
    test_badges: 'Testabzeichen',
    awarded_every_passes_tests:
      'Verliehen alle 2, 4, 8, 16, 32, 64, 128, 256 bestandene Tests',
    assignment_badges: 'Aufgabenabzeichen',
    awarded_every_passed_assignments:
      'Verliehen alle 1, 2, 4, 8, 16, 32, 64, 128 bestandene Aufgaben',
    perfectionism_badges: 'Perfektionismus-Abzeichen',
    awarded_every_assignments_with_scrore:
      'Verliehen alle 1, 2, 4, 8, 16, 32, 64, 128 Tests oder Aufgaben mit 90%+ Punktzahl',
    communication_badges: 'Kommunikationsabzeichen',
    awarded_every_topics_or_comments:
      'Verliehen alle 2, 4, 8, 16, 32, 64, 128, 256 Themen oder Kommentare',
    certification_badges: 'Zertifizierungsabzeichen',
    awarded_every_certificates:
      'Verliehen alle 1, 2, 4, 8, 16, 32, 64, 128 Zertifikate',
    level_name: 'Levelname',
    delete_competition: 'Wettbewerb löschen',
    this_week: 'Diese Woche',
    this_year: 'Dieses Jahr',
    folder: 'Ordner',
    item: 'Element',
    delete_confirmation: 'Möchten Sie wirklich löschen',
    make_organization: 'Machen Sie Organisation',
    no_results_found: 'Keine Ergebnisse gefunden für',
    no_items_available: 'Keine Elemente verfügbar',
    help_video: 'Hilfsvideos',
    select_a_video_from_the_list:
      'Wählen Sie ein Video aus der Liste, um zu lernen',
    relevant_videos_label: 'Einzelne Videos',
    pinned_bundle_label: 'Vollständiges Tutorial',
    recording: 'Aufnahme',
    on: 'Ein',
    off: 'Aus',
    started_on: 'Gestartet am',
    created_on: 'Erstellt am',
    this: 'Dieses',
    list_arrangement_will_be_primary_order:
      'Die Listenanordnung ist die primäre Reihenfolge für die auf der Trainingsseite sichtbare Liste.',
    sequence_order: 'Reihenfolge',
    sequence_not_set: 'Reihenfolge nicht festgelegt',
    order_sequence_set_successfully: 'Reihenfolge erfolgreich festgelegt',
    search_for_stock_images: 'Nach Stockbildern suchen...',
    search_for_a_location: 'Nach einem Ort suchen...',
    loading_suggestions: 'Vorschläge werden geladen...',
    suggested_locations: 'Vorgeschlagene Orte:',
    available: 'verfügbar',
    no_podcast_is_available: 'Kein Podcast verfügbar!',
    no_mazes_available: 'Keine Labyrinthe verfügbar!',
    grid_view: 'Rasteransicht',
    list_view: 'Listenansicht',
    create_a_subtle_and_non_distracting_background_image:
      'Erstellen Sie ein dezentes und unaufdringliches Hintergrundbild für einen digitalen Kurs, inspiriert von',
    the_image_should_incorporate_elements_of: 'Das Bild sollte Elemente von',
    vary_abstract_faded_or_minimalist_way:
      'auf sehr abstrakte, verblasste oder minimalistische Weise enthalten. Verwenden Sie extrem weiche Farben, sanfte Verläufe oder kaum sichtbare Muster, die auf das Thema hinweisen, ohne zu wörtlich oder dominant zu sein. Der Gesamteffekt sollte leicht und luftig sein, damit überlagerter Text und Inhalte leicht lesbar sind. Das Design muss für ein 16:9-Format geeignet sein und verschiedene UI-Elemente berücksichtigen. Stellen Sie sicher, dass die Elemente gleichmäßig über das Bild verteilt sind, um einen ausgewogenen, nicht ablenkenden Hintergrund zu schaffen.',
    top_left: 'Oben links',
    top_right: 'Oben rechts',
    bottom_left: 'Unten links',
    bottom_right: 'Unten rechts',
    select_position_of_image_you_like:
      'Wähle die Position des Bildes, das dir gefällt',
    select_a_position_of_image:
      'Wähle eine Position des Bildes, um Variationen zu erstellen',
    generate_variations: 'Variationen erstellen',
    select_a_position_of_image_upscale:
      'Wähle eine Position des Bildes, um es hochzuskalieren',
    upscale_image_for_selection: 'Bild für Auswahl hochskalieren',
    generation_variations: 'Variationen werden erstellt...',
    generating_your_image: 'Dein Bild wird erstellt...',
    waiting_start_generation: 'Warte auf Beginn der Erstellung',
    variations: 'Variationen',
    upscaling_image: 'Bild wird hochskaliert...',
    upscaled_image: 'Hochskaliertes Bild',
    ai_generate_image: 'KI-generiertes Bild',
    select: 'Auswählen',
    generate_image_using_your_image: 'Bild basierend auf deiner Idee erstellen',
    please_enter_your_idea: 'Bitte gib deine Bildidee ein...',
    your_prompt_here: 'Dein Prompt hier...',
    add_text_in_the_image: 'Text zum Bild hinzufügen',
    what_type_image_do_you_generate:
      'Welche Art von Bild möchtest du erstellen? Beschreibe bitte die Szene, Objekte oder spezifische Details, und ich erstelle es für dich.',
    are_you_sure_you_want_to_start_a_new_chat:
      'Möchtest du wirklich einen neuen Chat starten?',
    start_new_chat: 'Neuen Chat starten',
    stop_chat: 'Chat stoppen',
    start_chat: 'Chat starten',
    created_successfully: 'Erfolgreich erstellt',
    failed_to_create_folder: 'Ordner konnte nicht erstellt werden',
    please_enter_name: 'Bitte einen Namen eingeben',
    failed_to_rename_file_folder: 'Datei/Ordner konnte nicht umbenannt werden',
    opened_download_link_in_new_tab: 'Downloadlink in neuem Tab geöffnet',
    failed_to_get_download_link: 'Downloadlink konnte nicht abgerufen werden',
    prepare_download: 'Vorbereitung der Downloads...',
    failed_download_link: 'Downloadlink für ID konnte nicht abgerufen werden',
    open_first_download: 'Erster Downloadlink geöffnet. Prüfe die Konsole für',
    additional_link: 'weitere Links.',
    prepared: 'Vorbereitet',
    download_link: 'Downloadlinks',
    no_download_file: 'Keine herunterladbaren Dateien gefunden',
    download_failed: 'Download-Vorbereitung fehlgeschlagen',
    certificate_title_is_required: 'Zertifikattitel ist erforderlich.',
    are_you_sure_you_want_to_attach_this_certificate:
      'Möchtest du dieses Zertifikat wirklich an diesen Kurs anhängen? Es wird auch in deinem Zertifikatsverlauf verfügbar sein.',
    update_badge: 'Abzeichen aktualisieren',
    attach_audio: 'Audio anhängen',
    correct_answer_is_required: 'Eine richtige Antwort ist erforderlich.',
    or: 'ODER',
    insert_scenario: 'Szenario einfügen',
    as_screen_capture: 'als Screenshot',
    as_simulation: 'Mit Simulation',
    added_avatar: 'Avatar hinzugefügt',
    select_avatar: 'Avatar auswählen',
    add_audio: 'Audio hinzufügen',
    only_to_options: 'Nur 2 bis 4 Optionen',
    only_to_layers: 'Nur 2 bis 8 Ebenen',
    shop: 'SOP',
    video_channel: 'Video-Kanal',
    podcasts: 'Podcasts',
    organisations: 'Organisationen',
    org_groups: 'Organisationsgruppen',
    channel_outline_is_required: 'Kanalübersicht ist erforderlich',
    channel_obj_required: 'Kanalziele sind erforderlich.',
    enter_value: 'Bitte einen Wert eingeben.',
    no_basket_to_add: 'Keine Artikel zum Warenkorb hinzugefügt',
    find_your_video: 'Finde deine YouTube Benutzer- & Kanal-IDs',
    each_youtube_channel_has_unique:
      'Jeder YouTube-Kanal hat eine eindeutige Benutzer-ID und Kanal-ID. Diese IDs werden zur Referenzierung in bestimmten Apps und Diensten verwendet.',
    find_channel_id: 'So findest du die Benutzer- und Kanal-ID deines Kanals',
    your_channel_user_id:
      'Du findest die Benutzer- und Kanal-IDs deines Kanals in',
    advance_account: 'Erweiterte Kontoeinstellungen',
    computer_or_mobile_browser: 'am Computer oder mobilen Browser.',
    sign_in_to: 'Anmelden bei',
    click_profile_pic_left: 'Klicke oben rechts auf dein Profilbild',
    from_the_left_menu: 'Wähle aus dem linken Menü',
    adv_setting: 'Erweiterte Einstellungen',
    user_channel_id_there:
      'Dort siehst du die Benutzer- und Kanal-IDs deines Kanals.',
    you_can_also: 'Du kannst auch',
    manage_channel: 'deinen Kanalnamen verwalten',
    studio_youtube: 'im YouTube Studio.',
    sharesphere_question_updated: 'ShareSphere-Frage aktualisiert',
    select_category: 'Kategorie(n) auswählen',
    please_select_category: 'Bitte Kategorie(n) auswählen!',
    ShareSphere_question_created: 'ShareSphere-Frage erstellt',
    generate_text: 'Text generieren',
    ar_trigger_image: 'AR-Auslöserbild',
    name_of_the_guest: 'Name des Gastes Nr.',
    library: 'Bibliothek',
    previous: 'Zurück',
    draft: 'Entwurf',
    unpublishing: 'Entpublizieren',
    publishing: 'Veröffentlichen',
    unpublish_from_marketplace: 'Vom Marktplatz entfernen',
    unpublished: 'Nicht veröffentlicht',
    unpublish: 'Entveröffentlichen',
    publish: 'Veröffentlichen',
    quiz_complete: 'Quiz abgeschlossen',
    lesson_complete: 'Lektion abgeschlossen',
    get_certificate: 'Zertifikat erhalten',
    select_participants: 'Teilnehmer auswählen',
    competition_updated_successfully: 'Wettbewerb erfolgreich aktualisiert!',
    competition_created_successfully: 'Wettbewerb erfolgreich erstellt!',
    levels_configuration: 'Level-Konfiguration',
    account_subscribptions: 'Aktive Abonnements',
    search_organisation: 'Organisation suchen',

    generate_an_engaging_introduction_to_capture:
      'Erstellen Sie eine fesselnde Einleitung, um die Aufmerksamkeit Ihres Publikums zu gewinnen und den Ton für Ihre Lektion festzulegen.',
    create_a_comprehensive_summary:
      'Erstellen Sie eine umfassende Zusammenfassung, die wichtige Punkte verstärkt und Ihre Lektion effektiv abschließt.',
    introductio_added_at_the_beginning:
      'Einleitung am Anfang der Lektion hinzugefügt.',
    summary_added: 'Zusammenfassung am Ende der Lektion hinzugefügt.',
    you_cannot_add_other_element_in_a_scenario_page:
      'Sie können keine anderen Elemente auf einer Szenarioseite hinzufügen. Bitte versuchen Sie es auf anderen Seiten oder entfernen Sie zuerst das Szenario von der Seite.',
    pages_list_whose_content_you_want_to_reference:
      'Bitte klicken Sie auf die Seiten aus der Seitenliste, deren Inhalt Sie in der',
    choose_your_story: 'Wählen Sie Ihre Geschichte',
    generate_scenario: 'Hier ist Ihr generiertes Szenario!',
    will_help_you_create_scenario:
      'Hallo! Ich helfe Ihnen beim Erstellen eines Szenarios. Worauf möchten Sie sich konzentrieren?',
    sorry_encountered_an_error:
      'Entschuldigung, es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
    chat_based_scenario_generation: 'Chat-basierte Szenario-Generierung',
    start_conversation_to_generate:
      'Starten Sie eine Unterhaltung, um Ihr Szenario durch interaktiven Dialog zu generieren.',
    view_scenario: 'Szenario anzeigen',
    use_this_scenario: 'Dieses Szenario verwenden',
    prompt_helper: 'Eingabeaufforderung-Hilfe',
    hide_prompt_helper: 'Eingabeaufforderung-Hilfe ausblenden',
    please_upload_reference_image:
      'Bitte laden Sie mindestens ein Referenzbild für den Bildbearbeitungsmodus hoch',
    error_generating_image:
      'Fehler beim Generieren des Bildes. Bitte versuchen Sie es erneut!',
    max_reference_images_allowed:
      'Maximal 9 Referenzbilder erlaubt. Bitte entfernen Sie zuerst ein Bild.',
    failed_to_convert_image_url: 'Fehler beim Konvertieren der Bild-URL!',
    preparing_variations: 'Variationen werden vorbereitet...',
    preparing_image: 'Bild wird vorbereitet...',
    generated_image_alt: 'Generiertes Bild',
    processing_your_request: 'Ihre Anfrage wird verarbeitet...',
    generating_variations_in_progress: 'Variationen werden generiert',
    lightning_fast_generation_in_progress: 'Blitzschnelle Generierung läuft',
    file: 'Datei',
    is_too_large: 'ist zu groß',
    mb: 'MB',
    limit_is: 'Limit ist',
    please_enter_image_idea: 'Bitte geben Sie Ihre Bildidee ein...',
    your_prompt_here: 'Ihre Eingabeaufforderung hier...',
    what_type_image_generate:
      'Welche Art von Bild möchten Sie generieren? Bitte beschreiben Sie die Szene, Objekte oder spezifische Details, die Sie im Kopf haben, und ich werde mein Bestes tun, um es für Sie zu erstellen.',
    select_pixel_image_title: 'Pixel-Bild auswählen',
    stock_image: 'Stock-Bild',
    pagination_of: 'von',
    pagination_images: 'Bilder',
    reference_image_alt: 'Referenzbild',
    user_alt: 'Benutzer',
    story_description_tone: 'Gesamtstimmung oder Haltung der Geschichte.',
    story_description_narrative_hook:
      'Eine fesselnde Eröffnungszeile oder ein Absatz, der die Aufmerksamkeit des Lesers erregt und die Bühne für die Geschichte bereitet.',
    story_description_narrative_style:
      'Eine Perspektive, aus der die Geschichte erzählt wird.',
    story_description_story_plot:
      'Eine Handlung ist, wie eine Geschichte gezeigt wird, wie in einem Film oder Buch. Es ist die Reihenfolge, in der Ereignisse passieren. Manchmal werden sie nacheinander gezeigt, und manchmal sind sie durcheinander. Zum Beispiel beginnen einige Geschichten mit dem Ende und gehen dann zurück zum Anfang, um zu erklären.',
    story_description_complexity:
      'Schwierigkeitsgrad und Tiefe der Geschichte.',
    story_description_genre: 'Kategorie oder Art der Geschichte.',
    story_description_vocabulary: 'Auswahl und Verwendung von Wörtern.',
    story_description_narrative_structure:
      'Organisation der Geschichtsereignisse.',
    story_description_time_period: 'Ära, in der die Geschichte spielt.',
    story_description_story_length: 'Länge der Erzählung.',
    story_description_character_names:
      'Namen der Charaktere in der Geschichte.',
    story_description_output_type: 'Das Format der Geschichte.',
    story_chat_initial_message:
      'Hallo! Ich helfe Ihnen beim Erstellen einer Geschichte. Worauf möchten Sie sich konzentrieren?',
    story_add_to_pages_title:
      'Möchten Sie die Geschichte zu den Seiten hinzufügen?',
    story_add_to_pages_content:
      'Der ursprüngliche Inhalt wird durch den Geschichte-Text ersetzt.',
    story_chat_error_message:
      'Entschuldigung, es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
    story_generated_story_label: 'Generierte Geschichte',
    story_generating: 'Generiere...',
    story_use_story_title: 'Möchten Sie diese generierte Geschichte verwenden?',
    story_use_story_content:
      'Dies öffnet den Geschichten-Editor, in dem Sie weitere Bearbeitungen vornehmen können, bevor Sie sie zu Ihrer Lektion hinzufügen.',
    story_use_story_button: 'Geschichte verwenden',
    story_chat_placeholder: 'Geben Sie Ihre Nachricht ein...',
    story_chat_send: 'Senden',
    story_form_mode: 'Formularmodus',
    story_chat_mode: 'Chat-Modus',
    story_page_heading: 'Geschichte',
    bullet_points: 'Aufzählungspunkte',
    scenario_generation: 'Szenarioerstellung',
    please_enter_number_of_questions:
      'Bitte geben Sie die Anzahl der Fragen ein',
    please_enter_number_of_questions:
      'Bitte geben Sie eine Anzahl von Fragen zwischen 1 und 10 ein',
    maze_summary: 'Labyrinth-Zusammenfassung',
    course_recommendation: 'Kursempfehlung',
    downlad_center_save_summary: 'Zusammenfassung im Download-Center speichern',
    loading_maze_summary: 'Lade Labyrinth-Zusammenfassung...',
    generating_course_recommendation: 'Erstelle Kursempfehlung...',
    no_course_recommended: 'Kein Kurs empfohlen.',
    click_to_view_course: 'Klicken Sie, um den Kurs anzusehen',
    select_simulation_type: 'Simulationsart auswählen',
    simulation_mode: 'Simulationsmodus',
    attempts_count: 'Anzahl der Versuche',
    no_of_attempts_user_can_try:
      'Anzahl der Versuche, die ein Benutzer versuchen kann',
    uload_section_file: 'Abschnittsdatei hochladen',
    my_library: 'Meine Bibliothek',
    search_documents_by_name: 'Dokumente nach Namen suchen...',
    document: 'Dokument',
    org_library: 'Organisationsbibliothek',
    top_center: 'Oben Mitte',
    center: 'Mitte',
    bottom_center: 'Unten Mitte',
    big: 'Groß',
    small: 'Klein',
    medium: 'Mittel',
    text_position: '📝 Textposition',
    please_select_text: 'Bitte wählen Sie eine Textposition aus',
    note_that_ai_generated_content_may_not_always_be_accurate:
      '* Bitte beachten Sie, dass KI-generierte Inhalte nicht immer genau sind. Die Platzierung und Formatierung des Textes, wie das Hinzufügen von Text, kann manchmal ungenau sein.',
    number_of_images: '📝 Anzahl der Bilder',
    please_select_of_image: 'Bitte wählen Sie die Anzahl der Bilder aus',
    creating_calc_spreadsheet: 'Erstelle Calc-Tabelle...',
    creating_calc_spreadsheet_successfully:
      'Calc-Tabelle erfolgreich erstellt und hochgeladen!',
    opening_sharelook: 'Öffne ShareLook...',
    shareLook_opened_successfully: 'ShareLook erfolgreich geöffnet!',
    upload_function_not_provided:
      'Impress-Präsentation erfolgreich erstellt und hochgeladen!',
    creating_impress_presentation: 'Erstelle Impress-Präsentation...',
    talk_with_course_assistants: 'Sprich mit Kursassistenten',
    select_your_coacher: 'Wähle deinen Coach',
    simon_witts_aviation_generation_ccoacher:
      'Simon Witts - Aviation Generation - Coach',
    simon_witts: 'Simon Witts',
    aviation_generation_coacher: 'Aviation Generation - Coach',
    coacher_mode_active: 'Coach-Modus aktiv',
    your_personal_coaching_experience: 'Deine persönliche Coaching-Erfahrung',
    powered_by: 'Bereitgestellt von',
    uk_civil_viation_authority_data:
      'Daten der britischen Luftfahrtbehörde (CAA)',
    start_coaching_session: 'Coaching-Sitzung starten',
    what_image_do_you_need: 'Welches Bild benötigst du?',
    write_something: 'Schreibe etwas.',
    speak: 'Sprich',
    grid: 'Raster',
    ar: 'AR',
    premium_voices: 'Premium-Stimmen',
    default_tts: 'Standard-TTS',
    generate_audio: 'Audio generieren',
    username_or_email_address: 'Benutzername oder E-Mail-Adresse',
    meta_maze_avatars: 'MetaMaze-Avatare',
    training_skill_journey: 'TRAINING-SKILL-REISE',
    video_channel: 'Video-Kanal',
    marketplace: 'Marktplatz',
    are_you_sure_you_want_to_update_your_course_template:
      'Sind Sie sicher, dass Sie Ihre Kurvorlage aktualisieren möchten?',
    this_will_automatically_update_the_template:
      'Dies aktualisiert die Vorlage automatisch für alle generierten Lektionen und Seiten Ihres Kurses.',
    note_this_process_will_change_the_course_lesson_layouts:
      'Hinweis: Dieser Vorgang ändert die Layouts der Kurslektionen, was die Positionen von Audio, Video, Bildern und anderen Elementen beeinflussen kann. Wenn Sie neue Elemente zu einer bestehenden Vorlage auf einer Seite hinzugefügt haben, bleiben deren Positionen unverändert.',
    open_sharelook_application: 'ShareLook-Anwendung öffnen?',
    this_will_launch_sharelook_for_screen_capture:
      'Dies öffnet ShareLook für die Bildschirmaufnahme.',
    open: 'Öffnen',
    are_you_sure_you_want_to_save_this_certificate_for_later:
      'Sind Sie sicher, dass Sie dieses Zertifikat für später speichern möchten? Es wird nicht an diesen Kurs angehängt, steht jedoch in Ihrem Zertifikatsverlauf zur Verfügung.',
    are_you_sure_you_want_to_remove_this_media:
      'Sind Sie sicher, dass Sie dieses Medium entfernen möchten?',
    the_media_will_be_removed_from_the_scenario:
      'Das Medium wird aus dem Szenario entfernt.',
    proceed_to_template_selection: 'Weiter zur Vorlagenauswahl',
    template_selection: 'Vorlagenauswahl',
    template_selection: 'Vorlagenauswahl',
    competition_title_is_required: 'Wettbewerbstitel ist erforderlich!',
    competition_description_is_required:
      'Wettbewerbsbeschreibung ist erforderlich!',
    skill_selection_is_required: 'Fähigkeitsauswahl ist erforderlich!',
    start_date_is_required: 'Startdatum ist erforderlich!',
    end_date_is_required: 'Enddatum ist erforderlich!',
    start_date_must_be_before_end_date:
      'Das Startdatum muss vor dem Enddatum liegen!',
    points_cannot_be_negative: 'Punkte dürfen nicht negativ sein!',
    points_connot_exceed: 'Punkte dürfen 1000 nicht überschreiten!',
    error_occured_while_creating_the_competition:
      'Beim Erstellen des Wettbewerbs ist ein Fehler aufgetreten.',
    select_question_type: 'Fragetyp auswählen',
    please_select_question_type: 'Bitte Fragetyp auswählen!',
    search_by_title_or_description: 'Suche nach Titel oder Beschreibung...',
    no_videos_found_matching: 'Keine passenden Videos gefunden',
    what_new_at_shareLook: 'Was gibt es Neues bei ShareLook',
    did_you_know_that_creating_learning_experience:
      'Wussten Sie, dass das Erstellen einer Storytelling-Lernumgebung einfach, schnell und kostengünstig ist? Sie sollten den ShareLook-Kursersteller mit Ihren Fähigkeiten kombinieren. Fragen Sie uns wie.',
    welcome_to_shareLook_help_center: 'Willkommen im ShareLook Help Center',
    select_video_from_the_left_navigation:
      'Wählen Sie ein Video aus der linken Navigation, um zu starten, oder verwenden Sie die Suche, um spezifische Inhalte zu finden.',
    date_time_error_peer:
      'Die Startzeit des Ereignisses muss mindestens 1 Minute in der Zukunft liegen.',
    no_language_information_available:
      'Für diese Stimmen stehen keine Sprachinformationen zur Verfügung.',
    loading_eventlabs_voices: 'Lade ElevenLabs-Stimmen...',
    search_voices: 'Stimmen suchen...',
    please_upload_at_last_one_supported_file:
      'Bitte laden Sie mindestens eine unterstützte Datei hoch.',
    you_can_upload_a_maximum_of_files:
      'Sie können maximal 5 Dateien hochladen.',
    failed_to_load_documents:
      'Dokumente konnten nicht geladen werden. Bitte versuchen Sie es erneut.',
    file_not_supported: 'ist kein unterstützter Dateityp. Akzeptierte Typen:',
    required_fields_are_missing: 'Erforderliche Felder fehlen.',
    form_validation_failed: 'Formularvalidierung fehlgeschlagen.',
    select_cloned_voice: 'Klonstimme auswählen',
    upload_voice: 'Hochgeladene Stimmen',
    max_five: '5 (Max)',
    loading_list: 'Liste wird geladen...',
    failed_to_create_podcast: 'Erstellung des Podcasts fehlgeschlagen!',
    failed_to_create_voicce: 'Erstellung der Stimme fehlgeschlagen!',
    make_public_success: 'Elemente wurden erfolgreich öffentlich gemacht',
    make_org_success: 'Elemente wurden erfolgreich zur Organisation verschoben',
    make_private_success: 'Elemente wurden erfolgreich privat gemacht',
    make_public_failed: 'Fehler beim Öffentlichmachen der Elemente',
    make_org_failed: 'Fehler beim Verschieben der Elemente zur Organisation',
    make_private_failed: 'Fehler beim Privatmachen der Elemente',
    the_number_of_choices_or_paths_available:
      'Die Anzahl der dem Lernenden zur Verfügung stehenden Auswahlmöglichkeiten oder Pfade. Dieser Abschnitt wird deaktiviert, wenn der Lernende den offenen Szenariotyp wählt. <2, 3, 4>',
    select_this_image: 'Dieses Bild auswählen',
    please_select_a_font_size: 'Bitte wählen Sie eine Schriftgröße',
    font_style: 'Schriftstil',
    please_select_a_font_style: 'Bitte wählen Sie einen Schriftstil',
    font_type: 'Schrifttyp',
    please_select_a_font_type: 'Bitte wählen Sie einen Schrifttyp',
    text_color: 'Textfarbe',
    please_select_a_text_color: 'Bitte wählen Sie eine Textfarbe',
    regular: 'Normal',
    bold: 'Fett',
    italic: 'Kursiv',
    thin: 'Dünn',
    font_retro: 'Retro',
    font_techy: 'Technisch',
    font_neon: 'Neon',
    font_sketch: 'Skizze',
    font_3d: '3D',
    font_comic_style: 'Comic-Stil',
    font_anime_style: 'Anime-Stil',
    font_illustration: 'Illustration',
    font_hand_written: 'Handschrift',
    font_quirky: 'Eigenartig',
    font_chalk_board: 'Tafel',
    color_vibrant: 'Lebhaft',
    color_black_white: 'Schwarz & Weiß',
    color_gold_script: 'Goldschrift',
    color_rainbow_neon: 'Regenbogen Neon',
    color_gradient: 'Verlauf',
    text_options: 'Textoptionen',
    icon_text: '📝 Text',
    type_message: 'Nachricht eingeben',
    please_upload_at_least_one_supported_file:
      'Bitte laden Sie mindestens eine unterstützte Datei hoch (.pdf, .doc, .docx, .ppt, .pptx, .txt).',
    select_files_to_upload: 'Dateien zum Hochladen auswählen',
    showing: 'Anzeigen',
    are_you_sure_delete_file_confirm:
      'Sind Sie sicher, dass Sie dies löschen möchten?',
    click_to_open_pdf_reference: 'Klicken, um die PDF-Referenz zu öffnen',
    click_to_open: 'Klicken zum Öffnen',
    write_here: 'Hier schreiben...',
    content_edited_successfully: 'Inhalt erfolgreich bearbeitet!',
    failed_to_edit_content: 'Inhalt konnte nicht bearbeitet werden',
    please_enter_editing_instruction:
      'Bitte geben Sie Bearbeitungshinweise ein',
    review_course_wide_changes: 'Kursweite Änderungen überprüfen',
    collapse_all: 'Alle einklappen',
    expand_all: 'Alle ausklappen',
    adding_content_from_internet: 'Füge Inhalte aus dem Internet hinzu...',
    no_content_found: 'Kein Inhalt gefunden.',
    please_enroll_to_take_this_skill_journey:
      'Bitte melden Sie sich an, um diese Skill Journey zu absolvieren',
    edited_content: 'Bearbeiteter Inhalt',
    a_recommended_course_is_available:
      'Ein empfohlenes Kursangebot ist verfügbar. Bitte prüfen Sie die Anwendung für weitere Details.',
    competition_deleted_successfully: 'Wettbewerb erfolgreich gelöscht!',
    failed_to_delete_the_competition: 'Fehler beim Löschen des Wettbewerbs!',
    generate_content_from: 'Inhalt generieren aus',
    minimum_score: 'Mindestpunktzahl',
    please_select_style: 'Bitte wählen Sie einen Stil aus',
    document_type: 'Dokumenttyp',
    select_document_type: 'Wählen Sie einen Dokumenttyp aus',
    please_select_document_type: 'Bitte wählen Sie einen Dokumenttyp aus',
    document_name: 'Dokumentname',
    please_enter_document_name: 'Bitte geben Sie einen Dokumentnamen ein',
    infographics: 'Infografiken',
    generate_infographics: 'Infografiken erstellen',
    course_builder: 'Kurs-Builder',
    short_videos: 'Kurzvideos',
    user_management: 'Benutzerverwaltung',
    user_agreement: 'NUTZERVEREINBARUNG',
    terms_and_conditions_upper: 'ALLGEMEINE GESCHÄFTSBEDINGUNGEN',
    connected: 'Verbunden',
    waiting_for_coach: 'Warte auf Coach...',
    disconnected: 'Getrennt',
    coach_intro: 'Hallo, ich bin DGF Logistik-Coach.',
    coach_help: 'Wie kann ich Ihnen helfen?',
    press_to_speak: 'Drücken Sie hier, bevor Sie sprechen',
    leave: 'Verlassen',
    open_the_sharelook_application_for_building_interactive_lesson:
      'Dies öffnet die ShareLook-Anwendung zum Erstellen interaktiver Lektionen. Wenn die Anwendung nicht geöffnet wird, ist sie möglicherweise nicht auf Ihrem Gerät installiert.',
    launch_interactive_lesson: 'Interaktive Lektion starten',
    create_interactive_lesson: 'Interaktive Lektion erstellen',
    set_up_your_interactive_lesson: 'Richten Sie Ihre interaktive Lektion ein',
    interactive_lesson_title: 'Titel der interaktiven Lektion',
    enter_interactive_lesson_title: 'Titel der interaktiven Lektion eingeben',
    this_feature_available_for_windows_user_only:
      'Diese Funktion ist nur für Windows-Benutzer verfügbar',
    preparing_interactive_lesson: 'Interaktive Lektion wird vorbereitet...',
    please_wait_while_we_set_up_your_interactive_lesson:
      'Bitte warten Sie, während wir Ihre interaktive Lektion einrichten',
    open_sharelook_app: 'ShareLook App öffnen',
    current_color: 'Aktuelle Farbe',
    new_color: 'Neue Farbe',
    narrativeHook: 'Narrations-Hook',
    storyPlot: 'Geschichtenerzählung',
    complexity: 'Komplexität',
    genre: 'Genre',
    vocabulary: 'Vokabular',
    narrativeStructure: 'Narrationsstruktur',
    timePeriod: 'Zeitraum',
    storyLength: 'Geschichtenerzählungslänge',
    characterNames: 'Charakternamen',
    outputType: 'Ausgabetyp',
    tone: 'Ton',
    narrativeStyle: 'Narrationsstil',
    formal: 'Formell',
    informal: 'Informell',
    humorous: 'Humorvoll',
    assertive: 'Durchsetzungsfähig',
    sarcastic: 'Sarkastisch',
    optimistic: 'Optimistisch',
    firstPerson: 'Erste Person',
    secondPerson: 'Zweite Person',
    thirdPerson: 'Dritte Person',
    thirdPersonLimited: 'Dritte Person begrenzt',
    thirdPersonOmniscient: 'Dritte Person allwissend',
    epistolary: 'Epistolär',
    beginner: 'Anfänger',
    intermediate: 'Fortgeschritten',
    advanced: 'Erfahren',
    experimental: 'Experimentell',
    realistic: 'Realistisch',
    historical: 'Historisch',
    casual: 'Locker',
    drama: 'Drama',
    fantasy: 'Fantasy',
    adventure: 'Abenteuer',
    satire: 'Satire',
    scienceFiction: 'Science-Fiction',
    mystery: 'Mystery',
    linear: 'Linear',
    nonLinear: 'Nicht-linear',
    circular: 'Zirkulär',
    inMediaRes: 'In medias res',
    framedNarrative: 'Rahmenerzählung',
    past: 'Vergangenheit',
    present: 'Gegenwart',
    future: 'Zukunft',
    timelessOrUnspecified: 'Zeitlos / nicht spezifiziert',
    short: 'Kurz (300 - 500 Wörter)',
    medium: 'Mittel (500 - 800 Wörter)',
    long: 'Lang (800+ Wörter)',
    screenplay: 'Drehbuch',
    narrative: 'Erzählung',
    simple: 'Einfach',
    moderate: 'Mittel',
    advanced: 'Fortgeschritten',
    jargonOrTechnical: 'Fach- oder Fachjargon',
    periodSpecific: 'Zeitspezifisch',
    slangOrColloquial: 'Slang oder umgangssprachlich'
  },
  v4: {
    translation_complete: 'Übersetzung abgeschlossen',
    upload_another_file: 'Weitere Datei hochladen',
    all_files_uploaded: 'Alle Dateien hochgeladen',
    upload_and_submit: 'Hochladen & Absenden',
    drop_files: 'Datei ablegen und Ziel für Upload auswählen.',
    duplicate_lessoon: 'Lektion bereits im Kurs vorhanden',
    skill_rule_title: 'Bitte Skill Journey Titel eingeben',
    imageCreatorTitle: 'Bild-Generator',
    isTranslated: 'Übersetzt',
    translationCourseDesc:
      'Diese Kursübersetzung kann einige Minuten dauern. Vielen Dank für Ihre Geduld!',
    translateCourseTip:
      'Erstellen Sie einen übersetzten Kurs, den Sie unabhängig vom Original ändern können, einschließlich aller Lektionen und Seiten.',
    translateModalBtn: 'Übersetzen',
    sharelook_assistance: 'Sharelook Coaching',
    translationSuccess: 'Kurs "<0/>" wurde erfolgreich übersetzt!',
    translatingCourse: 'Kurs wird übersetzt...',
    translateModalTitle: 'Kurs übersetzen',
    translateSelectLang: 'Sprache auswählen',
    fileDeleteconfirm:
      'Sind Sie sicher, dass Sie diese Datei löschen möchten? Dies kann nicht rückgängig gemacht werden.',
    fileDeleteMessage: 'Datei erfolgreich gelöscht.',
    fileDeleteFailedMessage: 'Dateilöschung fehlgeschlagen!',
    certificate_save_btn: 'Zertifikat hinzufügen zu ',
    maze_path_info: 'Es sind keine Wege für den Graphen verfügbar!',
    file_size_mb: 'Die Dateigröße muss kleiner als 25 MB sein!',
    reports: {
      products: 'Produkte',
      users: 'Benutzer',
      ph_username: 'Benutzer nach Benutzernamen suchen',
      ph_id: 'Benutzer nach Benutzer-ID suchen',
      ph_email: 'Benutzer nach E-Mail-Adresse suchen'
    },
    tags_all: 'Alle',
    delete_file_confirm:
      'Sind Sie sicher, dass Sie diese Datei löschen möchten?',
    delete_file_title: 'Datei löschen',
    tooltip_publish: 'Kurs mit ausgewählter Option veröffentlichen',
    tooltip_save: 'Kurs mit aktuellen Updates speichern',
    tooltip_next: 'Zur nächsten Kurseinstellung gehen',
    tooltip_finish: 'Aktuelle Updates abschließen und speichern',
    audio_modal: {
      title_upload: 'Hochladen',
      title_update: 'Aktualisieren',
      title_audio: 'Audiodatei',
      fileDeleteFailedMessage: 'Datei löschen fehlgeschlagen!',
      fileDelete: 'Diese Datei löschen.',
      certificate_save_btn: 'Zertifikat hinzufügen zu ',
      maze_path_info: 'Es sind keine Pfade für den Graphen verfügbar!',
      file_size_mb: 'Dateigröße muss unter 25 MB liegen!',
      reports: {
        products: 'Produkte',
        users: 'Benutzer',
        ph_username: 'Benutzer nach Benutzername suchen',
        ph_id: 'Benutzer nach Benutzer-ID suchen',
        ph_email: 'Benutzer nach E-Mail suchen'
      },
      select_upload_section_id: 'Abschnittsdatei ist erforderlich',
      tags_all: 'Alle',
      delete_file_confirm:
        'Sind Sie sicher, dass Sie diese Datei löschen möchten?',
      delete_file_title: 'Datei löschen',
      tooltip_publish: 'Kurs in ausgewählter Option veröffentlichen',
      tooltip_save: 'Kurs mit aktuellen Updates speichern',
      tooltip_next: 'Zu nächster Kurs-Einstellung gehen',
      tooltip_finish: 'Aktuelle Updates abschließen und speichern',
      stories_modal: {
        title_upload: 'Geschichten hochladen',
        title_update: 'Geschichten aktualisieren',
        title_audio: 'Audio Story Datei',
        btn_upload: 'Hochladen',
        btn_update: 'Aktualisieren',
        btn_close: 'Schließen',
        btn_cancel: 'Abbrechen',
        lbl_cover: 'Story Cover Bild',
        rule_cover: 'Bitte Story Audio Cover hochladen!',
        lbl_title: 'Story Audio Titel',
        rule_title: 'Bitte Story Audio Titel eingeben!',
        lbl_description: 'Story Audio Beschreibung',
        rule_description: 'Bitte Story Audio Beschreibung eingeben!',
        lbl_file: 'Story Audio Datei hochladen',
        rule_file: 'Bitte Story Audio Datei hochladen!',
        rule_file_type: 'Bitte gültige Story Audio Datei hochladen!',
        lbl_select_file: 'Story Audio Datei auswählen',
        msg_valid_file: 'Bitte gültige Story Audio Datei auswählen!',
        msg_success: 'Story Audio Datei erfolgreich hochgeladen',
        msg_failed: 'Fehler beim Zuweisen der Mediendaten!',
        msg_error: 'Fehler beim Hochladen der Datei!'
      },
      audio_modal: {
        title_upload: 'Hochladen',
        title_update: 'Aktualisieren',
        title_audio: 'Audio Datei',
        btn_upload: 'Hochladen',
        btn_update: 'Aktualisieren',
        btn_close: 'Schließen',
        btn_cancel: 'Abbrechen',
        lbl_cover: 'Titelbild',
        rule_cover: 'Bitte laden Sie ein Audio-Cover hoch!',
        lbl_title: 'Audio-Titel',
        rule_title: 'Bitte geben Sie den Audio-Titel ein!',
        lbl_description: 'Audio-Beschreibung',
        rule_description: 'Bitte geben Sie eine Audio-Beschreibung ein!',
        lbl_file: 'Audiodatei hochladen',
        rule_file: 'Bitte laden Sie eine Audiodatei hoch!',
        rule_file_type: 'Bitte laden Sie eine gültige Audiodatei hoch!',
        lbl_select_file: 'Audiodatei auswählen',
        msg_valid_file: 'Bitte wählen Sie eine gültige Audiodatei aus!',
        msg_success: 'Audiodatei erfolgreich hochgeladen',
        msg_failed: 'Medien-Daten konnten nicht zugewiesen werden!',
        msg_error: 'Fehler beim Hochladen der Datei!'
      },
      info_episode: 'Ein Titelbild für die Episode',
      btn_delete_episode: 'Diese Podcast-Episode löschen.',
      btn_edit_marketplace: 'Marktplatzdetails bearbeiten',
      btn_save_marketplace: 'Änderungen speichern',
      btn_ai_podcast: 'Erstelle eine KI-gestützte Podcast-Episode.',
      btn_upload_podcast: 'Lade deine eigene Podcast-Audio-Episode hoch.',
      attach_file:
        'Dateien hochladen, um mehr Inhalte mit Ihrem Publikum zu teilen',
      fileDownload: 'Download this file.',
      singleEpishode: 'Folge',
      podcast_music: 'Podcast und Musik',
      publishHeader: 'Podcast und Musik veröffentlichen',
      editHeader: 'Podcast und Musik bearbeiten',
      createHeader: 'Podcast und Musik erstellen',
      marketplaceHeader: 'Marktplatzdetails für Podcast und Musik',
      message_marketplace: 'Bitte füllen Sie das Marktplatzformular aus!',
      create_podcast_live: 'Live-Podcast und Musik',
      create_podcast_custom: 'Benutzerdefinierter Podcast und Musik',
      create_podcast_stories: 'Benutzerdefinierter Podcast und Geschichten',
      ai_Assisted_podcast_reation:
        'KI-unterstützte Podcast- und Musikproduktion',
      publishTitle:
        'Veröffentlichen Sie Podcast und Musik zur öffentlichen Ansicht.',
      customButton: 'Benutzerdefiniert erstellen',
      customTitle: 'Speichert die am Podcast vorgenommenen Änderungen.',
      updateButton: 'Aktualisieren',
      createButton: 'Erstellen',
      createNewButton: 'Neu erstellen',
      updateTitle:
        'Aktuelle Podcast-, Musik- & Geschichten-Details aktualisieren.',
      createTitle: 'Neuen Podcast, Musik & Geschichten erstellen',
      createNewTitle:
        'Neuer Podcast und Musik werden auf dem aktuellen Podcast und Musik mit neuen Eingabedetails erstellt.',
      podcastTitle: 'Episodenliste',
      podcastStoryTitle: 'Liste der Geschichten',
      podcastToolTipTitle: 'Liste der Podcast-Episode(n)',
      uploadAudio: 'Hochladen',
      aiAudio: 'KI-Audio',
      emptyPodcast: 'Noch keine Podcast- und Musik-Audioaufnahmen vorhanden.',
      emptyStoriesPodcast: 'Noch keine Podcasts und Geschichten hinzugefügt.',
      emptyCreatePodcast:
        'Bitte erstelle einen Podcast, um Musik hinzuzufügen.',
      playPodcast: 'Den ausgewählten Podcast und Musik abspielen.',
      pausePodcast: 'Den ausgewählten Podcast und Musik pausieren.',
      selectPodcas: 'Diesen Podcast und Musik auswählen.',
      downloadPodcast: 'Dieses Audio herunterladen.',
      uploadAudioFile:
        'Laden Sie neues Audio hoch und ersetzen Sie das aktuelle Audio.',
      deleteConfirm: 'Sind Sie sicher, dass Sie dieses Audio löschen möchten?',
      roomName: 'Podcast-Name',
      addGuestTitle: 'GASTREDNER HINZUFÜGEN',
      lbl_cover: 'Audio Cover',
      rule_cover: 'Bitte Audio Cover hochladen!',
      lbl_title: 'Audio Titel',
      rule_title: 'Bitte Audio Titel eingeben!',
      lbl_description: 'Audio Beschreibung',
      rule_description: 'Bitte Audio Beschreibung eingeben!',
      lbl_file: 'Audio Datei hochladen',
      rule_file: 'Bitte Audio Datei hochladen!',
      rule_file_type: 'Bitte gültige Audio Datei hochladen!',
      lbl_select_file: 'Audio Datei auswählen',
      msg_valid_file: 'Bitte gültige Audio Datei auswählen!',
      msg_success: 'Audio Datei erfolgreich hochgeladen',
      msg_failed: 'Fehler beim Zuweisen der Mediendaten!',
      msg_error: 'Fehler beim Hochladen der Datei!'
    },
    info_episode: 'Ein Cover-Bild für die Episode.',
    btn_delete_episode: 'Diese Podcast-Episode löschen.',
    btn_edit_marketplace: 'Marktplatz-Details bearbeiten.',
    btn_save_marketplace: 'Aktuelle Änderungen speichern.',
    btn_ai_podcast: 'Eine KI-gestützte Podcast-Episode erstellen.',
    btn_upload_podcast: 'Eigene Podcast-Audio-Episode hochladen.',
    attach_file:
      'Dateien hochladen, um mehr Inhalte mit Ihrem Publikum zu teilen',
    fileDownload: 'Diese Datei herunterladen.',
    singleEpishode: 'Episode',
    podcast_music: 'Podcast, Musik & Geschichten',
    publishHeader: 'Podcasts, Musik & Geschichten veröffentlichen',
    editHeader: 'Podcasts, Musik & Geschichten bearbeiten',
    createHeader: 'Podcasts, Musik & Geschichten erstellen',
    marketplaceHeader: 'Podcasts, Musik & Geschichten Marktplatz-Details',
    message_marketplace: 'Bitte Marktplatz-Formular ausfüllen!',
    create_podcast_live: 'Live Podcast und Musik',
    create_podcast_custom: 'Benutzerdefinierten Podcast und Musik',
    create_podcast_stories: 'Geschichte',
    ai_Assisted_podcast_reation: 'KI-unterstützter Podcast und Musik',
    publishTitle:
      'Podcast, Musik & Geschichten für öffentliche Ansicht veröffentlichen.',
    customButton: 'Benutzerdefiniert erstellen',
    customTitle: 'Speichert Änderungen am Podcast.',
    updateButton: 'Aktualisieren',
    createButton: 'Erstellen',
    createNewButton: 'Neu erstellen',
    updateTitle:
      'Aktuelle Podcast-, Musik- & Geschichten-Details aktualisieren.',
    createTitle: 'Neuen Podcast, Musik & Geschichten erstellen',
    createNewTitle:
      'Neuer Podcast, Musik & Geschichten wird auf aktuellem Podcast, Musik & Geschichten mit neuen Eingabedetails erstellt.',
    podcastTitle: 'Episoden-Liste',
    podcastStoryTitle: 'Geschichten-Episoden-Liste',
    podcastToolTipTitle: 'Liste der Podcast-Episode(n)',
    uploadAudio: 'Hochladen',
    aiAudio: 'KI Audio',
    emptyPodcast:
      'Noch keine Podcast-, Musik- & Geschichten-Audio-Aufzeichnung.',
    emptyStoriesPodcast: 'Noch keine Geschichten hinzugefügt.',
    emptyCreatePodcast:
      'Bitte Podcast erstellen, um Audio hinzufügen zu können.',
    playPodcast: 'Ausgewählten Podcast, Musik & Geschichten abspielen.',
    pausePodcast: 'Ausgewählten Podcast, Musik & Geschichten pausieren.',
    selectPodcast: 'Diesen Podcast, Musik & Geschichten auswählen.',
    downloadPodcast: 'Diese Audio herunterladen.',
    uploadAudioFile: 'Neue Audio hochladen und aktuelle Audio ersetzen.',
    deleteConfirm: 'Sind Sie sicher, dass Sie diese Audio löschen möchten?',
    roomName: 'Podcast Name',
    addGuestTitle: 'GAST-SPRECHER HINZUFÜGEN',
    showTime: 'Show-Zeit',
    startTime: 'Startzeit',
    endTime: 'Endzeit',
    erorMsgImg: 'Bitte gültiges Bild auswählen.',
    failedMsgImg:
      'Fehler beim Laden des Bildes. Bitte versuchen Sie es erneut!',
    failedMsgUpload: 'Fehler beim Hochladen des Cover-Bildes!',
    btnCoverUpload: 'Cover hochladen',
    is_private: 'Privat',
    to_attach: 'Datei anhängen',
    file_attached: 'Datei(en) anhängen',
    main_event: 'Hauptveranstaltung',
    event: 'Veranstaltungen',
    upload_pdf: 'PDF hochladen',
    portrait: 'Hochformat',
    landscape: 'Querformat',
    import_from_library: 'Text aus Medienbibliothek importieren',
    question_answer_ai: 'Frage/Antwort KI',
    take_maze: 'MetaMaze NEHMEN',
    training: 'Schulung',
    select_transcribe_locale: 'Sprache für Transkription auswählen',
    transcribe_limit: 'Transkriptions-Minuten',
    not_complete: 'Marktplatz-Informationen sind nicht vollständig',
    complete: 'Marktplatz-Informationen sind vollständig',
    not_admin: 'Benötigt Admin-Berechtigung für Marktplatz-Veröffentlichung',
    no_course:
      'Bitte Titel eingeben und Bild auswählen, um Marktplatz zu aktivieren',
    scorm_not_complete:
      'Bitte Titel eingeben und Bild auswählen, um SCORM-Datei hochzuladen',
    not_found_maze: 'MetaMaze nicht gefunden',
    email_require: 'E-Mails sind erforderlich',
    poll_required: 'Umfrage-Daten sind erforderlich',
    alert: 'Warnung!',
    warning: 'Achtung!',
    ok: 'Ok',
    cancel: 'Abbrechen',
    done: 'Fertig',
    insert: 'Einfügen',
    private: 'Privat',
    public: 'Öffentlich',
    no_connection: 'Internetverbindung verloren',
    switch: 'Wechseln',
    share_screen: 'Bildschirm teilen',
    stop_share_screen: 'Bildschirmfreigabe beenden',
    share_screen_with_camera: 'Bildschirm mit Kamera teilen',
    stop_share_screen_with_camera: 'Bildschirmfreigabe mit Kamera beenden',
    camera_on: 'Kamera ein',
    camera_off: 'Kamera aus',
    mic_on: 'Mikrofon ein',
    mic_off: 'Mikrofon aus',
    fullscreen: 'Vollbild',
    live_now: 'Jetzt live',
    schedule_on: 'Geplant für',
    organisations: 'Organisationen',
    org_groups: 'Organisationsgruppen',
    specific_user: 'Bestimmter Benutzer',
    gif: 'GIF',
    unavailable: 'Nicht verfügbar',
    yes: 'Ja',
    no: 'Nein',
    event_duration_message: 'Maximal 300 Minuten (5 Stunden)',
    send_email: 'E-Mail-Benachrichtigung senden',
    admin_only: 'Nur Admin',
    join: 'Beitreten',
    leave: 'Verlassen',
    share: 'Teilen',
    share_text:
      'Bitte geben Sie die E-Mail-Adresse ein, mit der Sie diese Datei teilen möchten.',
    share_text_title: 'PDF teilen',
    share_text_title_txt: 'Text teilen',
    select_users: 'Benutzer auswählen',
    delete: 'Löschen',
    attachment_event: 'Anhänge für die Veranstaltung:',
    monthly_transcribe: 'Monatliches Transkriptions-Limit:',
    enable_ai: 'KI aktivieren:',
    enable_maze: 'MetaMaze aktivieren:',
    media_service: 'Medien-Service',
    allow_others: 'Anderen das Bearbeiten erlauben',
    join_breakout_room: 'Breakout-Raum beitreten',
    bio: 'Biografie',
    linkedin: 'LinkedIn',
    select_org_report:
      'Bitte finden und wählen Sie eine Organisation für die Berichtserstellung.',
    org_image_not_found: 'Bild nicht gefunden',
    insert_text: 'Text einfügen',
    insert_question_answer: 'Frage/Antwort KI',
    modal_title2: 'Text-Galerie',
    my_text_library: 'Meine Textbibliothek',
    ai: 'KI',
    public_text_library: 'Öffentliche Textbibliothek',
    organization_text_library: 'Organisations-Textbibliothek',
    no_transcribed_text: 'Kein transkribierter Text gefunden',
    public_text_not_found: 'Öffentlicher transkribierter Text nicht gefunden',
    org_text_not_found: 'Organisations-transkribierter Text nicht gefunden',
    org_video_not_found: 'Video nicht gefunden',
    canva: 'Mit Canva machen',
    canva_open: 'Hier klicken, um Canva-Editor zu öffnen.',
    pdf: 'PDF',
    txt: 'TEXT',
    human: 'Premium',
    shared_file: 'Ihre Datei wurde erfolgreich geteilt.',
    error_shared_file:
      'Problem beim Teilen der Datei. Bitte versuchen Sie es erneut.',
    publish: 'Veröffentlichen',
    maze_scenes: 'MetaMaze-Szenen',
    pexel_images: 'Pexel-Bilder',
    group: 'Gruppe',
    group_name: 'Gruppenname',
    select_group: 'Gruppe auswählen',
    search_maze: 'MetaMaze suchen',
    hosts: 'Gastgeber',
    avg_score: 'Prozent-Punktzahl',
    maze_report: 'Maze-Bericht',
    maze_view: 'Maze-Ansicht',
    title_maze: 'MetaMaze',
    author: 'Autor',
    match: 'Pfad-Übereinstimmung',
    preview_mazeTitle: 'Titel: ',
    other: 'Andere',
    total: 'GESAMT',
    report_course: 'KURS',
    report_courses: 'KURSE',
    report_event: 'VERANSTALTUNG',
    report_events: 'VERANSTALTUNGEN',
    report_maze: 'MAZE',
    report_personalize_learning: 'PERSONALISIERTES LERNEN',
    report_live_assessment: 'LIVE-BEWERTUNG',
    report_live_assessments: 'LIVE-BEWERTUNGEN',
    report_skill_journey: 'SKILL JOURNEY',
    skill_journey: 'Skill Journey',
    skill_journeys: 'Skill Journeys',
    date: 'DATUM: ',
    search_people: 'Personen suchen',
    passed: 'BESTANDEN',
    failed: 'NICHT BESTANDEN',
    item: 'ARTIKEL',
    type: 'TYP',
    minimum_pass_score: 'MINDEST-BESTEHENS-PUNKTZAHL',
    resources_count: 'RESSOURCEN-ANZAHL',
    back: 'ZURÜCK',
    resources: 'RESSOURCEN',
    time_spent: 'VERBRACHTE ZEIT (MINUTEN)',
    detail: 'DETAIL',
    watched_time_mins: 'ANGESEHENE ZEIT (MINUTEN)',
    personalize_learning: 'Personalisiertes Lernen',
    result: 'Ergebnis',
    assessment_title: 'Titel',
    marketPlace_graph: 'Marktplatz-Diagramm',
    attachments: 'Zusätzliche Anhänge',
    new_scorm_course: 'Neuen SCORM-Kurs hochladen',
    upload_scorm_course: 'SCORM-Kurs hochladen',
    new_maze: 'Neue MetaMaze erstellen',
    new_skill_journey: 'Skill Journey erstellen',
    tags_scorm: 'SCORM',
    tags_skillJourney: 'Skill Journey',
    new_discussion_room: 'Neuen Podcast erstellen',
    title: 'Was möchten Sie heute tun?',
    build_course: 'Meinen Kurs erstellen',
    live_broadcast: 'Live-Übertragung',
    invite_users: 'Benutzer zu meiner Organisation einladen',
    build_voice_over: 'Mein Voiceover erstellen',
    view_reports: 'Berichte anzeigen',
    upload_media: 'Meine Medien oder Arbeiten hochladen und teilen',
    main_menu: 'Hauptmenü',
    get_started: 'LOSLEGEN',
    search_group: 'Organisationsgruppe suchen',
    ai_course: 'KI-Kurs',
    search_user: 'Name des Unternehmens suchen',
    no_maze: 'Es gibt derzeit keine MetaMaze.',
    conference_event_title: 'Konferenz-Veranstaltungen',
    conference_event_subTitle: 'Beendete Konferenz-Veranstaltungen',
    conference_event: 'Es gibt derzeit keine Konferenz-Veranstaltungen.',
    no_skill: 'Es gibt derzeit keine Skill Journeys.',
    no_podcast: 'Es gibt derzeit keine Podcasts.',
    maze_channel: 'MetaMaze',
    past_live_assessment: 'Vergangene Live-Bewertungen',
    no_live_assessment: 'Es gibt derzeit keine Live-Bewertungen.',
    enrolled_courses: 'Kurse',
    my_video_channel: 'Meine Video-Kanäle',
    enrolled_liveEvents: 'Live-Veranstaltungen',
    sharebot: 'Sharebot',
    selected_language: 'Ausgewählte Sprache',
    shareSphere_game: 'ShareSphere-Spiel',
    maze: 'MetaMaze',
    skill: 'Skill Journey',
    channel: 'Kanal',
    order: 'Reihenfolge',
    is_record: 'Aufzeichnen',
    no_maze_found: 'Keine MetaMaze gefunden.',
    maze_self_limit_reached: 'MetaMaze-Selbstbewertungs-Limit erreicht.',
    metamaze_two_times: 'Sie haben diese MetaMaze bereits 2 Mal absolviert.',
    metamaze_two_times_no_result:
      'Sie haben diese MetaMaze bereits 2 Mal absolviert. Ihr Ergebnis wird nicht für das Abschließen dieser Selbstbewertung nach dem zweiten Mal verfolgt.',
    scorm_zip: 'SCORM ZIP',
    pass_score: 'Mindestpunktzahl zum Bestehen',
    organization: 'Bitte Organisation auswählen',
    pass_score_mark: 'Bitte Punkte zwischen 1 und 100 eingeben',
    maze_cloning_success: 'MetaMaze "<0/>" wurde erfolgreich geklont!',
    create_certificate: 'Zertifikat erstellen',
    create_badge: 'Abzeichen erstellen',
    certificate_added: 'Zertifikat hinzugefügt.',
    badge_added: 'Abzeichen hinzugefügt.',
    certificate_warning:
      'Sie können das Zertifikat/Abzeichen nicht bearbeiten, sobald es veröffentlicht ist!',
    created_course_plan:
      'Bearbeiten und veröffentlichen Sie Ihren erstellten Kurs und planen Sie Live-Veranstaltungen',
    market_place_space: 'Marktplatz',
    select_course_language: 'Sprache auswählen (Optional)',
    select_language: 'Sprache auswählen',
    file_upload: 'Datei hochladen',
    text: 'Text hier schreiben…',
    attempts_count: 'Anzahl der Versuche, die ein Benutzer wiederholen kann',
    no_of_people_placeholder: 'Anzahl der Personen',
    back_to_maze: 'Zurück zum MetaMaze-Szenario',
    edit_maze: 'Bearbeiten',
    wait: 'Warten...',
    retry: 'Wiederholen',
    publish_scorm_course: 'Ihren SCORM-Kurs veröffentlichen',
    publish_maze: 'Ihre MetaMaze veröffentlichen',
    import: 'Elemente importieren',
    answer_correct: 'Richtige Antwort wählen',
    author_name: 'Bitte Namen des Autors eingeben',
    select_category: 'Bitte Kategorie auswählen',
    course_outline: 'Bitte Kurs-Gliederung eingeben',
    course_obj: 'Bitte Kurs-Ziele eingeben',
    course_description: 'Bitte Kurs-Beschreibung eingeben',
    maze_outline: 'Bitte Maze-Gliederung eingeben',
    maze_obj: 'Bitte Maze-Ziele eingeben',
    maze_description: 'Bitte Maze-Beschreibung eingeben',
    lessons: 'Bitte Anzahl der Lektionen eingeben',
    user_email_require: 'Benutzer-E-Mail ist erforderlich',
    team_size: 'Teamgröße ist erforderlich',
    enter_price: 'Bitte Preis eingeben (5 oder mehr)',
    input_title_maze: 'Bitte Maze-Titel eingeben',
    trainer_bio: 'Bitte Trainer-Biografie eingeben',
    trainer_linkedin: 'Bitte LinkedIn des Trainers eingeben',
    error_video: 'Bitte Anzahl der Videos eingeben',
    input_video_link: 'Bitte Video-Link eingeben',
    number_of_video: 'Anzahl der Videos',
    number_of_lessions: 'Anzahl der Lektionen',
    no_of_people_in_conference: 'Wie viele Personen in der Konferenz?',
    transcribe_settings: 'Transkriptions-Einstellungen',
    transcribe: 'Transkribieren',
    cloning_maze: 'MetaMaze wird geklont...',
    id_number: 'ID-Nummer',
    timezone: 'Zeitzone',
    delete_maze: 'Löschen',
    view_maze: 'Anzeigen',
    create_metamaze: 'MetaMaze erstellen',
    metamaze_scenario: 'MetaMaze-Szenario',
    publish_metamaze: 'Veröffentlichungs-Einstellung',
    search_result: 'Suchergebnisse',
    search_for: 'Suchen nach',
    search_no_result: '- Keine Ergebnisse verfügbar!',
    channel_no_available: 'Kein Kanal verfügbar!',
    this_card: 'Das ist eine Karte',
    course_no_available: 'Keine Kurse verfügbar!',
    manage_sequence: 'Reihenfolge verwalten',
    save_sequence: 'Reihenfolge speichern',
    new: 'Neu',
    in_progress: 'In Bearbeitung',
    recommended_course: 'Empfohlener Kurs',
    up_coming: 'Bevorstehend',
    past_live: 'Vergangene Live',
    input_your_channel_name: 'Bitte Namen Ihres Kanals eingeben!',
    organization_place: 'Organisations-Marktplatz',
    marketplace_report: 'Marktplatz-Bericht',
    story_writing: 'Geschichten-Schreibung',
    Ai_quiz: 'KI-Quiz',
    generate_quiz: 'Quiz generieren',
    create_story: 'Geschichte erstellen',
    change_layout_page: 'Sie sind dabei, das Layout dieser Seite zu ändern.',
    change_layout_message:
      'Bitte beachten Sie, dass nur Text, Bilder, Hintergrund und Logo beibehalten werden. Alle anderen Elemente werden von der Seite entfernt.',
    reviews: 'Bewertungen',
    tab_attachments: 'Anhänge',
    zoom_in: 'Vergrößern',
    zoom_out: 'Verkleinern',
    zoom_reset: 'Zoom zurücksetzen',
    no_attachment: 'Keine Anhänge.',
    select_upload_simulation: 'Bitte Simulation auswählen/hochladen.',
    quiz_updated_successfully: 'Quiz erfolgreich aktualisiert!',
    quizes: 'Quizzes',
    trivia: 'Trivia',
    closing: 'Schließt...',
    products: 'Produkte',
    ask_questions: 'Hier eine Frage stellen...',
    course_information: 'Kurs-Informationen',
    course_assistance: 'Kurs-Ersteller-Unterstützung',
    go_back: 'Zurück gehen',
    ai_generate_content_progress: 'Inhaltsgenerierungs-Fortschritt',
    view_generate_content: 'Generierten Inhalt anzeigen',
    generate_error: 'Generierungs-Fehler!',
    confirm_creating_course:
      'Möchten Sie die Erstellung des Kurses mit diesem Inhalt bestätigen?',
    generate_content_automatically:
      'Dies fügt automatisch alle generierten Inhalte als Lektionen und Seiten zu Ihrem Kurs hinzu.',
    quiz_created_successfully: 'Quiz erfolgreich erstellt!',
    create_quiz: 'Quiz erstellen',
    quiz_setting: 'Quiz-Einstellung',
    please_fill_quiz_setting:
      '* Bitte füllen Sie alle Felder in den Quiz-Einstellungen aus',
    question_list: 'Fragen-Liste',
    add_quiz_to_page: 'Quiz zur Seite hinzufügen',
    form_create_question: 'Formular zum Erstellen einer Frage',
    user_information_updated: 'Benutzer-Informationen aktualisiert!',
    your_stripe_activete_to_continue:
      'Ihr Stripe-Konto ist inaktiv. Bitte verbinden oder aktivieren Sie es, um fortzufahren.',
    connect_tripe: 'Stripe verbinden',
    certificate_sent_sucessfully:
      'Zertifikat erfolgreich an Ihre E-Mail gesendet.',
    error_try_again: 'Fehler. Versuchen Sie es erneut!',
    error_delete_channel: 'Fehler beim Löschen des Kanals.',
    error_update_sub: 'Fehler beim Aktualisieren des Abonnements.',
    end_time_cannot_start: 'Endzeit kann nicht vor Startzeit liegen.',
    start_date_time_interval: 'Startdatum und Zeitintervall sind erforderlich!',
    podcast_updated_successful: 'Podcast erfolgreich aktualisiert.',
    podcast_created_successful: 'Podcast erfolgreich erstellt.',
    podcast_published_successful: 'Podcast erfolgreich veröffentlicht',
    podcast_cover_updated: 'Podcast-Cover aktualisiert',
    new_podcast_details:
      'Neuer Podcast wird auf aktuellem Podcast mit neuen Eingabedetails erstellt.',
    current_update_podcast:
      'Aktuelle Podcast-, Musik- & Geschichten-Details aktualisieren.',
    create_new_podcast: 'Neuen Podcast erstellen',
    publish_podcast_public_view:
      'Podcast für öffentliche Ansicht veröffentlichen.',
    only_allowed_twenty_five_email: 'Nur 25 E-Mails sind erlaubt',
    only_allowed_five_email: 'Es sind nur 5 E-Mails erlaubt.',
    cover_is_required: 'Titelbild ist erforderlich.',
    topic_is_required: 'Thema ist erforderlich.',
    delete_schedule: 'Zeitplan löschen',
    make_as_coaching: 'Als Coaching-Verfügbarkeit markieren',
    manage_category: 'Kategorie verwalten',
    threshold: 'Schwellenwert',
    threshold_popup:
      'Schwellenwert in Prozent (%) – ab diesem Wert wird die Empfehlung für die jeweilige Kategorie aktiviert.',
    list_of_catagory: 'Kategorienliste',
    category_name: 'Kategoriename',
    category_threshold: 'Kategorietoleranz',
    play_game: 'Spiel starten',
    switching_organization: 'Organisation wird gewechselt...',
    coaching_session: 'Coaching-Sitzung',
    required_channel_id: 'Channel-ID ist erforderlich!',
    error_occured_try_again:
      'Fehler ist aufgetreten. Bitte versuche es erneut!',
    please_complete_marketplace_form:
      'Bitte fülle das Marktplatz‑Formular vollständig aus!',
    upload_file_corrupt: 'Die hochgeladene Datei ist beschädigt.',
    course_not_published: 'Der Kurs ist noch nicht veröffentlicht!',
    error_request: 'Fehler bei der Anfrage. Bitte versuche es nochmal!',
    skill_request: 'Bitte fülle alle erforderlichen Felder aus!',
    error_occured: 'Fehler ist aufgetreten. Bitte versuche es erneut!',
    show_time: 'Uhrzeit anzeigen',
    start_time: 'Startzeit',
    end_time: 'Endzeit',
    room_name: 'Podcast‑Name',
    add_guest_speaker: 'Gastsprecher hinzufügen',
    cover_picture: 'Titelbild',
    guest_speaker: 'Gastsprecher',
    see_more: 'Mehr anzeigen',
    see_less: 'Weniger anzeigen',
    background: 'Hintergrund',
    icon: 'Symbol',
    icon_size: 'Symbolgröße',
    icon_color: 'Symbolsfarbe',
    only_text: 'Text',
    change_bg: 'Hintergrundfarbe ändern',
    bg_color: 'Hintergrundfarbe',
    font_size: 'Schriftgröße',
    normal: 'Normal',
    change_color: 'Textfarbe ändern',
    slant_text: 'Text kursiv',
    text_radius: 'Text‑Radius',
    vertical_align: 'Vertikale Ausrichtung',
    horizontal_align: 'Horizontale Ausrichtung',
    change_icon_color: 'Symbolsfarbe ändern',
    upload_icon: 'Symbol hochladen',
    upload_signature: 'Unterschrift hochladen',
    add_another_sign: 'Weitere Unterschrift hinzufügen',
    name_badges: 'Name der Abzeichen',
    should_less_150: 'sollte 150 Zeichen oder weniger sein',
    your_badge: 'Dein Abzeichen',
    do_you_want_delete_badge: 'Möchtest du dieses Abzeichen wirklich löschen?',
    do_you_want_delete_cert: 'Möchtest du dieses Zertifikat wirklich löschen?',
    upload_logo: 'Logo hochladen',
    name_of_cert: 'Name des Zertifikats',
    upload_cert: 'Zertifikat aktualisieren',
    your_cert: 'Dein Zertifikat',
    translate_to: 'Übersetzen in',
    select_file_attach: 'Datei zum Anhängen auswählen',
    certificate: 'Zertifikat',
    badge: 'Abzeichen',
    publish_options: 'Veröffentlichungsoptionen',
    publish_skills_journey: 'Fähigkeitenreise veröffentlichen',
    videos: 'Video‑Liste',
    generate_ai_video:
      'Die Videoerstellung kann einige Zeit dauern. Du wirst per E‑Mail benachrichtigt, sobald sie abgeschlossen ist.',
    trainer_information: 'Trainer‑Information',
    promotional_video_link: 'Werbevideo‑Link',
    please_select: 'Bitte auswählen',
    image_name: 'Bildname:',
    image_size: 'Bildgröße:',
    charecters_fifteen_less: '15 Zeichen oder weniger',
    leadership: 'Führung',
    text_arc: 'Textbogen',
    vertical: 'Vertikal',
    horizontal: 'Horizontal',
    badge_history: 'Abzeichen‑Verlauf',
    templates: 'Vorlagen',
    sign: 'Unterschrift',
    logo: 'Logo',
    certificate_history: 'Zertifikats‑Verlauf',
    please_wait: 'Bitte warten...',
    information: 'Information',
    support_five_thousand_live_event:
      'Unterstützt bis zu 5000 Teilnehmer bei der Veranstaltung',
    support_ten_live_event: 'Unterstützt bis zu 10 Live‑Video‑Teilnehmer',
    we_will_back_participant:
      'Wir werden mit der Veranstaltung und großem Teilnehmerzugang zurück sein.',
    course_objectives: 'Kursziele',
    course_outlines: 'Kursübersicht',
    price_dollor: 'Preis (USD)',
    not_completed: 'Nicht abgeschlossen',
    enable_marketplace: 'Marktplatz aktivieren',
    enable_course_ai: 'Kurserstellung mit KI aktivieren',
    enable_report_to_admin: 'Berichte für Admin anzeigen aktivieren',
    enable_white_label: 'White Label aktivieren',
    enable_eleven_labs_for_maze_play: 'Elevenlabs für Maze‑Play aktivieren',
    enable_eleven_labs_for_maze_play_cloned:
      'Elevenlabs geklonte Stimmen aktivieren',
    simulation_quiz: 'Simulations‑Quiz',
    bg_color_setting: 'Hintergrundfarb‑Einstellungen',
    color_preview: 'Farbvorschau',
    choose_new_color: 'Neue Farbe wählen',
    remove_color: 'Farbe entfernen',
    apply_color: 'Farbe anwenden',
    elemeent_in_a_sceenario_page:
      'Du kannst in einer Szenari-Seite keine anderen Elemente hinzufügen. Bitte nutze andere Seiten oder entferne zuerst das Szenario.',
    no_data_found: 'Keine Daten gefunden.',
    references: 'Quellen / Referenzen',
    open_file: 'Datei öffnen',
    showing_result: 'Ergebnisse werden angezeigt:',
    fiften_day_free_trail: '15‑Tage‑Kostenlose Testphase',
    your_browser_does_not_support:
      'Dein Browser unterstützt das Audio-Element nicht.',
    podcast_desc: 'Podcast‑Beschreibung',
    input_podcast_desc: 'Bitte Podcast‑Beschreibung eingeben',
    podcast_obj: 'Podcast‑Ziele',
    input_podcast_obj: 'Bitte Podcast‑Ziele eingeben',
    podcast_outline: 'Podcast‑Gliederung',
    input_podcast_outline: 'Bitte Podcast‑Gliederung eingeben',
    add_file: 'Datei hinzufügen',
    generate_podcast_audio: 'Podcast‑Audio generieren',
    generate_uploaded_file_input_parameter:
      'Generiert Inhalte basierend auf deiner hochgeladenen Datei und den eingegebenen Parametern.',
    go_backe_generation_state: 'Zurück zum Erstellungs‑Status',
    create_ai_powered_podcast: 'KI‑gestützte Podcast‑Episode(n) erstellen',
    generate_voice_for_all_podcast:
      'Bitte generiere die Stimme für alle Podcast‑Episoden',
    create_podcast_episode: 'Podcast‑Episode erstellen',
    voice_name: 'Stimmenname',
    input_custom_name: 'Bitte benutzerdefinierten Namen eingeben!',
    enter_custom_name: 'Benutzerdefinierten Namen eingeben',
    upload_complete: 'Hochladen abgeschlossen',
    uploading_in_progress: 'Hochladen läuft...',
    podcast_stream_content: 'Podcast‑Inhalts‑Stream',
    upload_podcast_cover: 'Bitte Podcast‑Cover hochladen!',
    enter_podcast_name: 'Bitte Podcast‑Name eingeben!',
    podcast_topic: 'Podcast‑Thema',
    enter_podcast_topic: 'Bitte Podcast‑Thema eingeben!',
    enter_podcast_desc: 'Bitte Podcast‑Beschreibung eingeben!',
    number_of_speaker: 'Anzahl der Sprecher',
    select_the_number_of_speaker: 'Bitte Anzahl der Sprecher auswählen!',
    number_of_episode: 'Anzahl der Episoden',
    input_number_of_episode: 'Bitte Anzahl der Episoden eingeben!',
    podcast_length: 'Podcast‑Länge',
    select_the_podcast_length: 'Bitte Länge des Podcasts auswählen!',
    short_podcast: 'Kurz (5–10 Min.)',
    medium_podcast: 'Mittel (15–18 Min.)',
    long_podcast: 'Lang (18+ Min.)',
    name_of_host: 'Name des Hosts',
    enter_host_name: 'Bitte Name des Hosts eingeben!',
    guest_name: 'Name der Gäste',
    enter_guest_name: 'Bitte Namen der Gäste eingeben!',
    choose_speaker_tone: 'Stimmung der Sprecher wählen',
    enter_speaker_tone: 'Bitte Stimmung des Podcasts auswählen!',
    informal: 'Informell',
    formal: 'Formell',
    serious: 'Ernst',
    light_humor: 'Leichter Humor',
    casual: 'Locker',
    select_content_source: 'Inhaltsquelle wählen',
    from_internet: 'Aus dem Internet',
    upload_pdf_internet: 'PDF oder interne Dokumente hochladen',
    note: 'Hinweis:',
    podcast_content_will_be_automatically_generated:
      'Der Podcast‑Inhalt wird automatisch mithilfe vertrauenswürdiger Internet‑Quellen generiert.',
    upload_or_select_file: 'Bitte Datei(en) hochladen oder auswählen!',
    podcast_eposode_title: 'Podcast‑Episodentitel',
    enter_podcast_title: 'Bitte Episodentitel eingeben!',
    podcast_episode_des: 'Podcast‑Episodenbeschreibung',
    enter_podcast_episode_des: 'Bitte Episodenbeschreibung eingeben!',
    voice: 'Stimme',
    music: 'Musik',
    select_music: 'Musik auswählen',
    play_the_music: 'Musik abspielen',
    stop_the_music: 'Musik stoppen',
    context: 'Kontext',
    generate_audio_content_selected_voice:
      'Generiert Audio für den Inhalt mit gewählter Stimme.',
    required_field_before_submitting:
      'Bitte fülle alle Pflichtfelder aus, bevor du absendest.',
    regenerate_voice: 'Stimme neu generieren',
    generate_voice: 'Stimme generieren',
    your_browser_does_not_suppot:
      'Dein Browser unterstützt das Audio-Element nicht.',
    are_sure_leave_podcast: 'Möchtest du den Podcast wirklich verlassen?',
    broadcast_ongoing:
      'Die Übertragung läuft. Möchtest du wirklich navigieren?',
    brodcaster_unavailable: 'Der Sender ist momentan nicht verfügbar.',
    setting_calender_for_booking: 'Kalender für Buchung einstellen',
    add_calender: 'Kalender hinzufügen',
    waiting_join_host: 'Warten, bis der Host beitritt...',
    no_reviews_found: 'Keine Bewertungen gefunden.',
    rated_already: 'Du hast diese Veranstaltung bereits bewertet.',
    downlink_png: 'PNG herunterladen',
    downlink_jpg: 'JPG herunterladen',
    donwload_file_format: 'Bitte wähle das Dateiformat zum Herunterladen.',
    crashed_event:
      'Diese Veranstaltung ist abgestürzt. Du musst eine neue Veranstaltung erstellen. Entschuldige die Unannehmlichkeiten.',
    prompt: 'Eingabeaufforderung:',
    generated_image: '🚀 Dein Bild wird generiert... bitte warten.',
    download_add: 'Alle herunterladen',
    setting_generator: 'Generator einstellen',
    enter_image_prompt: 'Bitte prompt für Bild eingeben',
    image_prompt: 'Bild-Prompt',
    negative_prompt: 'Negativer Prompt',
    negative_image_prompt: 'Negativen Bild‑Prompt eingeben',
    number_output: 'Anzahl der Ausgaben',
    enter_number_output: 'Bitte Anzahl der Ausgaben eingeben',
    image_style: 'Stil für Bild auswählen',
    output_format: 'Ausgabeformat',
    seeds: 'Seeds',
    enter_seeds: 'Bitte Anzahl der Seeds eingeben',
    performance_mode: 'Leistungsmodus',
    quality: 'Qualität',
    speed: 'Geschwindigkeit',
    balanced: 'Ausgewogen',
    guidance_scale: 'Guidance‑Skala',
    enter_guidance: 'Bitte Guidance‑Skala eingeben',
    select_image: 'Bitte Bild auswählen.',
    image_prmt: 'Bild‑Prompt',
    generate_image_list_empty: 'Keine Bilder generiert!',
    knowledge_center_tooltrip_des:
      'Erhalte präzise und kontextbezogene Antworten auf verschiedene Fragen. Die Antworten basieren auf allgemein verfügbaren Internetquellen.',
    contexts: 'Kontexte',
    ai_processing_video_sharebot:
      'Die KI‑Verarbeitung des Videos kann bis zu 24 Stunden dauern und wird in Sharebot reflektiert.',
    remove_sharebot_video:
      'Wenn du den Sharebot‑Verweis entfernen möchtest, lösche bitte das zugehörige Transkript und das Video.',
    remove_sharebot_video_audio:
      'Das Löschen des Transkripts entfernt die Audioreferenz in Sharebot, das Video bleibt im Medien‑Ordner.',
    monthly_live_stream:
      'Um dein monatliches Live‑Streaming‑Limit zu ändern, kontaktiere bitte',
    monthly_transcribe_limit:
      'Um dein monatliches Transkriptions‑Limit zu ändern, kontaktiere bitte',
    must_be_one_to_three_hundred: 'Muss zwischen 1 und 300 Minuten liegen.',
    all_field_required: 'Alle Felder sind erforderlich.',
    duration_minute: 'Dauer (maximal 300 Minuten)',
    gender: 'Geschlecht',
    select_gender: 'Geschlecht auswählen',
    accent: 'Akzent',
    select_accent: 'Akzent auswählen',
    create_voice: 'Stimme erstellen',
    enter_voice_name: 'Stimmenname eingeben',
    select_voice_gender: 'Bitte Geschlecht der Stimme auswählen',
    upload_voice: 'Stimme hochladen',
    upload_voice_mp_three: 'Stimme hochladen (.mp3)',
    cloned_voice: 'Geklonte Stimmen',
    voice_type: 'Stimmenart',
    select_voice_type: 'Stimmenart auswählen',
    sharelook_stand: 'Standard',
    sharelook_premium: 'Premium',
    sharelook_custum_voice: 'Benutzerdefiniert (Voice Cloning)',
    create_auto_flow: 'Auto‑Flow erstellen',
    how_many_layers: 'Wie viele Ebenen',
    verify_selection: 'Auswahl verifizieren',
    uploaded_successful: 'Erfolgreich hochgeladen',
    upload_failed: 'Upload fehlgeschlagen',
    upload_only_five_mb: 'Inhalt hochladen (PDF‑Dateien, max. 5)',
    docs_from_org_library: 'Dokument aus Organisationsbibliothek verwenden',
    failed_maze_generate:
      'Fehler bei der Maze‑Generierung. Bitte versuche es erneut.',
    generate_metamaze: 'Metamaze wird generiert...',
    metamaze_being_generated:
      'Dein Metamaze wird erstellt. Du wirst per E‑Mail benachrichtigt, sobald es fertig ist.',
    metamaze_generate_successfully: 'Metamaze erfolgreich generiert!',
    metamaze_with_proceed: 'Du kannst jetzt mit dem Metamaze fortfahren.',
    ai_metamaze_generate: 'KI‑Metamaze Generierung',
    what_kind_maze_create: 'Welche Art von Maze möchtest du erstellen?',
    manual_metamaze_creation: 'Manuelle Metamaze‑Erstellung',
    manually_maze_customizing_scnario:
      'Metamaze manuell durch Szenario‑Anpassung erstellen',
    maze_ai_generated: 'Metamaze automatisch per KI generiert',
    unmark_deadend: 'Als Sackgasse markieren entfernen',
    mark_deadend: 'Als Sackgasse markieren',
    select_multiple_image_for_scenario:
      'Du kannst mehrere Bilder für das Szenario auswählen.',
    select_your_image: 'Deine ausgewählten Bilder',
    click_to_preview: 'Zum Vorschať draufklicken',
    are_you_sure_delete_image: 'Möchtest du dieses Bild wirklich löschen?',
    select_image_from_library: 'Bild aus Medienbibliothek auswählen',
    uploading_video: 'Video wird hochgeladen...',
    tree_node_type: 'Baumknotentyp',
    correct_option_scenario: 'Korrekte Option/Szenario',
    incorrect_option: 'Falsche Option',
    option_scenario_without_text: 'Option/Szenario ohne Text',
    dead_end: 'Sackgasse (roter Rahmen)',
    correct_path: 'Korrigierter Pfad',
    incorrect_path_not_selected_correct_option_path:
      'Falscher Pfad / Pfad bei nicht gewählter korrekter Option.',
    double_click_on_tree_node:
      'Ein Doppelklick auf einen Knoten scrollt den Editor automatisch an diesen Knoten heran.',
    add_scenario: 'Szenario hinzufügen',
    add_option: 'Option hinzufügen',
    an_error_occured: 'Ein Fehler ist aufgetreten:',
    download_summary: 'Zusammenfassung herunterladen',
    step_wise_analysis: 'Schritt‑für‑Schritt Analyse',
    step: 'Schritt',
    upload_csv_file: 'CSV‑Datei hochladen',
    download_template_to_import: 'Beispiel‑Vorlage zum Import herunterladen',
    please_input_email: 'Bitte E‑Mail eingeben.',
    email_at_least_three_characters:
      'E‑Mail muss mindestens 3 Zeichen lang sein.',
    email_cannot_be_empty: 'E‑Mail darf nicht leer sein.',
    input_email_in_new_line: 'Bitte E‑Mails eingeben (jeweils in neuer Zeile)',
    role: 'Rolle',
    select_role: 'Rolle auswählen',
    identification_number: 'Identifikationsnummer (optional)',
    add_identification_number: 'Bitte Identifikationsnummer hinzufügen',
    pie_chart_of_all_categories:
      'Kreisdiagramm aller Kategorien nach ihrer Nutzung in Sharelook.',
    total_sharesphere_question_answered_by_users:
      'Insgesamt von Nutzern in der aktuellen Organisation beantwortete ShareSphere‑Fragen, gegliedert nach Kategorien mit Erfolgs- und Fehlschlagsquoten.',
    voice_style_over_the_text:
      'Hier kannst du verschiedene Sprachstile über deinen Text verwenden. Lorem Ipsum ist der Standard‑Platzhaltertext seit den 1500ern.',
    input_your_question: 'Bitte deine Frage eingeben!',
    make_me_sales_manager: 'z. B.: Was kann mich zum Verkaufsleiter machen',
    enter_the_number_relevant_document:
      'Gib die Anzahl relevanter Dokumente ein',
    please_wait_loading_result: 'Bitte warten, Ergebnisse werden geladen…',
    no_result_found:
      'Keine Ergebnisse gefunden, versuche mehr oder andere Fragen.',
    browser_doesnot_support_iframes: 'Dein Browser unterstützt keine iframes',
    total_duration: 'Gesamtdauer',
    number_of_messages: 'Anzahl der Nachrichten',
    count_result: '(1244 Ergebnisse)',
    your_other_interests: 'Deine weiteren Interessen',
    your_total_score: 'Deine Gesamtpunktzahl',
    add_a_question: '+ Frage hinzufügen',
    travia_question_empty: 'Trivia‑Fragen‑Liste ist leer.',
    video_generation_is_on_queue:
      'Deine Videoerstellung ist in der Warteschlange!',
    checking_video_status: 'Video‑Status wird überprüft…',
    total_quizzes: 'Gesamtzahl der Quiz',
    number_of_votes: 'Anzahl der Stimmen',
    total_events: 'Gesamtzahl der Veranstaltungen',
    number_of_rates: 'Anzahl der Bewertungen',
    number_of_likes: 'Anzahl der Likes',
    all_courses: 'Alle Kurse',
    total_questions: 'Gesamtanzahl der Fragen',
    no_skill_journey: 'Keine Skill‑Journey verfügbar!',
    search_no_results: '- keine Ergebnisse verfügbar!',
    no_image_generated: 'Keine Bilder generiert!',
    all_topic_in_this_lesson:
      'Alle Themen in dieser Lektion werden gelöscht. Dies kann nicht rückgängig gemacht werden.',
    content_has_been_generated:
      'Für dieses Thema wurden bereits Inhalte generiert.',
    update_course_template: 'Kursvorlage aktualisieren',
    add_course_template: 'Kursvorlage hinzufügen',
    create_course_now: 'Jetzt Kurs erstellen',
    preview_course: 'Kursvorschau',
    layout: 'Layout',
    import_from_youtube: 'Von YouTube importieren',
    my_media_library: 'Meine Mediathek',
    bg_added: 'Hintergrund hinzugefügt',
    add_bg: 'Hintergrund hinzufügen',
    booked_schedule: 'Gebuchter Zeitplan',
    add_schedule: 'Zeitplan hinzufügen',
    are_you_delete_schedule: 'Möchtest du diesen Zeitplan wirklich löschen?',
    add_task: 'Aufgabe hinzufügen',
    update_calender: 'Kalender aktualisieren',

    exit_fullscreen: 'Vollbild beenden',
    bg_image: 'Hintergrundbild',
    introduction: 'Einführung',
    summary: 'Zusammenfassung',
    generate_introduction: 'Einführung generieren',
    generate_summary: 'Zusammenfassung generieren',
    bullet_points: 'Stichpunkte',
    title_simulation: 'Bitte Simulationstitel eingeben',
    view_generated_images: 'Generierte Bilder anzeigen',
    image_transparency: 'Bildtransparenz',
    template_bg_color: 'Vorlagen‑Hintergrundfarbe',
    select_template_layout: 'Vorlagenlayout auswählen',
    reload_template: '(Vorlagen neu laden)',
    are_you_sure_want_close: 'Möchtest du das wirklich schließen?',
    all_your_changes_will_be_lost: 'Alle deine Änderungen gehen verloren.',
    please_checked_before_generated_video:
      'Bitte bestätige alle Bedingungen, bevor das Video generiert wird.',
    voice_must_be_selected: 'Eine Stimme muss ausgewählt werden',
    avatar_must_be_selected: 'Ein Avatar‑Bild muss ausgewählt werden.',
    maximum_five_slides_try_again:
      'Fehler beim Extrahieren der Bilder. Stelle sicher, dass maximal 5 Folien mit Notizen vorhanden sind. Bitte versuche es erneut!',
    back_to_upload: 'Zurück zum Hochladen',
    uploading_file_to_server: 'Datei wird auf den Server hochgeladen',
    extracting_images_from_your_file:
      'Bilder aus deiner Datei werden extrahiert',
    upload_your_ppt_or_drag:
      'Lade deine Präsentation (.PPTX) hoch oder ziehe sie hierher.',
    maximum_five_slides_error:
      'Bitte stelle sicher, dass deine PowerPoint-Datei maximal 5 Folien enthält und in jeder Folie Notizen vorhanden sind. Andernfalls tritt ein Fehler auf.',
    number_of_questions_generated: 'Anzahl der zu generierenden Fragen',
    quiz_page_this_cannot_be_done:
      'Möchtest du das Quiz dieser Seite hinzufügen? Das kann nicht rückgängig gemacht werden.',
    confirm_selection: 'Auswahl bestätigen',
    select_quiz_page: 'Quiz‑Seite auswählen',
    lesson_do_you_want_add_this_quiz:
      'An welcher Stelle der Lektion möchtest du das Quiz hinzufügen?',
    beginning_of_lesson: 'Am Anfang der Lektion',
    end_of_lesson: 'Am Ende der Lektion',
    currently_active_page: 'Derzeit aktive Seite',
    finish: 'Fertig',
    upload_selection_file: 'Abschnittsdatei hochladen',
    general_quiz: 'Allgemeines Quiz',
    manage_cookies: 'Cookies verwalten',
    cookie_banner_text:
      'Wir verwenden Cookies, um dein Erlebnis zu verbessern, den Website‑Verkehr zu analysieren und Inhalte zu personalisieren. Deine Privatsphäre ist uns wichtig.',
    accept_all_cookies: 'Alle Cookies akzeptieren',
    reject_all: 'Alle ablehnen',
    customize: 'Anpassen',
    cookie_preferences_title: 'Cookie‑Einstellungen & Datenschutz',
    privacy_subtitle:
      'Deine Privatsphäre ist uns wichtig. Wähle, mit welchen Cookies du einverstanden bist. Du kannst diese Einstellungen jederzeit ändern.',
    save_choices: 'Meine Auswahl speichern',
    strictly_necessary: 'Unbedingt erforderlich',
    strictly_necessary_desc:
      'Diese Cookies sind für die grundlegende Funktion der Website unerlässlich. Sie ermöglichen Kernfunktionen wie Navigation, Formularübermittlung und Zugriff auf gesicherte Bereiche. Ohne sie ist die Nutzung nicht möglich.',
    analytics_performance: 'Analyse & Performance',
    analytics_performance_desc:
      'Diese Cookies helfen uns, zu verstehen, wie Besucher unsere Website nutzen, indem sie anonym Informationen sammeln und melden. So können wir die Website‑Performance und das Nutzererlebnis verbessern.',
    advertising_marketing: 'Werbung & Marketing',
    advertising_marketing_desc:
      'Diese Cookies sorgen dafür, dass Werbebotschaften relevanter sind, verhindern wiederholte Anzeigen und stellen eine ordnungsgemäße Darstellung für Werbetreibende sicher.',
    tracking_social: 'Tracking & Soziale Medien',
    tracking_social_desc:
      'Diese Cookies ermöglichen erweiterte Funktionen und Personalisierung, z. B. durch Social‑Media‑Features und personalisierte Inhalte. Sie können von uns oder Drittanbietern gesetzt werden.',
    functional: 'Funktional',
    functional_desc:
      'Diese Cookies ermöglichen erweiterte Funktionen wie Chat‑Support, Live‑Hilfe und andere interaktive Features zur Verbesserung deines Erlebnisses.',
    your_rights: 'Deine Rechte:',
    rights_description:
      'Du kannst deine Zustimmung jederzeit widerrufen, Zugriff auf deine Daten verlangen oder ihre Löschung beantragen.',
    withdraw_consent: 'Zustimmung vollständig widerrufen',

    how_many_options: 'Wie viele Optionen',
    add_content: 'Inhalt hinzufügen',
    downloads_center: 'Download-Center',
    sharelook_help_center: 'Sharelook-Hilfezentrum',
    channel_outline: 'Kanalübersicht',
    channel_objectives: 'Kanalziele',
    no_sop_available: 'Keine SOP-Liste verfügbar.',
    generate_world_summary: 'Szenario generieren',
    world_scenario: 'Reale Welt-Szenario',
    drag_icon_hint:
      'Tipp: Ziehen Sie das Symbol auf die Leinwand, um es zu positionieren',
    drag_text_hint:
      'Tipp: Ziehen Sie den Text auf die Leinwand, um ihn zu positionieren',
    edit_badge: 'Abzeichen bearbeiten',
    create_new_badge: 'Neues Abzeichen',
    select_video_preview: 'Wählen Sie ein Video zur Vorschau aus',
    certificate_title_required: 'Zertifikatstitel ist erforderlich',
    discard_changes: 'Änderungen verwerfen',
    edit_certificate: 'Zertifikat bearbeiten',
    add_another_logo: 'Weiteres Logo hinzufügen',
    optional: 'Optional',
    doc: 'DOC',
    ppt: 'PPT',
    quest_title: 'Neue Quest erstellen',
    quest_filter_title: 'Quest',
    sharelook_assistance: 'Sharelook-Coaching',
    upload_scorm_zip: 'SCORM-Zip hochladen',
    only_letters_numbers_space_dot_allowed:
      'Nur Buchstaben, Zahlen, Leerzeichen und Punkte sind erlaubt!',
    video_playing: 'Wird abgespielt',
    course_price_message: `*Der Kurs wird nur für Benutzer innerhalb der Organisation veröffentlicht und kann nicht auf dem Marktplatz weiterverkauft werden.`,
    lesson_must_be_positive: 'Die Anzahl der Lektionen muss größer als 1 sein',
    btn_proceed: 'Fortfahren',
    rule_select_music: 'Bitte Musik auswählen',
    course_info: 'Kursinformationen',
    content_selection: 'Inhaltsauswahl',
    course_content_source: 'Kursinhalt-Quelle',
    choose_how_to_source:
      'Wählen Sie, wie Sie Inhalte für diesen Kurs beziehen möchten:',
    automatic_selection: 'Automatische Auswahl',
    system_will_automatically_select_relavant_documents:
      'Das System wählt automatisch relevante Dokumente aus Ihrer Bibliothek aus',
    manual_selection: 'Manuelle Auswahl',
    choose_specific_documents_from_your_library:
      'Wählen Sie bestimmte Dokumente aus Ihrer Bibliothek aus',
    upload_files: 'Dateien hochladen',
    upload_new_documents:
      'Neue Dokumente hochladen (PDF, DOC, DOCX, PPT, PPTX, TXT) – maximal 5 Dateien',
    file: 'Datei',
    ready_to_upload: 'bereit zum Hochladen',
    clear_all: 'Alles löschen',
    confirm_course_wide_premiew: 'Kursweite Vorschau bestätigen',
    generate_course_preview: 'Kursvorschau generieren',
    instructions_across_the_course_to_generate:
      'Wir wenden Ihre Anweisungen auf den gesamten Kurs an, um eine Vorschau zu generieren. Überprüfen Sie alles, bevor Sie Änderungen speichern oder verwerfen.',
    instruction_to_preview_course_wide:
      'Anweisungen für die kursweite Vorschau:',
    edit_content: 'Inhalt bearbeiten',
    manage_course_template: 'Kursvorlage verwalten',
    undo: 'Rückgängig machen',
    apply_changes: 'Änderungen übernehmen',
    characters: 'Zeichen',
    apply_all: 'Alle anwenden',
    apply_to_all: 'Auf alle anwenden',
    use_this_content: 'Diesen Inhalt verwenden',
    original: 'Original',
    edited: 'Bearbeitet',
    edited_content_preview: 'Vorschau des bearbeiteten Inhalts',
    apply_edits_to_all_topices: 'Bearbeitungen auf alle Themen anwenden?',
    current_editing_instructions_across_the_whole_course:
      'Dies wendet Ihre aktuellen Bearbeitungsanweisungen auf den gesamten Kurs an. Sie können die kombinierte Vorschau vor dem Speichern überprüfen.',
    edit_content_instructions: 'Bearbeitungsanweisungen für den Inhalt',
    generate_content_for_this_topic_instruction:
      'Inhalt für dieses Thema anhand Ihrer Anweisungen generieren',
    descrip_edit_content:
      'Beschreiben Sie, wie dieser Inhalt bearbeitet werden soll (z. B. kürzen, vereinfachen, umformulieren)',
    try_short_clear_direcctives: `Versuchen Sie kurze, klare Anweisungen. Beispiele: „auf 100 Wörter kürzen, Hauptpunkte behalten“, „Sprache vereinfachen“, „prägnanter machen und Füllwörter entfernen“.`,
    we_preserve_the_core_meaning:
      'Wir bewahren die Kernbedeutung, während wir Ihre Anweisungen anwenden.',
    feedback_optional: 'Feedback (optional)',
    write_your_feedback_here: 'Schreiben Sie Ihr Feedback hier',
    from_web: 'Aus dem Web',
    from_desktop: 'Vom Desktop',
    pleae_wait_processing: 'Bitte warten, Verarbeitung läuft...',
    create_simulation_from_screen_capture:
      'Simulation aus Bildschirmaufnahme erstellen',
    sharelook_not_found: 'ShareLook nicht gefunden',
    sharelook_screen_capture_application_not_be_opened:
      'Die ShareLook-Bildschirmaufnahmeanwendung konnte nicht geöffnet werden. Möglicherweise ist sie nicht auf Ihrem Computer installiert.',
    download_sharelook: 'ShareLook herunterladen',
    launch_sharelook_application: 'ShareLook-Anwendung starten',
    this_will_open_the_sharelook_application_for_screen_capture:
      'Dadurch wird die ShareLook-Anwendung für die Bildschirmaufnahme geöffnet.',
    sharelook_dosenot_open:
      'Wenn ShareLook nicht geöffnet wird, ist es möglicherweise nicht installiert.',
    open_sharelook: 'ShareLook öffnen',
    download_app: 'App herunterladen',
    background_image_setting: 'Hintergrundbildeinstellungen',
    current_image: 'Aktuelles Bild',
    change_image: 'Bild ändern',
    remove_image: 'Bild entfernen',
    no_background_image_selected: 'Kein Hintergrundbild ausgewählt',
    add_image: 'Bild hinzufügen',
    this_will_open_for_screen_recording:
      'Dadurch wird die ShareLook-Anwendung für die Bildschirmaufnahme geöffnet.',
    ai_image_generation: 'KI-Bilderzeugung',
    image_edit: 'Bildbearbeitung',
    text_to_image: 'Text zu Bild',
    output_gallary: 'Ausgabegalerie',
    instant_generation: 'Bereit für sofortige Erstellung',
    prompt_and_unleash_the_power:
      'Geben Sie Ihre Eingabeaufforderung ein und entfesseln Sie die Kraft',
    use_this_image: 'Dieses Bild verwenden',
    error_generating: 'Fehler bei der Generierung.',
    generation_tips: 'Generierungstipps',
    detailed_descriptions_for_more_accurate_results:
      'Verwenden Sie detaillierte Beschreibungen für genauere Ergebnisse',
    reference_image: 'Referenzbild',
    select_pixel_image: 'Pixelbild auswählen',
    max_mb: 'Max. 50 MB',
    please_enter_text_to_appear_image:
      'Bitte geben Sie den Text ein, der im Bild erscheinen soll',
    enter_text_to_apear_in_the_image:
      'Text eingeben, der im Bild erscheinen soll',
    generate_image: 'Bild generieren',
    prompt_assistant: 'Prompt-Assistent',
    generate_image_using_suggested_prompt:
      'Bild mit vorgeschlagenem Prompt generieren',
    talk_to_ai_about_the_image_generate:
      'Sprechen Sie mit der KI über das zu generierende Bild',
    ask_for_prompt_suggestions: 'Nach Prompt-Vorschlägen fragen...',
    enter_a_search_term_to_find_stock_images:
      'Geben Sie einen Suchbegriff ein, um Stockbilder zu finden',
    choose_your_content_source: 'Wählen Sie Ihre Inhaltsquelle:',
    upload_new_document_from_your_device:
      'Neue Dokumente von Ihrem Gerät hochladen',
    automatic_library_selection: 'Automatische Bibliotheksauswahl',
    system_automatically_selects_relevant_document:
      'Das System wählt automatisch relevante Dokumente aus',
    manual_library_selection: 'Manuelle Bibliotheksauswahl',
    generate_content: 'Inhalt generieren',
    add_to_current_page: 'Zur aktuellen Seite hinzufügen',
    generate_bullet_points: 'Stichpunkte generieren',
    generating: 'Wird generiert',
    this_may_take_a_few_moments: 'Dies kann einige Momente dauern',
    apply_to_page: 'Auf Seite anwenden',
    scenario_escription: 'Szenariobeschreibung:',
    feedback: 'Feedback',
    form_mode: 'Formularmodus',
    chat_mode: 'Chatmodus',
    this_will_generate_a_continuation_of_the_seleccted_story:
      'Dadurch wird eine Fortsetzung der ausgewählten Geschichte mit KI generiert.',
    continue_this_story_question: 'Diese Geschichte fortsetzen?',
    continue_this_story: 'Diese Geschichte fortsetzen',
    what_will_happen: 'Was wird passieren:',
    the_ai_will_analyze_the_existing_story_content:
      'Die KI analysiert den vorhandenen Geschichtsinhalt',
    generate_a_natural_continuation_that_follows_the_same_tone:
      'Erzeugt eine natürliche Fortsetzung mit demselben Ton und Stil',
    create_new_content_that_build_upon_the_current_narrative:
      'Erstellt neuen Inhalt, der auf der aktuellen Erzählung aufbaut',
    this_process_may_take_a_few_moments_to_complete:
      'Dieser Vorgang kann einige Momente dauern.',
    no_existing_stories_found_for_this_course:
      'Keine vorhandenen Geschichten für diesen Kurs gefunden.',
    create_your_first_story: 'Erstellen Sie Ihre erste Geschichte',
    existing_stories: 'Vorhandene Geschichten',
    create_new_story: 'Neue Geschichte erstellen',
    tone: 'Ton',
    style: 'Stil',
    genre: 'Genre',
    loading_your_stories: 'Ihre Geschichten werden geladen...',
    edit_story: 'Geschichte bearbeiten',
    story_preferences: 'Geschichten-Einstellungen',
    please_input_your: 'Bitte geben Sie Ihre(n)',
    add_character_names_and_press_enter:
      'Fügen Sie Charakternamen hinzu und drücken Sie Enter',
    select_or_type_your: 'Wählen oder geben Sie Ihre(n)',
    enter_your: 'Geben Sie Ihre(n)',
    position_of_the_story_in_the_lesson:
      'Die Position der Geschichte in der Lektion. Sie wird als Block an der angegebenen Position hinzugefügt.',
    save_previous_content_on_the_pages: 'Vorherigen Seiteninhalt speichern',
    the_existing_content_in_the_selected_pages:
      'Der vorhandene Inhalt der ausgewählten Seiten wird durch die generierte Geschichte ersetzt.',
    real_world_scenario: 'Reales Szenario',
    add_optional_instructions:
      'Optionale Anweisungen hinzufügen (Ton, Länge, Zielgruppe usw.)',
    ready_to_enerate_your_real_world_scenario:
      'Bereit, Ihr reales Szenario zu generieren',
    click_generate_real_world_scenario_to_create_a_realistic_scenario:
      'Klicken Sie auf „Reales Szenario generieren“, um ein realistisches Szenario basierend auf Ihrem Unterrichtsinhalt zu erstellen.',
    the_ai_will_analyze_your_lesson_topic_and_content:
      'Die KI analysiert Ihr Unterrichtsthema und den Inhalt',
    generate_a_practical_real_world_scenario:
      'Ein praktisches, reales Szenario generieren',
    you_can_then_edit_and_customize_the_result:
      'Sie können das Ergebnis anschließend bearbeiten und anpassen',
    add_it_as_a_new_page_to_your_lesson:
      'Fügen Sie es als neue Seite zu Ihrer Lektion hinzu',
    regenerate_with_instructions: 'Mit Anweisungen neu generieren',
    add_real_world_scenario: 'Reales Szenario hinzufügen',
    generate_real_world_scenario: 'Reales Szenario generieren',
    simulation_has_been_stopped: 'Simulation wurde gestoppt!',
    loading_simulation: 'Simulation wird geladen...',
    you_have_exhausted_all_the_attempts: 'Sie haben alle Versuche ausgeschöpft',
    study_the_scenario_on_this_page_and_select_the_correct_answer:
      'Studieren Sie das Szenario auf dieser Seite und wählen Sie unten die richtige Antwort aus.',
    attempts_limit_reached:
      'Versuchslimit erreicht. Sie können erneut spielen, aber Ihre Punktzahl wird nicht gespeichert.',
    play_again: 'Erneut spielen',
    import_music_from_computer: 'Musik vom Computer importieren.',
    more: 'mehr',
    no_badge_yet: 'Noch keine Abzeichen',
    competition_filter: 'Wettbewerbsfilter',
    global_leaderboard: 'Globale Bestenliste',
    placeholder_for_the_global_leaderboard:
      'Dies ist ein Platzhalter für die globale Bestenliste.',
    badge_editor: 'Abzeichen-Editor',
    adjust_the_appearance_of_this_badge_icon:
      'Passen Sie das Erscheinungsbild dieses Abzeichens an. Die Änderungen gelten nur für dieses Abzeichen.',
    badge_style: 'Abzeichenstil',
    the_image_must_be_pixels: 'Das Bild muss 200×200 Pixel groß sein.',
    badge_name: 'Abzeichenname',
    badge_descrription: 'Abzeichenbeschreibung',
    enter_badge_criteria: 'Abzeichenkriterien eingeben',
    discard: 'Verwerfen',
    badge_enable: 'Abzeichen aktiviert',
    award_users_with_badges_to_highlight_the_milestones:
      'Vergeben Sie Abzeichen, um Meilensteine in der Lernreise der Benutzer hervorzuheben.',
    badge_types: 'Abzeichenarten',
    enable_or_disable_specific_badge_types_for_your_users:
      'Aktivieren oder deaktivieren Sie bestimmte Abzeichenarten für Ihre Benutzer.',
    levels_enabled: 'Level aktiviert',
    level_rules: 'Levelregeln',
    points: 'Punkte',
    add_new_level: 'Neues Level hinzufügen',
    add_level: 'Level hinzufügen',
    points_enabled: 'Punkte aktiviert',
    learning_activities_and_encourage_healthy_competition:
      'Belohnen Sie Benutzer mit Punkten für Lernaktivitäten und fördern Sie gesunden Wettbewerb.',
    award_points: 'Punkte vergeben',
    the_following_equates_the_value_of_one_item_completion:
      'Folgendes entspricht dem Wert des Abschlusses eines Elements',
    general: 'Allgemein',
    others: 'Andere',
    certificate: 'Zertifikat',
    quiz_passed: 'Quiz bestanden',
    tip_approved: 'Tipp genehmigt',
    tip_liked: 'Tipp gemocht',
    rewards: 'Belohnungen',
    offer_discounts_when_learners_achieve:
      'Bieten Sie Rabatte an, wenn Lernende eine bestimmte Anzahl von Punkten, Abzeichen oder Levels erreichen.',
    give_rewards: 'Belohnungen vergeben',
    discount_course_purchases_by: 'Kauf von Kursen rabattieren um',
    with_points_more_than: 'mit mehr als Punkten',
    with_badges_more_than: 'mit mehr als Abzeichen',
    with_level_upwards_more_than: 'mit Level größer als',
    leaderboard: 'Bestenliste',
    leaderboard_enabled: 'Bestenliste aktiviert',
    leaderboards_offer_users_an_overview_of_their_learning_progress:
      'Bestenlisten geben Benutzern einen Überblick über ihren Lernfortschritt im Vergleich zu anderen.',
    show_levels: 'Level anzeigen',
    show_points: 'Punkte anzeigen',
    show_badges: 'Abzeichen anzeigen',
    show_courses: 'Kurse anzeigen',
    show_certificates: 'Zertifikate anzeigen',
    leaderboard_settings: 'Bestenlisten-Einstellungen',
    set_up_engaging_leaderboard_experiences_to_boost_learner_motivation:
      'Richten Sie ansprechende Bestenlisten ein, um die Lernmotivation zu steigern.',
    award_users_with_points_for_different_learning_activities:
      'Belohnen Sie Benutzer mit Punkten für verschiedene Lernaktivitäten.',
    badge_set: 'Abzeichensatz',
    choose_the_type_of_badges_your_users:
      'Wählen Sie die Art der Abzeichen, die Ihre Benutzer beim Lernen verdienen.',
    levels: 'Level',
    Levels_represent_the_stages:
      'Level repräsentieren die Phasen der Lernreise eines Benutzers.',
    enabled: 'Aktiviert',
    disabled: 'Deaktiviert',
    quick_select: 'Schnellauswahl',
    yesterday: 'Gestern',
    last_week: 'Letzte Woche',
    Last_month: 'Letzter Monat',
    last_quarter: 'Letztes Quartal',
    historical_leaderboard: 'Historische Bestenliste',
    track_your_performance_and_see_how_you_rank_among_your_peers:
      'Verfolgen Sie Ihre Leistung und sehen Sie, wie Sie im Vergleich zu Ihren Kollegen abschneiden',
    time_period: 'Zeitraum',
    page_of: 'Seite 1 von 1',
    edit_competition: 'Wettbewerb bearbeiten',
    create_competition: 'Wettbewerb erstellen',
    arrow_right: 'Pfeil-rechts',
    update_competition: 'Wettbewerb aktualisieren',
    competition_title: 'Wettbewerbstitel',
    enter_competition_title: 'Wettbewerbstitel eingeben',
    enter_competition_description: 'Wettbewerbsbeschreibung eingeben',
    leaderboard_skill: 'Fähigkeit',
    select_a_skill: 'Fähigkeit auswählen',
    no_skills_found: 'Keine Fähigkeiten gefunden',
    competition_period: 'Wettbewerbszeitraum',
    add_badge_rule: 'Abzeichenregel hinzufügen',
    create_badge: 'Abzeichen erstellen',
    add_level_rule: 'Levelregel hinzufügen',
    selected_participants: 'Ausgewählte Teilnehmer',
    no_participants: 'Keine Teilnehmer',
    start_end_date: 'Start–Enddatum',
    created_date: 'Erstellt von',
    new_competition: 'Neuer Wettbewerb',
    competitions_list: 'Wettbewerbsliste',
    search_competitions: 'Wettbewerbe suchen...',
    are_you_sure_you_want_to_delete_the_competition:
      'Sind Sie sicher, dass Sie den Wettbewerb löschen möchten?',
    history: 'Verlauf',
    export: 'Exportieren',
    search_by_name: 'Nach Name suchen...',
    no_historical_data_available_for_the_selected_period:
      'Keine historischen Daten für den ausgewählten Zeitraum verfügbar.',
    no_leaderboard_data_available: 'Keine Bestenlistendaten verfügbar.',
    competitions: 'Wettbewerbe',
    leaderboards: 'Bestenlisten',
    welcome_back: 'Willkommen zurück',
    track_your_performance_and_see:
      'Verfolgen Sie Ihre Leistung und sehen Sie, wie Sie im Vergleich zu Ihren Kollegen abschneiden',
    team_leaderboard: 'Team-Bestenliste',
    try_again: 'Erneut versuchen',
    no_competitions_for_search: 'Keine Wettbewerbe verfügbar für',
    no_competitions_available: 'Keine Wettbewerbe verfügbar',
    no_competitions_matching_search:
      'Keine Wettbewerbe gefunden, die Ihrer Suche entsprechen. Passen Sie Ihre Suchbegriffe an oder versuchen Sie es später erneut.',
    no_competitions_general:
      'Derzeit sind keine Wettbewerbe eingerichtet. Versuchen Sie es später erneut oder wenden Sie sich an Ihren Administrator, um neue Wettbewerbe zu erstellen.',
    media_management: 'Medienverwaltung',
    badgess_set: 'Abzeichensatz',
    choose_the_default_visual_style_for_badge:
      'Wählen Sie den Standardstil für Abzeichen, die plattformweit verwendet werden.',
    enable_badges: 'Abzeichen aktivieren',
    add_badge: 'Abzeichen hinzufügen',
    min: 'Min',
    max: 'Max',
    your_rank: 'Dein Rang',
    your_points: 'Deine Punkte',
    your_level: 'Dein Level',
    rank: 'Rang #',
    level: 'Level',
    progress: 'Fortschritt',
    new_folder: 'Neuer Ordner',
    file_upload: 'Datei-Upload',
    writer: 'Textverarbeitung',
    text_documents: 'Textdokumente',
    spreadsheets: 'Tabellenkalkulationen',
    impress: 'Präsentationsprogramm',
    presentations: 'Präsentationen',
    capture_desktop_screen: 'Desktop-Bildschirm aufnehmen',
    capture_desktop_screens: 'Desktop-Bildschirme aufnehmen',
    your_documents: 'Deine Dokumente',
    manage_your_videos_images_audio_files:
      'Verwalte deine Videos, Bilder, Audiodateien und andere Medien, die du für deine Inhaltserstellung verwendest.',
    your_organization_documents: 'Dokumente deiner Organisation',
    keep_your_organization_creative_assets_organized:
      'Halte die kreativen Ressourcen deiner Organisation organisiert und zugänglich – optimiere Teamarbeit und Content-Produktion.',
    your_public_documents: 'Deine öffentlichen Dokumente',
    curated_collection_of_media_assets_available:
      'Eine kuratierte Sammlung von Mediendateien, die für alle verfügbar ist – entdecke, verwende wieder und kreiere Neues.',
    your_download_center_documents: 'Deine Downloadcenter-Dokumente',
    repository_of_approved_media_assets_for_download:
      'Ein Repository mit freigegebenen Mediendateien zum Herunterladen und Verwenden in deinen Projekten.',
    search_files_and_folders: 'Dateien und Ordner suchen…',
    home: 'Startseite',
    folders: 'Ordner',
    folder_name: 'Ordnername',
    owner: 'Eigentümer',
    last_updated: 'Zuletzt aktualisiert',
    action: 'Aktion',
    no_folders_found: 'Keine Ordner gefunden',
    files: 'Dateien',
    enabling_ai: 'KI wird aktiviert…',
    rename: 'Umbenennen',
    copy: 'Kopieren',
    move: 'Verschieben',
    verson_history: 'Versionsverlauf',
    manage_permission: 'Berechtigungen verwalten',
    generate_audit_report: 'Prüfbericht erstellen',
    last_edited: 'Zuletzt bearbeitet',
    no_files_found: 'Keine Dateien gefunden',
    are_you_sure_you_want_to_make_this_item_public:
      'Bist du sicher, dass du dieses Element öffentlich machen möchtest? Es wird in deine öffentliche Bibliothek kopiert.',
    move_to_organization: 'In die Organisation verschieben',
    are_you_sure_you_want_to_copy_this_item_to_your_organization_library:
      'Bist du sicher, dass du dieses Element in die Bibliothek deiner Organisation kopieren möchtest?',
    are_you_sure_you_want_to_make_this_item_private:
      'Bist du sicher, dass du dieses Element privat machen möchtest? Es wird in deine eigene Bibliothek kopiert.',
    date_modified: 'Änderungsdatum',
    workflow_management: 'Workflow-Management',
    configure_editors_approvers_and_viewers_for_this_document:
      'Konfiguriere Bearbeiter, Genehmiger und Betrachter für dieses Dokument.',
    error_Loading_editor: 'Fehler beim Laden des Editors',
    debug_info: 'Debug-Informationen',
    loading_editor: 'Editor wird geladen…',
    submitted_for_review: 'Zur Überprüfung eingereicht',
    editors: 'Bearbeiter',
    no_editors_added_yet:
      'Noch keine Bearbeiter hinzugefügt. Klicke auf "Bearbeiter hinzufügen", um einen hinzuzufügen.',
    add_editor: 'Bearbeiter hinzufügen',
    approvers: 'Genehmiger',
    no_approvers_added_yet:
      'Noch keine Genehmiger hinzugefügt. Klicke auf "Genehmiger hinzufügen", um einen hinzuzufügen.',
    add_approvers: 'Genehmiger hinzufügen',
    viewer: 'Betrachter',
    no_viewers_added_yet:
      'Noch keine Betrachter hinzugefügt. Klicke auf "Betrachter hinzufügen", um einen hinzuzufügen.',
    add_viewer: 'Betrachter hinzufügen',
    are_you_sure_you_want_to_delete_the_selected_items:
      'Bist du sicher, dass du die ausgewählten Elemente löschen möchtest?'
  },
  v3: {
    reportShareSphere: 'SHARESPHERE',
    overview: 'Kategorie Übersicht',
    triviaReport: 'ShareSphere Kategorie',
    overviewGraph: 'Kategorieübersicht Diagramm',
    category: 'Kategorie',
    phCategory: 'Kategorie auswählen',
    podcast: 'Podcast und Musik',
    pastPodcast: 'Ältere Podcasts',
    upcomingPodcast: 'Kommende Podcasts',
    podcastLanguageTitle: 'Podcast Sprache',
    podcastLanguageCheckbox: 'Generiere Audio für meinen Podcast mithilfe KI',
    howRate: 'Wie würden Sie diesen Podcast bewerten?',
    podcastSubmit: 'Absenden',
    podcastGuest: 'Gastsprecher',
    podcastReview: 'Bewertungen',
    podcastEpishode: 'Episoden',
    podcastEnd: 'Podcast hat geendet',
    date_podcast: 'Podcast Datum',
    skill_not_found: 'Entschuldigung ! Keine Fähigkeitsreise wurde gefunden.',
    coaching: 'Coaching',
    webinar: 'Webinar',
    public_conference: 'Öffentliche Konferenz',
    skill_journey_subtitle:
      'Fügen Sie Einstellungen zu Ihrer Fähigkeitsreise hinzu und wählen Sie aus, wer Ihre Fähigkeitsreise sehen und mit ihr interagieren kann.',
    enable_white_label: 'White Label aktivieren',
    create_new_event_org: 'Neues Event für Ihre Organisation erstellen.',
    create_new_event_marketplace: 'Neues Event für den Marktplatz erstellen.',
    create_new_event_both:
      'Neues Event für sowohl den Marktplatz als auch Ihre Organisation erstellen.',
    event_outline: 'Bitte Event Kurzübersicht einfügen',
    event_obj: 'Bitte Eventziele einfügen',
    event_description: 'Bitte Eventbeschreibung einfügen',
    create_new_metamaze_org: 'Neues MetaMaze für Ihre Organisations erstellen.',
    create_new_metamaze_marketplace:
      'Neues MetaMaze für den Marktplatz erstellen.',
    create_new_metamaze_both:
      'Neues MetaMaze für sowohl den Marktplatz als auch Ihre Organisation erstellen.',
    add_key_words: 'Keywords hinzufügen',
    press_enter_make_keyword:
      'Drücken Sie die Enter, um ein Keyword zu erstellen',
    disable_skip_quiz: 'Quiz überspringen deaktivieren',
    warning_complete_quiz: 'Bitte absolvieren Sie das Quiz, um fortzufahren.',
    signup_email_verification:
      'Wir haben einen Bestätigungslink an die von Ihnen angegebene E-Mail-Adresse gesendet. Bitte besuchen Sie den Link, um Ihre Registrierung zu bestätigen..',
    verifying_registration: 'Kontoanmeldung wird verifiziert...',
    reset_password_linK:
      'Wir haben einen Link an die von Ihnen angegebene E-Mail-Adresse gesendet. Bitte besuchen Sie diesen Link, um ein neues Passwort festzulegen.',
    reset_email_error:
      'Benutzer mit dieser E-Mail nicht gefunden, bitte versuchen Sie es stattdessen mit dem Benutzernamen!',
    first_name: 'Vorname',
    last_name: 'Nachname',
    error_firstName: 'Bitte geben Sie Ihren Vornamen ein',
    error_sharebot_organization: 'Bitte geben Sie Ihre Organisation ein',
    error_lastName: 'Bitte geben Sie Ihren Nachnamen ein',
    private_conference: 'Private Konferenz',
    discussion_room: 'Diskussionsraum',
    training_no_courses: 'Sie sind derzeit in keine Kurse eingeschrieben.',
    training_no_events:
      'Sie sind derzeit in keine Veranstaltungen eingeschrieben.',
    allow_sharing_trainer_info:
      'Erlauben Sie das Teilen der E-Mail-Adresse im Marktplatz',
    error_username_space: 'Benutzername darf keine Leerzeichen enthalten.',
    error_sharebot_organization_space:
      'Organisation darf keine Leerzeichen enthalten.',
    edit_permission: 'Bearbeitungsberechtigung',
    valid_price: 'Der Preis muss größer als 0 sein',
    course_price_message:
      '*Der Kurs wird nur an die Anzahl der Benutzer veröffentlicht, die die Organisation gekauft hat, und kann nicht auf dem Marktplatz weiterverkauft werden.',
    valid_edit_price:
      'Preis für die Bearbeitung muss geringer sein als der Kaufpreis.',
    my_calendar: 'Mein Kalender',
    error_valid_firstName: 'Bitte geben Sie einen gültigen Vornamen ein.',
    error_valid_organization:
      'Bitte geben Sie einen gültigen Organisationsnamen ein.',
    error_valid_lastName: 'Bitte geben Sie einen gültigen Nachnamen ein.',
    error_name_spaces: 'Name darf keine Leerzeichen enthalten.',
    items: 'Artikel',
    publish_to_channel: 'In meiner Kanal Kollektion veröffentlichen',
    create_a_channel: 'Meinen Kanal erstellen',
    create_a_trivia: 'Trivia erstellen',
    create_a_new_channel: 'Einen neuen Kanal erstellen',
    add_videos: 'Videos hinzufügen',
    save_and_continue: 'Speichern und Fortfahren',
    channel: 'Kanal',
    channels: 'Kanäle',
    view_channel: 'Kanal anzeigen',
    edit_channel: 'Kanal bearbeiten',
    delete_channel: 'Kanal löschen',
    my_video_channels: 'Meine Videokanäle',
    training_no_channel: 'Sie sind derzeit in keinen Kanal eingeschrieben.',
    monthly_price_required: 'Monatspreis erforderlich',
    yearly_price_required: 'Jahrespreis erforderlich',
    one_time_price_required: 'Einmaliger Preis erforderlich',
    marketplace_quantity: 'USD',
    report_webinar: 'WEBINAR',
    report_coaching: 'COACHING',
    report_channel: 'KANAL',
    report_public_conference: 'ÖFFENTLICHE KONFERENZ',
    report_maze: 'MAZE',
    edit_price: 'Preis bearbeiten ($)',
    quantity: 'Menge',
    payment_type: 'Zahlungsart',
    total_amount: 'Gesamtbetrag ($)',
    net_amount: 'Nettobetrag ($)',
    edit_option: 'Bearbeitungsoption',
    marketplace_price: 'Preis ($)',
    market_name: 'Name',
    duration_min: 'Dauer (Min)',
    users_total: 'Benutzer (Insgesamt)',
    sales_total: 'Verkaufsgesamtbetrag (USD)',
    search_coaching: 'Coaching suchen',
    search_channel: 'Kanal suchen',
    search_webinar: 'Webinar suchen',
    search_maze: 'Maze suchen',
    search_public_conference: 'Öffentliche Konferenz suchen',
    buyer_type: 'Käufertyp',
    quanity: 'Menge',
    channel_unit_amount: 'Nettobetrag ($)',
    channel_updated_at: 'Aktualisierungsdatum',
    month_price: 'Preis (Monat)',
    year_price: 'Preis (Jahr)',
    one_time_price: 'Preis (Einmalig)',
    sharebot_organization: 'Neuen Organisationsnamen hinzufügen',
    share_sphere: 'ShareSphere',
    ai_course_title: 'Kurstitel',
    ai_input_course_title: 'Bitte geben Sie den Kurstitel ein!',
    learning_objective_label: 'Lernziel',
    learning_objective_message: 'Bitte geben Sie das Lernziel ein!',
    standard_question: 'Gibt es einen Standard, dem der Lernende folgen muss?',
    standard_details_label: 'Standarddetails',
    standard_details_message: 'Bitte geben Sie die Standarddetails ein!',
    estimated_duration_label: 'Geschätzte Kursdauer (in Minuten)',
    estimated_duration_message: 'Bitte geben Sie die geschätzte Dauer ein!',
    min_duration_message: 'Die Mindestdauer beträgt 5 Minuten.',
    ai_mins: '25 Minuten',
    industry_specific_question: 'Ist es branchenspezifisch?',
    industry_label: 'Branchenspezifizierung',
    industry_message: 'Bitte geben Sie die Branche ein!',
    ai_course_creation: 'KI Kurs Erstellung',
    course_generated: 'Kurs generiert von Sharelook',
    ai: 'KI',
    ai_you: 'Sie',
    ai_prompt_ready:
      'Ihr Prompt ist bereit. Sie sind nun bereit, das Inhaltsverzeichnis zu generieren.',
    ai_unable_respond:
      'Entschuldigung! Die KI kann nicht auf Ihren Prompt antworten. Bitte versuchen Sie es erneut.',
    ai_hide_toc: 'Inhaltsverzeichnis ausblenden',
    ai_preview_toc: 'Vorschau des Inhaltsverzeichnisses',
    ai_generate_toc_now: 'Jetzt Inhaltsverzeichnis generieren',
    ai_creation_course_title: 'Kurstitel:',
    ai_creation_industry_specific: 'Ist es branchenspezifisch:',
    ai_creation_industry: 'Branche:',
    ai_creation_standard_needed:
      'Gibt es einen Standard, dem der Lernende folgen muss?:',
    ai_creation_standard_details: 'Standarddetails:',
    ai_creation_estimated_duration: 'Geschätzte Kursdauer (in Minuten):',
    minutes: 'Minuten',
    ai_creation_learning_objective: 'Lernziel:',
    setup_again: 'Erneut erstellen',
    ai_creation_confirm_title:
      'Möchten Sie das Formular wirklich erneut erstellen?',
    ai_creation_confirm_content:
      'Der Chat und alle Inhalte, die Sie generiert haben, werden zurückgesetzt.',
    ai_toc: 'Inhaltsverzeichnis',
    ai_note_topic:
      'Hinweis: Sie können Themen innerhalb der Lektion per Drag & Drop neu anordnen.',
    ai_add_topic: '+ Thema hinzufügen',
    add_topic: 'Thema hinzufügen',
    add_lesson: 'Lektion hinzufügen',
    add_new_lesson: 'Neue Lektion hinzufügen',
    ai_add_lesson: '+ Lektion hinzufügen',
    attention: 'Achtung',
    before_varifying: 'Vor der Überprüfung',
    ai_save_later: 'Für später speichern',
    ai_download_word_doc: 'Als Word-Dokument herunterladen',
    ai_download_course_word_doc: 'Kurs als Word-Dokument herunterladen',
    ai_create_course_button: 'Kurs jetzt erstellen',
    ai_generate_course_content: 'Kursinhalt generieren',
    ai_out_of: 'von',
    ai_subtopic_failed_content:
      'Unterthemen konnten nicht generiert werden. Klicken Sie erneut auf "Kursinhalt generieren", um nur für diese Unterthemen Inhalte zu generieren.',
    ai_edit_topic: 'Thema bearbeiten',
    ai_edit_lesson_title: 'Lektionstitel bearbeiten',
    ai_save_topic: 'Thema speichern',
    ai_save: 'Speichern',
    ai_save_lesson_title: 'Lektionstitel speichern',
    ai_add_new_topic: 'Neues Thema hinzufügen',
    ai_download_ref: 'Mit Referenzen herunterladen',
    ai_download_ref_content:
      'Es wird der Kurs als Word-Dokument mit Referenzen heruntergeladen.',
    ai_download_without_ref: 'Download ohne Referenzen',
    ai_download_two_word: 'Es werden zwei Word-Dokumente heruntergeladen:',
    ai_download_two_word_content_one:
      '• Eine mit dem Hauptinhalt ohne Quellenangaben',
    ai_download_two_word_content_two:
      '• Eine nur mit Quellenangaben (kein Inhalt)',
    ai_manage_content: 'Inhalt verwalten',
    ai_add_content_from_internet: '+ Inhalt aus dem Internet hinzufügen',
    ai_confirm_start: 'Start bestätigen',
    ai_Verify: 'Überprüfen',
    ai_undo_warning:
      'Dieser Vorgang kann einige Zeit in Anspruch nehmen. Bitte schließen Sie dieses Fenster nicht, bis die Generierung abgeschlossen ist, da sie nicht rückgängig gemacht werden kann.',
    ai_verified_content:
      'Sie haben den Inhalt überprüft. Beachten Sie, dass Sie nach der Bestätigung nicht mehr mit dem KI-Assistenten chatten können.',
    ai_want_proceed: 'Möchten Sie fortfahren?',
    upload_simulation: 'Simulation hochladen',
    name_simulation: 'Simulationsname',
    selected_simulation_files: 'Ausgewählte Simulationsdateien',
    score_between_one_hundred:
      'Ihre Punktzahl sollte zwischen 1 und 100 liegen.',
    are_sure_simulation: 'Möchten Sie diese Simulationsdatei wirklich löschen?',
    required_simulation: 'Punktzahl ist erforderlich',
    simulation: 'Simulation',
    simulation_quiz_games: 'Quiz in Spielen hinzufügen',
    simulation_alert_des:
      'Sie können Spiele nur hinzufügen, wenn alle Fragen eine Antwortart von entweder Einzel- oder Mehrfachauswahl haben.',
    alert_info: 'Info',
    ai_number_quiz: 'Anzahl der Quizfragen',
    ai_point: 'Punkt',
    ai_points: 'Punkte',
    val_required: 'Erforderlich',
    games: 'Spiele',
    add_simulation: 'Simulation hinzufügen',
    text_tiewer: 'Textanzeiger',
    back_to_account: 'Zurück zum Konto',
    delete_account: 'Konto löschen',
    delete_account_title: 'Konto löschen?',
    delete_account_subtitle: 'Sie können Ihr Konto hier löschen.',
    delete_account_cannot_undo:
      'Sie sind dabei, Ihr Konto zu löschen. Diese Aktion kann nicht rückgängig gemacht werden.',
    account_org_profile:
      'Sie verlieren auch alle von Ihnen erstellten Kurse, Ihr Organisationsprofil und alle Ihre Einstellungen.',
    deleting_account_database:
      'Das Löschen Ihres Kontos entfernt alle Ihre Daten aus unserer Datenbank.',
    account_confirm_delete: 'Möchten Sie Ihr Konto wirklich löschen?',
    action_cannot_be_undone:
      'Diese Aktion kann nicht rückgängig gemacht werden.',
    account_delete_message_success: 'Ihr Konto wurde erfolgreich gelöscht.',
    message_edit: 'Bearbeiten',
    message_delete: 'Löschen',
    message_reply: 'Antworten',
    attached_file: 'Angehängte Datei',
    attach_file: 'Datei anhängen',
    attach_des: '25 MB maximale Dateigröße',
    view: 'Ansehen',
    go_to_marketplace: 'Zum Marktplatz gehen',
    learning_center: 'Lernzentrum',
    knowledge_center: 'Wissenszentrum',
    sharebot: 'ShareBot',
    sharebot_help_message: 'Wie kann ich Ihnen heute helfen?',
    my_organization: 'Meine Organisation',
    world_knowledge: 'Weltwissen',
    welcome_to_sharelook: 'Willkommen bei Sharelook!',
    sharelook_you_want_go: 'Wohin möchten Sie heute gehen?',
    shareLook_learning_management_system:
      'Zugang zum ShareLook Learning Management System, um Lernressourcen wie Live-Events und Kurse in Ihrer Organisation auf ShareLook zu erstellen oder darauf zuzugreifen.',
    shareLook_powerful_ai_system:
      'Zugang zum leistungsstarken KI-gesteuerten System von ShareLook, wo Sie PDF-Dokumente hochladen und innerhalb von Sekunden nützliche Erkenntnisse erhalten können. Erhalten Sie schnelle Antworten basierend auf den hochgeladenen Ressourcen in Ihrer Organisation oder erhalten Sie Antworten von unserem allgemeinen KI-System im Bereich Weltwissen.',
    edit_now: 'Jetzt bearbeiten',
    sharelook_log_out:
      'Sie wurden von Sharelook abgemeldet. Bitte melden Sie sich erneut an!',
    sorry_error: 'Entschuldigung! Es ist ein Fehler aufgetreten.',
    login: 'Anmelden',
    refresh_page: 'Seite aktualisieren',
    just_a_moment: 'Einen Moment bitte',
    enter_lname_fname:
      'Bitte geben Sie Ihren Vor- und Nachnamen ein, um fortzufahren.',
    procced_to_sharelook: 'Zu Sharelook gehen',
    option_one: 'Option 1',
    option_two: 'Option 2',
    selected_image: 'Ausgewähltes Bild:',
    add_text: 'Text hinzufügen',
    linkdin_is_required: 'Linkedin ist erforderlich.',
    bio_is_required: 'Bio ist erforderlich.',
    save_user_information: 'Benutzerinformationen speichern',
    select_all: 'Alle auswählen',
    enable_ai: 'KI aktivieren',
    load_more: 'Mehr laden',
    channel_id: 'Kanal ID.',
    send: 'Senden',
    v4: 'Informationen',
    subscription: 'Abonnement',
    reset_user_flag: 'BENUTZERFLAGGE ZURÜCKSETZEN',
    delete_my_accont: 'Mein Konto löschen',
    sharebot_sub_error:
      'Fehler beim Abrufen von Abonnements. Versuchen Sie es erneut!',
    sharebot_no_sub: 'Sie haben derzeit keine aktiven Abonnements.',
    sharebot_dont_sub: 'Sie haben keine früheren Abonnements.',
    sharebot_prev_sub: 'Früher abonniert',
    sharebot_sub: 'ShareBot-Abonnement',
    sharebot_un_sub: 'ShareBot-Abonnement kündigen',
    sharebot_no_available: 'Keine Beschreibung verfügbar',
    sharebot_start_date: 'Startdatum:',
    sharebot_end_date: 'Enddatum:',
    sharebot_sure: 'Sind Sie sicher?',
    sharebot_do_you_want: 'Möchten Sie',
    unsubscribe: 'abbestellen',
    unsubscribe_what: 'abbestellen?',
    subscribe: 'abonnieren',
    subscribe_what: 'abonnieren?',
    subscribe_now: 'Jetzt abonnieren',
    confirm: 'Bestätigen',
    sharebot_intel_knowledge_center: "ShareBot's Intelligentes Wissenszentrum",
    sharebot_welcome_paragraph:
      'Willkommen im Wissenszentrum von ShareBot, dem fortschrittlichen KI-Chatbot, der darauf ausgelegt ist, die Art mit der Profis auf Informationen zugreifen und zusammenarbeiten zu verbessern.',
    expired: 'Abgelaufen',
    active: 'Aktiv',
    Inactive: 'Inaktiv',
    yearly_subscription: 'Jahresabonnement',
    monthly_subscription: 'Monatsabonnement',
    no_sharebot_org: 'Sie haben keine ShareBot-Organisation',
    sharebot_start_free_trial: 'Kostenlose Testversion starten',
    sub_month: 'Abonnement monatlich',
    sub_year: 'Abonnement jährlich',
    question_per_month: 'Daten speicher (1 TB) und 1000 Fragen pro Monat',
    sharebot_para:
      'Wenn Sie fortfahren, bestätigen Sie die sofortige Löschung der Organisation. Diese Aktion führt zum Verlust aller wertvollen Einblicke, die von ShareBot bereitgestellt wurden, und kann nicht rückgängig gemacht werden.',
    cancelled_date: 'Stornierungsdatum:',
    live_straming_para:
      'Wenn Sie Ihr monatliches Live-Streaming-Limit ändern möchten, kontaktieren Sie uns bitte',
    sharelook_agree: 'Ich gebe meine Zustimmung für Sharelooks',
    terms_condition: 'Nutzungsbedingungen',
    and: 'und',
    privacy_policy: 'Datenschutzbestimmungen',
    save_for_later: 'Für später speichern',
    no_video_yet: 'Noch keine Videos ausgewählt!',
    are_you_sure_delete_video: 'Möchten Sie dieses Video wirklich löschen?',
    video_des: 'Beschreibung',
    video_now: 'Jetzt',
    video_playing: 'Wiedergabe:',
    video_no: 'Video Nr.',
    ai_generated_course: 'Von KI generierter Kurs',
    create_course_on_our_own: 'Erstellen Sie einen Kurs selbst',
    ai_Assisted_ourse_reation: 'KI-unterstützte Kurs-Erstellung',
    pending: 'Ausstehend',
    published: 'Veröffentlicht',
    intro_course: 'in Ihren Kurs?',
    clone_course: 'Möchten Sie den Kurs klonen',
    browser_audio_not_support:
      'Ihr Browser unterstützt die Audio-Flagge nicht.',
    audio_popup_content:
      'Hier können Sie viele Sprachstile über den von Ihnen eingegebenen Text verwenden bla Bla bla Lorem Ipsum ist einfach dummy text aus dem Druck- und Satzgewerbe. Lorem Ipsum ist der Standarddummy-Text der Branche seit den 1500er Jahren,',
    close: 'Schließen',
    podcast_rec: 'REC',
    create_podcast: 'Podcast erstellen',
    add_admin: 'ADMIN HINZUFÜGEN',
    delete_all: 'Alle löschen',
    ai_podcast_audio: 'KI Podcast Audio',
    language: 'Sprache',
    podcast_download_content:
      '*Laden Sie die KI Audiodatei herunter, um sie zu bearbeiten und zu Ihrer eigenen Audiodatei zu machen.',
    upload_audio: 'Audio hochladen',
    browser_do_not_support_audio:
      'Ihr Browser unterstützt das Audioelement nicht.',
    upload_cover: 'Cover hochladen',
    upload_ai_creator: 'KI-Ersteller',
    required_cover_image: 'Coverbild ist erforderlich!',
    room_required_name: 'Raumname ist erforderlich!',
    add_guest_list: 'Bitte fügen Sie Gästelisten hinzu!',
    podcast_add_participants: 'TEILNEHMER HINZUFÜGEN',
    topic_required: 'Mindestens ein Thema ist erforderlich',
    podcast_description: 'BESCHREIBUNG',
    podcast_date: 'DATUM',
    date: 'Datum',
    podcast_time: 'Uhrzeit',
    podcast_to: 'bis',
    podcast_all_day: 'Den ganzen Tag',
    podcast_start_date_time: 'Startdatum und -zeit sind erforderlich!',
    podcast_id: 'ID',
    selected_user: 'Ausgewählte Benutzer einladen',
    see_more: 'Mehr anzeigen',
    see_less: 'Weniger anzeigen',
    no_review_yet:
      'Noch keine Bewertung, seien Sie der Erste, der eine abgibt.',
    request_to_speak: 'Benutzeranfrage zum Sprechen annehmen?',
    kick_user: 'Möchten Sie diesen Benutzer rauswerfen?',
    accept_request: 'Anfrage annehmen',
    kick: 'RAUSWERFEN',
    started: 'GESTARTET',
    end: 'ENDE',
    join_now: 'Jetzt beitreten',
    podcast_end: 'Der Podcast ist zu Ende',
    connecting: 'Verbinden...',
    knowledge_center_know_today: 'Was möchten Sie heute wissen?',
    knowledge_center_question: 'Bitte geben Sie zuerst eine Frage ein',
    knowledge_center_error: 'Entschuldigung! Es ist ein Fehler aufgetreten.',
    knowledge_center_tooltrip:
      'Erhalten Sie schnelle Antworten aus den Lernressourcen im Repository Ihrer Organisation auf ShareLook, mit korrekten Referenzen und der Möglichkeit, die referenzierten PDF-Dokumente zu überprüfen und herunterzuladen.',
    open_file: 'Datei öffnen',
    reference: 'Referenz',
    are_you_cancel: 'Sind Sie sicher, dass Sie abbrechen möchten?',
    are_you_remove_media:
      'Sind Sie sicher, dass Sie die Mediendatei entfernen möchten?',
    terms_agree: 'Ich stimme diesen zu',
    ready: 'Bereit',
    send_email: 'E-MAIL SENDEN',
    active_users: 'Aktive Benutzer',
    sign_up_user: 'Benutzer anmelden',
    non_sign_up_user: 'Nicht angemeldete Benutzer',
    organisation: 'Organisation',
    usage_report: 'Nutzungsbericht',
    check_email: 'Überprüfen Sie Ihre E-Mails',
    delete_schedule: 'Zeitplan löschen',
    are_you_sure_delete_schedule:
      'Sind Sie sicher, dass Sie diesen Zeitplan löschen möchten?',
    add_task: 'Bitte geben Sie eine Aufgabe ein!',
    coaching_available: 'Als Coaching-Verfügbarkeit markieren',
    message_booking_coaching:
      'Dieser Zeitraum wurde von einem Benutzer für ein Coaching gebucht.',
    task_day: 'Aufgabentag',
    created_task_day: 'Sie haben eine Aufgabe für diesen Tag erstellt.',
    event_day: 'Veranstaltungstag',
    has_booked_coaching: 'Ein Coaching wurde für diesen Tag gebucht.',
    active_day: 'Aktiver Tag',
    selectable_time_slots:
      'Die auswählbaren Zeitfenster rechts sind für diesen Tag aktiv.',
    compare_last_month: 'Im Vergleich zum letzten Monat',
    uploading_file: 'Ihre Datei wird hochgeladen',
    attach_file_course: 'An diesen Kurs angehängt.',
    fetch_request: 'Ihre Anfrage wird abgerufen',
    finilize_upload: 'Upload abschließen',
    scorm_scanned:
      'Bitte warten... Ihre hochgeladene SCORM-Zip-Datei wird gescannt.',
    scan_status: 'Scan Status:',
    scan_completed: 'Scan Abgeschlossen. Ihre Datei ist',
    scan_progress: 'Scan läuft...',
    check_scorm: 'Überprüfung des SCORM-Dateiformats... Bitte warten...',
    file_check_success: 'Dateiüberprüfung erfolgreich',
    file_check_progress: 'Dateiüberprüfung läuft...',
    scorm_not_upload:
      'Ihre hochgeladene Datei entspricht nicht dem SCORM 1.2-Standard. Bitte laden Sie die Datei erneut hoch.',
    select_question: 'Antwortoptionen (eine richtige Antwort auswählen)',
    select_answer: 'Bitte wählen Sie eine Antwortoption aus!',
    check_option_one: 'Bitte geben Sie Option eins ein!',
    check_option_two: 'Bitte geben Sie Option zwei ein!',
    check_option_three: 'Bitte geben Sie Option drei ein!',
    check_option_four: 'Bitte geben Sie Option vier ein!',
    question_image: 'Fragebild',
    select_question_image: 'Bitte wählen Sie ein Fragebild aus!',
    ans_image: 'Antwortbild',
    upload_image_question: 'Antwortbild hochladen',
    select_image_answer: 'Bitte wählen Sie ein Antwortbild aus!',
    save_question: 'Frage speichern',
    do_you_leave: 'Sind Sie sicher, dass Sie die Seite verlassen möchten?',
    loose_all_progress: 'Sie werden Ihren gesamten Fortschritt verlieren.',
    welcome: 'Willkommen',
    team_knowledge_quest: 'Team Wissensaufgabe',
    your_score: 'Ihr Ergebnis',
    start_playing: 'Starten',
    share_sphere_complete: 'ShareSphere abgeschlossen',
    final_score: 'Endstand',
    play_next: 'Nächstes Spiel',
    you_donot_access_event: 'Sie haben keinen Zugang zu dieser Veranstaltung.',
    ai_content_generated: 'Inhalt für dieses Thema wurde generiert.',
    ai_popup_confirm_content: 'Inhaltsgenerierung bestätigen',
    limit_transcribe_text:
      'Verbleibende Transkriptionsminuten: <0>{{ transcribe_limit }}</0> Minuten <1/><2/> <3>. Um Ihr Transkriptionslimit zu ändern, kontaktieren Sie bitte </3> <4>admin@sharelook.com</4>.',
    monthly_ai_credit_limit: 'Um Ihr KI-Guthabenlimit zu ändern, kontaktieren Sie bitte',
    remaining_credits_text: 'Verbleibendes KI-Guthaben: <0>{{ remaining_credits }}</0> Guthaben <1/><2/> <3>. Um Ihr KI-Guthabenlimit zu ändern, kontaktieren Sie bitte </3> <4>admin@sharelook.com</4>.',
    ai_course_title_training: 'Führungskräftetrainings Kurse',
    ai_course_object: 'Führung in der digitalen Welt',
    create_ai_video: 'KI-Video erstellen',
    generate: 'GENERIEREN',
    video_generate_process:
      'Der Prozess zur Videogenerierung kann einige Zeit in Anspruch nehmen. Sie werden per E-Mail benachrichtigt, wenn er abgeschlossen ist.',
    stripe_account_connect:
      'Ihr Stripe-Konto ist inaktiv. Bitte verbinden oder aktivieren Sie es, um fortzufahren.',
    ai_creator: 'KI Ersteller',
    check_video_status: 'Überprüfung des Videogenerierungsstatus...',
    video_on_queue: 'Die Videogenerierung befindet sich in der Warteschlange.',
    video_fail_generation:
      'Die Videogenerierung ist fehlgeschlagen. Bitte versuchen Sie es erneut.',
    video_currently_generated: 'Dieses Video wird derzeit generiert.',
    checking_status: 'Status wird überprüft',
    check_status: 'Status überprüfen',
    browser_does_not_support_audio:
      'Ihr Browser unterstützt die Audio-Flagge nicht',
    existing_edit_scenario:
      'Möchten Sie das bestehende Szenario bearbeiten oder ein neues Szenario erstellen? Wenn Sie ein neues Szenario erstellen möchten, gehen alle alten Szenarien verloren.',
    generate_scenario: 'Szenario generieren',
    layout: 'Layout',
    confirm_change: 'Änderung bestätigen',
    generated_ai_creation_message:
      'Bitte beachten Sie, dass nur die Textelemente, die aus der KI-Erstellung generiert wurden, erhalten bleiben. Alle anderen Elemente werden von der Seite entfernt.',
    generate_story: 'Geschichte generieren',
    save_original_content: 'Ursprünglichen Inhalt speichern:',
    story_added_specified_position:
      'Die Position der Geschichte in der Lektion. Die Geschichte wird als Block an der angegebenen Position hinzugefügt.',
    position_of_story: 'Position der Geschichte',
    start_the_lesson: 'Beginn der Lektion',
    end_the_lesson: 'Ende der Lektion',
    add_story_pages: 'Geschichte zu Seiten hinzufügen',
    browser_does_not_support:
      'Ihr Browser unterstützt das Audio-Element nicht.',
    no_video_available: 'Keine Videos verfügbar.',
    no_podcast_available: 'Keine Podcasts verfügbar.',
    no_item_baskets: 'Keine Artikel im Korb.'
  },
  v2: {
    n_data: 'Keine Daten',
    change: 'Ändern',
    remove: 'Entfernen',
    auto_background: 'Automatischer Hintergrund',
    create_new_course_org:
      'Erstellen Sie einen neuen Kurs für Ihre Organisation.',
    create_new_course_marketplace:
      'Erstellen Sie einen neuen Kurs für den Marktplatz.',
    create_new_course_both:
      'Erstellen Sie einen neuen Kurs für Ihre Organisation und den Marktplatz.',
    ok: 'OK',
    page_bg: 'Seitenhintergrund',
    lesson_cover: 'Cover-Bild der Lektion',
    create_skill_journey: 'Erstellen Sie eine Fähigkeitsreise',
    Metamaze: 'Metamaze',
    events: 'Veranstaltungen',
    scroms: 'SCORMs',
    min_score_pass: 'Mindestpunktzahl zum Bestehen',
    no_scorms_available: 'Keine SCORMs verfügbar.',
    no_events_available: 'Keine Veranstaltungen verfügbar.',
    no_courses_available: 'Keine Kurse verfügbar.',
    no_courses_baskets: 'Keine Kurse im Korb.',
    no_mazes_baskets: 'Keine Labyrinthe im Korb.',
    no_scroms_baskets: 'Keine SCORMs im Korb.',
    no_events_baskets: 'Keine Veranstaltungen im Korb.',
    sorry: 'Entschuldigung!',
    option_1: 'Option 1',
    option_2: 'Option 2',
    enter_number_words: 'Geben Sie die maximale Anzahl von Wörtern ein.',
    summarize: 'Zusammenfassen',
    answer: 'Antwort',
    hold_tight_one_minute:
      'Bitte warten Sie einen Moment! Wir bereiten noch alles vor. Dies kann bis zu einer Minute dauern.',
    enter_question: 'Geben Sie Ihre Frage ein.',
    enter_relevant_documents: 'Geben Sie die Anzahl relevanter Dokumente ein.',
    please_input_relevant_documents:
      'Bitte geben Sie die Anzahl relevanter Dokumente ein!',
    please_wait_loading_results: 'Bitte warten Sie auf die Ergebnisse...',
    proceed_to_add_voice: 'Fahren Sie mit der Sprachauswahl fort',
    results: 'Ergebnisse',
    no_result_found_try_asking_questions:
      'Keine Ergebnisse gefunden. Versuchen Sie, mehr Fragen zu stellen.',
    eg: 'z.B.,',
    what_make_sales_manager: 'Was macht mich zu einem Vertriebsleiter?',
    please_select_lang: 'Bitte wählen Sie eine Sprache aus!',
    search: 'Suche',
    please_copy_desired_content:
      'Bitte kopieren Sie den gewünschten Inhalt von der linken Box in die rechte Box.',
    rating_req: 'Bewertung ist ein Pflichtfeld.',
    review_req: 'Rezension ist ein Pflichtfeld.',
    rating_review_req:
      'Es muss sowohl eine Bewertung als auch eine Rezension angegeben werden.',
    how_rate_this: 'Wie würden Sie dies bewerten?',
    amazing_above_expectations: 'Erstaunlich! Über den Erwartungen!',
    certificates: 'Zertifikate',
    you_no_certificates: 'Sie haben derzeit keine Zertifikate verfügbar.',
    please_add_review:
      'Bitte geben Sie eine Rezension zusammen mit der Bewertung ab. Vielen Dank!',
    post: 'Posten',
    rate: 'Bewerten',
    avg_rating: 'Durchschnittliche Bewertung',
    no_review_found: 'Keine Bewertung gefunden',
    are_sure_to_disale_zoom_integration:
      'Sind Sie sicher, dass Sie die Zoom-Integration deaktivieren möchten?',
    badges: 'Abzeichen',
    you_no_badge_available: 'Sie haben derzeit keine Abzeichen verfügbar.',
    download_certificate: 'Zertifikat herunterladen',
    loading: 'Laden...',
    no_file_attached: 'Keine Dateien angehängt',
    you_do_not_have_any_notes: 'Sie haben keine Notizen.',
    question: 'Frage',
    score: 'Punktzahl',
    alert_score_message: 'Person(en) haben ihre Punkte abgegeben.',
    alert_question_message: 'Bis jetzt wurden keine Fragen hinzugefügt.',
    button_submit: 'Einreichen',
    button_allScores: 'Alle Punkte wurden abgegeben.',
    record_wait: 'Die Aufnahme beginnt. Bitte warten...',
    buttonSubmit_warning:
      'Bitte geben Sie alle Punkte ein, bevor Sie sie einreichen.',
    upload_ar_assets: 'AR-Ressourcen hochladen',
    edit_ar_assets: 'AR-Ressourcen bearbeiten',
    edit_maze_assets: 'MetaMaze-Ressourcen bearbeiten',
    upload_assets: 'Ressourcen hochladen',
    upload_maze_assets: 'MetaMaze-Ressourcen hochladen',
    trigger_title: 'Trigger-Titel',
    model_title: 'Modellname',
    trigger_description: 'Auslöse-Beschreibung',
    model_description: 'Modell-Beschreibung',
    please_type_target_description: 'Bitte geben Sie die Zielbeschreibung ein.',
    please_type_model_description:
      'Bitte geben Sie die Modellbeschreibung ein.',
    trigger_image: 'Auslösebild*',
    model_image: 'Modellbild*',
    upload_trigger_image: 'Auslösebild hochladen',
    upload_model_image: 'Modellbild hochladen',
    drag_n_drop: 'Drag & Drop',
    file_size_should_not_exceed:
      '(Bilddatei (JPEG) darf 512 KB nicht überschreiten)',
    zip_size_should_not_exceed: '(ZIP-Datei darf 60 MB nicht überschreiten)',
    ar_content: 'AR-Inhalt*',
    model_content: '3D-Modell*',
    upload_3d_zip: 'ZIP / Video hochladen',
    upload_3d_maze_zip: 'ZIP hochladen',
    audio_content: 'Audio-Inhalt',
    _mp3: '(.mp3)',
    content_attached: 'ZIP angehängt.',
    video_attached: 'Video angehängt.',
    audio_attached: 'Audio angehängt.',
    enter_trigger_image_title: 'Titel des Auslösebildes eingeben.',
    enter_model_title: 'MetaMaze Modellname eingeben.',
    ar_preview_image: 'AR-Vorschau-Bild',
    upload_preview_image: 'Vorschau-Bild hochladen',
    upload_audio: 'Audio hochladen',
    creating___: 'Erstellen...',
    updating___: 'Aktualisieren...',
    create: 'Erstellen',
    update: 'Aktualisieren',
    ar_assets: '3D-Bild',
    _3d_files_mp4: '(Zipped .obj, .fbx oder .mp4 Video)',
    _3d_files_mp4_ar: '(Zipped .obj, .fbx)',
    maze_3d_files_mp4: '(Zipped .obj, .fbx)',
    _jpg_files: 'Unterstützt nur .jpg',
    persons_have_submitted_their_scores:
      'Person(en) haben ihre Punkte abgegeben.',
    no_questions_added_till_now: 'Bis jetzt wurden keine Fragen hinzugefügt.',
    submit: 'Einreichen',
    all_scores_submitted: 'Alle Punkte wurden abgegeben.',
    recording_is_starting: 'Die Aufnahme beginnt. Bitte warten...',
    please_input_scores_before_submitting:
      'Bitte geben Sie alle Punkte ein, bevor Sie sie einreichen.',
    end_for_all: 'Für alle beenden',
    full_screen: 'Vollbild',
    breakout_room: 'Breakout-Raum',
    send_invitations: 'Einladung(en) senden',
    add_participants: 'Teilnehmer hinzufügen',
    create_breakout_room: 'Breakout-Raum erstellen',
    connecting: 'Verbindung wird hergestellt...',
    currently_broadcaster_unavailable:
      'Der Broadcaster ist derzeit nicht verfügbar.',
    how_many_breakout_room_to_create:
      'Wie viele Breakout-Räume möchten Sie erstellen?',
    create_upto_three_breakout_rooms: '*Erstellen Sie bis zu 3 Breakout-Räume',
    allow: 'Erlauben',
    additional: 'Zusätzlich',
    attachment: 'Anhänge',
    no_description_available: 'Keine Beschreibung verfügbar.',
    people: 'PERSONEN',
    waiting: 'Warten',
    hand_raising_users: 'Benutzer die ihre Hand heben',
    invite: 'Einladen',
    create_room: 'Raum erstellen',
    create_live_event: 'Live-Event erstellen',
    support_upto_fivethousand_participants:
      'Unterstützt bis zu 5.000 Teilnehmer für das Event',
    support_upto_ten_participants:
      'Unterstützt bis zu 10 Live-Video-Teilnehmer',
    support_upto_twohundred_participants:
      'Unterstützt bis zu 200 Teilnehmer für das Event',
    supprt_upto_five_participants: 'Unterstützt bis zu 5 Live-Video-Teilnehmer',
    support_upto_twentyfive_participants:
      'Unterstützt bis zu 25 Live-Video-Teilnehmer für das Event',
    two_live_video_participants:
      'Es gibt 2 Live-Video-Teilnehmer für das Event (Host und Teilnehmer)',
    you_can_have_upto_five_examinees: 'Sie können maximal 5 Prüflinge haben.',
    you_can_have_upto_twentyfive_participants:
      'Sie können maximal 25 Teilnehmer haben.',
    you_can_have_upto_five_participants:
      'Sie können maximal 5 Teilnehmer haben.',
    you_can_have_upto_ten_participants:
      'Sie können maximal 10 Teilnehmer haben.',
    select_hosts_email: 'Host-E-Mail auswählen',
    send_invite_email: 'Einladungs-E-Mail senden',
    do_not_send_invite_email: 'Keine Einladungs-E-Mail senden',
    error: 'Fehler',
    max_twentyfive_users_allowed:
      'Maximal 25 Benutzer können ausgewählt werden',
    max_five_users_allowed: 'Maximal 5 Benutzer können ausgewählt werden',
    max_ten_users_allowed: 'Maximal 10 Benutzer können ausgewählt werden',
    no_user_found: 'Kein Benutzer gefunden',
    transcribe_to: 'Übertragen zu',
    integrate_zoom_to_start_meeting:
      'Integrieren Sie Zoom in Ihr Konto, um ein Zoom-Meeting zu starten.',
    zoom_is_not_integrated: 'Zoom ist nicht integriert.',
    delete_poll: 'Umfrage löschen',
    add_poll: 'Umfrage hinzufügen',
    live_now: 'JETZT LIVE!',
    average_rating: 'Durchschnittliche Bewertung',
    review: 'Bewertung',
    time_spent: 'Verbrachte Zeit',
    total: 'Gesamt',
    mins: 'Minuten',
    no_data: 'Für dieses Quiz liegen keine Daten vor.',
    total_score: 'Gesamtpunktzahl',
    pass_score: 'Mindestpunktzahl',
    point: 'Punkt',
    wrong: 'Falsch',
    response: 'Antwort',
    submitted: 'Abgeschickt',
    average: 'Durchschnitt',
    total_play: 'Gesamtspiel',
    view_graph: 'Diagramm anzeigen',
    time_spent_mins: 'Verbrachte Zeit (Minuten)',
    play: 'Abspielen',
    ideal_path: 'Idealer Pfad',
    user_incorrect_path: 'Falscher Benutzerpfad',
    ideal_path_taken: 'Vom Benutzer gewählter idealer Pfad',
    scenario: 'Szenario',
    option: 'Option',
    spend: 'Verbringen',
    average_spending_time: 'Durchschnittliche Verweildauer',
    activity_overview: 'Aktivitätsübersicht',
    live_event: 'Live-Event',
    live_assessment: 'Live-Bewertung',
    report_download: 'Bericht herunterladen',
    all_workshops: 'Alle Workshops',
    overview_average_activity: 'ÜbersichtDurchschnittliche Aktivität',
    overview_workshop_graph: 'Workshop-Übersichtsdiagramm',
    mazes: 'Labyrinthe',
    correct_feedback: 'Richtiges Feedback',
    incorrect_feedback: 'Falsches Feedback',
    checkin_checkout: 'Einchecken - Auschecken',
    minutes: 'Minuten',
    incorrect_path: 'Falscher Pfad',
    answer_not_available: 'Antwort nicht verfügbar',
    views: 'Ansichten',
    item: 'Element',
    questions: 'Fragen',
    total_points: 'Gesamtpunkte',
    total_attempts: 'Gesamtversuche',
    created_date: 'Erstellungsdatum',
    host_name: 'Host-Name',
    host_section: 'Host-Abschnitt',
    choose_products: 'Produkte auswählen',
    add_to_basket: 'Zum Warenkorb hinzufügen',
    basket: 'Warenkorb',
    times: 'mal',
    scorms: 'SCORMs',
    skill_journey_overview: 'Skill Journey Übersicht',
    how_to_use: 'Anwendung',
    live_broadcast_description:
      'WIR HABEN LIVE-VIDEO IN EINEN EINFACH ZU BENUTZENDEN KURSBUILDER INTEGRIERT',
    live_broadcast_subdescription:
      'Mit ShareLook’s patentiertem Live-Übertragungssystem können Sie Teilnehmer engagieren, Lernen automatisieren und den Wissensaustausch maximieren.',
    disclaimer:
      'Ich versichere, dass meine Fähigkeitsreise nicht:\n- die Rechte Dritter verletzen wird\n- keine Illegalität enthält, einschließlich diffamierender, obszöner, anstößiger, pornografischer, gewalttätiger, missbräuchlicher, beleidigender, bedrohlicher oder diskriminierender Inhalte, auch nicht durch Sternchen maskiert\n- keine persönlichen Angriffe auf andere Personen enthält\n- keine Personen, öffentlichen Personen oder Prominenten nachahmt\n- keine Aufzeichnungen oder persönlichen Informationen über Einzelpersonen ohne deren Zustimmung enthält und nicht gegen Datenschutzbestimmungen verstößt, die in jeglichen Teilen der Welt gelten\n- keine kommerzielle Werbung oder Form von "Spam" enthält',
    price: 'Preis',
    video_link: 'Video-Link',
    category: 'Kategorie',
    objectives: 'Ziele',
    marketplace_description: 'Marktplatzbeschreibung',
    live_discussion: 'LIVE DISKUSSION',
    poll: 'UMFRAGE',
    hide_grid: 'Raster ausblenden',
    show_grid: 'Raster anzeigen',
    stop_screen_share: 'Bildschirmfreigabe beenden',
    screen_share: 'Bildschirm teilen',
    mute: 'Stummschalten',
    unmute: 'Stummschaltung aufheben',
    raise_hand: 'Hand heben',
    waiting__: 'Warten...',
    audio_active: 'Audio aktiv'
  },
  general: {
    save: 'speichern',
    autosaved: 'automatisch gespeichert',
    back_to: 'zurück zu',
    by: 'von',
    chat: 'chat',
    completed: 'Abgeschlossen',
    canceled: 'Abgebrochen',
    component: 'Komponente',
    confirm: 'Bestätigen',
    course: 'Kurs',
    skill: 'Fähigkeitenreise',
    maze: 'MetaLabyrinth',
    channel: 'Kanal',
    podcast: 'Podcast',
    date: 'Datum',
    details: 'Details',
    empty: 'Keine Daten',
    enrolled: 'Eingeschrieben',
    free: 'kostenlos',
    graph: 'Diagramm',
    loading: 'Laden...',
    lesson: 'Lektion',
    lessons: 'Unterricht',
    live_assessment: 'Live-Bewertung',
    live_event: 'Live-Event',
    no: 'Nein',
    of: 'von',
    or: 'oder',
    organization: 'Organisation',
    page: 'Seite',
    pages: 'Seiten',
    personal: 'persönlich',
    poll: 'Umfrage',
    rating: 'Bewertung',
    reset: 'Zurücksetzen',
    signin: 'Anmelden',
    signup: 'Registrieren',
    soon: 'Bald',
    type: 'Typ',
    uploading: 'Hochladen...',
    yes: 'Ja',
    something_went_wrong: 'Irgendetwas ist schief gelaufen!',
    view_all: 'Alle anzeigen',
    upload_successful: 'Upload erfolgreich',
    upload_successful_message:
      'Ihre Excel-Dokumente wurden erfolgreich hochgeladen und werden derzeit verarbeitet. Dies kann einige Zeit in Anspruch nehmen.',
    check_email_upload_successful:
      'Bitte <0>überprüfen Sie Ihre E-mail</0> auf den Bericht <1>report</1> der hochgeladenen Benutzerliste.',
    is_private: 'privat'
  },
  account: {
    title: 'Konto',
    subtitle: 'Verwalten Sie Ihre Einstellungen und Kontoinformationen.',
    saved: 'Konto erfolgreich geändert'
  },
  assessments: {
    title: 'Bewertungen',
    subtitle: 'Erstellen einer Bewertung',
    finished: 'Die Bewertung ist abgeschlossen',
    countdown: 'Die Live-Bewertung wird in ',
    create: 'Erstellen von Bewertungen',
    list_title: 'Ihre Bewertungen',
    delete_warning: 'Möchten Sie dieses Element wirklich löschen?',
    details_title: 'Hinzufügen von Bewertungsdetails',
    details_subtitle:
      'Benennen Sie Ihre Bewertung und teilen Sie mit, was Ihre Leser daraus lernen sollten',
    disclaimer:
      'Ich versichere, dass in den Aufzeichnungen keine:\n    - Rechte dritter Parteien verletzt werden\n    - gesetzeswidrigen, rufschädigenden, obszönen, unsittlichen, anzüglichen, pornografischen, gewalttätigen, beleidigenden, unverschämten, drohenden oder diskriminierenden Inhalt                                    enthalten, dieser wird auch nicht mit Sternchen verborgen\n    - persönliche verbale Angriffe enthalten\n    - Imitationenvon anderen Teilnehmern, öffentlicher Personen oder Berühmtheiten enthalten    - Aufnahmenvon persönlichen Informationen einer Person ohne dessen Zustimmung enthalten und dass keine Datenschutzverordnungen in irgendeinem Land der Welt verletzt werden    -  gewerbliche Werbung oder sonstige Arten von “Spam” enthalten',
    assessment_details: 'Einzelheiten der Bewertung',
    assessment_settings: 'Assessment Einstellungen'
  },
  buildersettings: {
    title: 'Veröffentlichungseinstellungen',
    subtitle:
      'Fügen Sie zu den Einstellungen hinzu, wer Ihr Event sehen und mit Ihnen interagieren kann'
  },
  buttons: {
    market_place: 'Market Place',
    back_to_normal: 'Back To Normal',
    add: 'Hinzufügen',
    add_page: 'Seite hinzufügen',
    add_lesson: 'Lenktion hinzufügen',
    add_answer: 'Neue Antwort hinzufügen',
    add_group: 'Gruppe hinzufügen',
    add_organization: 'Organisation hinzufügen',
    add_question: 'Frage hinzufügen',
    add_quiz: 'Quiz hinzufügen',
    add_users: 'Benutzer hinzufügen',
    back: 'Zurück',
    back_to_course: 'Zurück zur Kursübersicht',
    back_to_lesson: 'Zurück zur Lektionsübersicht',
    back_to_media: 'Zurück zur Medienbibliothek',
    back_to_details: 'Zurück zu Details',
    cancel: 'Abbrechen',
    clear: 'bereinigen',
    close: 'Schließen',
    clone: 'Duplizieren',
    close_lesson: 'Lektion beenden',
    clone_course: 'Kurs duplizieren',
    confirm: 'Bestätigen',
    create: 'Erstellen',
    download: 'Herunterladen',
    download_mass_user_tamplate: 'Vorlage herunterladen',
    add_mass_users: 'Hinzufügen von Massenbenutzern',
    upload_excel_list: 'Excel-Liste hochladen',
    delete: 'Medien löschen',
    edit: 'Bearbeiten',
    edit_course: 'Kurs bearbeiten',
    enroll: 'Registrieren',
    finish: 'Beenden',
    upload_image: 'Bild hochladen',
    upload_image_video: 'Bild oder Video hochladen',
    select_media_library: 'Medienbibliothek auswählen',
    make_public: 'veröffentlichen',
    make_private: 'privat machen',
    make_org: 'Organisation erstellen',
    media: 'Mediathek',
    my_theme: 'Mein Thema',
    next: 'nächste',
    next_lesson: 'Nächste Lektion',
    next_step: 'Nächster Schritt',
    previous_step: 'Vorheriger Schritt',
    publish: 'Veröffentlichen',
    publish_assessment: 'Veröffentlichen Sie Ihre Bewertung',
    publish_course: 'Veröffentlichen Sie Ihren Kurs',
    publish_event: 'Veröffentlichen Sie Ihr Event',
    reset: 'Zurücksetzen',
    reset_elements: 'Elemente zurücksetzen',
    save: 'Speichern',
    creating: 'Erstellen...',
    updating: 'Aktualisieren...',
    saved: 'Gespeichert',
    save_for_later: 'Für später speichern',
    save_settings: 'Einstellungen speichern',
    select_files: 'Dateien auswählen',
    select_theme: 'Wählen Sie ein Thema',
    start_lesson: 'Lektion starten',
    update: 'Update',
    upload: 'Hochladen',
    upload_audio: 'Audio hochladen',
    upload_photo: 'Profilbild hochladen',
    upload_video: 'Video hochladen',
    enrolled: 'registriert',
    unenroll: 'nicht registrieren',
    from_library: 'Mediathek',
    remove: 'Entfernen',
    removed: 'Entfernt',
    start_broadcast: 'Übertragung starten',
    end_broadcast: 'Übertragung beenden',
    camera: 'Kamera',
    screen: 'Bildschirm',
    screen_with_camera: 'Bildschirm mit Kamera',
    insert: 'Einfügen',
    inserting: 'Einfügen'
  },
  card: {
    quick_add: 'Schnelles Hinzufügen',
    add: 'Hinzufügen',
    clone: 'Duplizieren',
    completed: 'Lektion abgeschlossen'
  },
  course: {
    upcoming_course: 'geplanter Kurs',
    unPublishEvent: 'Event nicht veröffentlichen',
    unPublishAssessment: 'Bewertung nicht veröffentlichen',
    pastCourse: 'Trainingskurs',
    upcoming: 'geplantes Live-Event',
    unPublishMaze: 'Maze veröffentlichung aufheben',
    upcomingMaze: 'Bevorstehendes Maze',
    pastMaze: 'Vergangenes MetaMaze',
    pastEvent: 'Vergangenes Live-Event',
    pastAssessment: 'Vergangene Live-Bewertung',
    upcomingAssessment: 'geplante Live-Bewertung',
    created: 'Erstelltes Datum:',
    assignees: 'Beauftragte',
    organisations:
      ' {{ Organisationen }} Organisationen, <2> {{ Benutzer }} Benutzer</2>',
    event_date: 'Live-Event Datum <1> {{ Datum }} </1>',
    delete_warning: 'Sind Sie sich sicher, dass Sie das löschen wollen?',
    clonning_no_lesson:
      'Bitte fügen Sie mindestens eine Lektion hinzu, um diesen Kurs zu duplizieren..',
    clone_warning: 'Sind Sie sicher, dass Sie diesen Kurs duplizieren wollen?',
    clone_success: 'wird dupliziert',
    disclaimer:
      'Ich versichere, dass meine Kurse nicht:\n    - die Rechte dritter Parteien verletzen\n    - gesetzeswidrigen, rufschädigenden, obszönen, unsittlichen, anzüglichen, pornografischen, gewalttätigen, beleidigenden, unverschämten, drohenden oder diskriminierenden Inhalt                                    enthalten, dieser wird auch nicht mit Sternchen verborgen\n    - persönliche verbale Angriffe enthalten\n    -Imitationen von anderen Teilnehmern, öffentlicher Personen oder Berühmtheiten enthalten\n    -Aufnahmen von persönlichen Informationen einer Person ohne dessen Zustimmung enthalten       \n     und dass keine Datenschutzverordnungen in irgendeinem Land der Welt verletzt werden\n    -gewerbliche Werbung oder sonstige Arten von “Spam” enthalten'
  },
  coursecreate: {
    take_a_tour: 'Tour starten',
    dropzone_text: 'Einfügen von Medien',
    sidebar_text: 'Wählen Sie ein Thema <1/> für Ihre <3/> Lektionen',
    delete_warning: 'Möchten Sie diese Lektion wirklich löschen?'
  },
  coursepage: {
    quizview_loading: 'Überprüfung der Antworten. Bitte warten...',
    quizview_answer: 'Ihre Antwort'
  },
  coursequiz: {
    title: 'Quiz in allen Lektionen'
  },
  dashboard: {
    tooltip_title: 'Dieses Video nicht mehr anzeigen',
    page_title: 'Die Statistik Ihrer Kurse',
    page_subtitle: 'Status der von Ihnen erstellten Kurse',
    profile_add_info:
      'Fügen Sie Ihre <1>{{unvollständigertext}}</1> , um Ihr Profil zu vervollständigen.',
    profile_build:
      'Erstellen Sie Ihr Profil <1>Hier</1>, teilen Sie uns Ihre Interessen und Fähigkeiten mit.',
    profile_title: 'Profilstärke',
    more_details: 'Weitere Details'
  },
  errors: {
    answer: 'Bitte geben Sie Antwort ein',
    answer_correct: 'Wählen Sie die richtige Antwort',
    code: 'Bitte geben Sie Ihren Code ein',
    criterion: 'Bitte geben Sie das Kriterium an',
    duration: 'Dauer ist erforderlich',
    element: 'Bitte geben Sie ein Element ein',
    email: 'Bitte geben Sie Ihre E-Mail-Adresse ein',
    email_invalid: 'Die eingegebene E-Mail-Adresse ist ungültig',
    feedback_correct: 'Bitte geben Sie positives Feedback',
    feedback_incorrect: 'Bitte geben Sie konstruktives negatives Feedback',
    host: 'Bitte geben Sie einen Leiter des Events an',
    host_assessment: 'Bitte geben Sie einen Leiter der Bewertung an',
    image: 'Bitte laden Sie ein Bild hoch',
    location: 'Bitte geben Sie Ihren Standort ein',
    live_location: 'Bitte wählen Sie einen Sendeort aus',
    limit: 'Bitte geben Sie Live-Streaming-Minuten ein',
    min_3char: 'Mindestens 3 Zeichen',
    number: 'bitte eine positive Zahl eingeben.',
    host_email_require: 'Die E-Mails der Leiters sind erforderlich.',
    attendee_email_require: 'Die E-Mails der Teilnehmer sind erforderlich.',
    name: 'Bitte geben Sie Ihren Namen ein',
    not_found_course: 'Kurs konnte nicht gefunden werden',
    not_found_event: 'Event konnte nicht gefunden werden',
    not_found_assessment: 'Bewertung nicht gefunden',
    password: 'Bitte geben Sie Ihr Passwort ein',
    password_digit: 'Mindestens eine Ziffer',
    password_short: 'Passwort ist zu kurz, mindestens 10 Zeichen',
    password_special: 'Mindestens ein Sonderzeichen',
    password_uppercase: 'Mindestens ein Großbuchstaben',
    password_lowercase: 'Mindestens ein Kleinbuchstaben',
    phone: 'Bitte geben Sie Ihre Telefonnummer ein',
    phone_invalid: 'Ungültige Telefonnummer',
    position: 'Bitte geben Sie Ihre Position ein',
    question: 'Bitte geben Sie die Frage ein',
    start_date: 'Startdatum & Uhrzeit sind erforderlich',
    tag: 'Bitte wählen Sie eine verlinkung aus',
    topics: 'Wählen Sie bitte mindestens ein Thema aus.',
    live_topics: 'Bitte fügen Sie Themen hinzu',
    title: 'Bitte geben Sie den Titel ein',
    title_assessment: 'Bitte geben Sie einen Bewertungstitel ein',
    title_course: 'Bitte geben Sie den Kurstitel ein',
    title_empty: 'Es muss einen Titel geben',
    title_event: 'Bitte geben Sie den Titel des Events ein',
    title_lesson: 'Bitte geben Sie den Titel der Lektion ein',
    title_quiz: 'Bitte geben Sie den Quiznamen ein',
    username: 'Bitte geben Sie Ihren Benutzernamen ein',
    invalid_verification_code: 'Dieser Bestätigungslink ist abgelaufen oder nicht mehr gültig. Dies geschieht normalerweise, wenn eine neuere Bestätigungs-E-Mail angefordert wurde. Bitte überprüfen Sie die aktuellste E-Mail von Sharelook, um Ihre E-Mail-Adresse zu bestätigen.',
    upload_error: 'Fehler - Datei ist nicht kompatibel!',
    upload_more_than_10:
      'Sie können nur maximal 10 Dateien auf einmal hochladen.',
    topics_max: 'Bitte fügen Sie maximal 3 Themen hinzu.',
    upload_excel:
      'Bitte stellen Sie sicher, dass Sie die richtige Datei hochgeladen haben.',
    title_excel: 'Fehler beim Hochladen der Vorlage:',
    file_size_exceed: 'Dateigröße überschritten',
    subtitle_excel:
      'Stellen Sie sicher, dass Sie die bereitgestellte Vorlage verwenden und die Spalten korrekt ausgefüllt sind.',
    select_broadcast_option:
      'Wählen Sie eine Option zum Übertragen dieses Events aus.',
    multi_hosts_number_error:
      'Nein. die Anzahl der Moderatoren darf nicht die vorher für das Event angegeben Anzahl überschreiten.',
    conference_people_number_error:
      'Nein. Die Teilnehmerzahl die angegeben wurde, darf nicht überschritten werden',
    select_max_host: 'Wählen Sie mindestens 1 Moderator für das Event aus.',
    select_max_conference:
      'Wählen Sie mindestens 1 Teilnehmer für das Event aus.',
    stream_stop_error: 'Streaming wurde unerwartet gestoppt!',
    unsecure_context:
      'Schwerwiegender Fehler: Der Browser kann aufgrund eines unsicheren Kontexts nicht auf Kamera und Mikrofon zugreifen. Bitte installieren Sie SSL und Zugriff über https',
    ws_not_supported:
      'Schwerwiegender Fehler: WebSocket wird in diesem Browser nicht unterstützt',
    no_org: 'Wählen Sie mindestens 1 Organisation zum Fortfahren aus',
    no_org_group:
      'Wählen Sie mindestens 1 Organisationsgruppe aus, um fortzufahren',
    waiting_to_join: 'Warten auf den Beitritt'
  },
  events: {
    title: 'Live-Eventdetails hinzufügen',
    change_host: 'Leiter ändern',
    finished: 'Das Event ist beendet',
    countdown: 'Live-Event wird übertragen in ',
    subtitle:
      'Benennen Sie Ihr Live-Event und sagen Sie Ihrem Publikum, was sie davon erwarten sollten.',
    poll_disabled: 'Umfragen sind in diesem Fall nicht verfügbar',
    disclaimer:
      "Ich versichere, dass meine Kurse nicht:\n    - die Rechte dritter Parteien verletzen\n     - gesetzeswidrigen, rufschädigenden, obszönen, unsittlichen, anzüglichen, pornografischen, gewalttätigen, beleidigenden, unverschämten, drohenden oder diskriminierenden Inhalt                                    enthalten, dieser wird auch nicht mit Sternchen verborgen\n      - persönliche verbale Angriffe enthalten\n      -Imitationen von anderen Teilnehmern, öffentlicher Personen oder Berühmtheiten enthalten\n      -Aufnahmen von persönlichen Informationen einer Person ohne dessen Zustimmung enthalten\n     und dass keine Datenschutzverordnungen in irgendeinem Land der Welt verletzt werden\n     -gewerbliche Werbung oder sonstige Arten von “Spam” enthalten'\n    },\n    '",
    prompt_message:
      'Wenn Sie diese Seite verlassen, wird das Ereignis beendet. Wollen Sie wirklich die Seite verlassen?',
    duration_exceed_message:
      'Ihre Sendezeit wird überschritten, die App wird die Übertragung beenden.',
    before_schedule_message:
      'Sie sind dabei, die Übertragung vor der geplanten Startzeit zu starten. Bitte beachten Sie, dass das Beenden der Übertragung das Event beendet.',
    browser_unsupportive_message:
      'Ihr Browser unterstützt kein Screenshare. Sie können unterstützende Browser in diesem Link sehen',
    cancel_switch_host_message:
      'Leiter ist nicht verfügbar. Das event wird von Ihrem Ende an fortgesetzt.',
    coaching_prompt_message:
      'Sie können diese Seite nicht verlassen, bis das Ereignis abgeschlossen ist.',
    event_modal_warn: 'Möchten Sie dieses Ereignis verlassen?',
    confirm_message: 'Das Event endet, wenn Sie auf OK klicken.',
    screen_share_denied: 'Sie haben die Freigabe Ihres Bildschirms verweigert',
    media_not_found:
      'Kamera oder Mikrofon wurden nicht gefunden oder sind in Ihrem Gerät nicht erlaubt',
    media_not_access:
      'Kamera oder Mikrofon wird von einem anderen Prozess verwendet, der die Geräte nicht lesen lässt',
    constraint_error:
      'Es wurde kein Gerät gefunden, das ihren Video- und Audioeinschränkungen entspricht. Sie können Video- und Audioeinschränkungen ändern',
    media_access_denied: 'Sie dürfen nicht auf Kamera und Mikrofon zugreifen.'
  },
  filters: {
    days7: 'Letzten 7 Tage',
    days15: 'Letzten 15 Tage',
    days30: 'Letzten 30 Tage',
    days365: 'Letzten 365 Tage',
    date: 'Erstelltes Datum',
    relevance: 'Relevanz',
    popularity: 'Popularität',
    name: 'Name',
    group: 'Gruppe',
    Newest_to_Oldest: 'Neueste bis Älteste',
    Oldest_to_Newest: 'Älteste bis neueste',
    A_Z: 'A bis Z',
    Z_A: 'Z bis A'
  },
  helpers: {
    password:
      'Um die Sicherheit Ihres Kontos zu gewährleisten, benötigen wir mindestens eine Kleinbuchstaben und eine Nummer in Ihrem Passwort. Sie müssen auch eine Mindestlänge von 10 Zeichen haben.',
    phone: 'Bitte geben Sie Ihre Telefon-Ländervorwahl an, z. B.: +65',
    username:
      'Ihr Benutzername wird als öffentliche Information behandelt und bei Bedarf mit anderen Benutzern geteilt. Daher empfehlen wir Ihnen, keine personenbezogenen Daten in Ihrem Benutzernamen zu verwenden.',
    public_description_normal:
      'Ihre <0><0/></0> wurde gespeichert und gilt standardmäßig als Privat. Dies bedeutet, dass nur Sie diesen Inhalt sehen können. Um diesen Inhalt zu veröffentlichen, können Sie eine der folgenden Optionen auswählen. Die Veröffentlichung Ihres Kurses unter "Öffentlich" bedeutet, dass er allen Benutzern auf der Plattform zur Verfügung steht. Mit der Option Spezifische Benutzer können Sie Ihren Kurs mit bestimmten Benutzern teilen, indem Sie die E-Mail-Adresse verwenden, die mit ihrem Sharelook-Konto verknüpft ist.',
    public_description_admin:
      'Dieser <0><0/></0> wurde gespeichert und gilt standardmäßig als Privat. Dies bedeutet, dass nur Sie (und der Inhaltsersteller) diesen Inhalt sehen können. Um diesen Inhalt zu veröffentlichen, können Sie eine der folgenden Optionen auswählen. Das Veröffentlichen des Kurses unter "Öffentlich" bedeutet, dass er für alle Benutzer auf der Plattform verfügbar ist , auch für Benutzer außerhalb Ihrer Organisation. Die Veröffentlichung in der Organisation bedeutet, dass alle Benutzer innerhalb der Organisation sie sehen können. Sie können es auch in 1 oder mehr Gruppen veröffentlichen, d. h., nur die Benutzer innerhalb dieser Gruppen können sie sehen.  Schließlich haben Sie die Möglichkeit, es für bestimmte Benutzer innerhalb und außerhalb Ihrer Organisation unter Verwendung ihrer E-Mail-Adresse des Sharelook-Kontos zu veröffentlichen.'
  },
  labels: {
    add: 'Hinzufügen',
    portrait: 'Crop Portrait',
    landscape: 'Crop Landscape',
    answer_type: 'Antworttyp',
    answers: 'Antworten',
    back_to_quiz: 'Zurück zur Quizliste',
    back_to_question: 'Zurück zur Fragenliste',
    chat: 'Chat',
    chat_available: 'Chat ist in diesem Fall nicht verfügbar',
    chat_report: 'Chat-Meldung',
    choice_single: 'Einzelwahl',
    choice_multiple: 'Mehrfach wählen',
    choice_free: '"Freie" Auswahl',
    choice_sorting: '"Sortieren" Auswahl',
    choice_matrix: '"Matrix Sortierung" Auswahl',
    clone_lesson_permission: 'Berechtugung zum Duplizieren',
    code: 'Code',
    correct: 'Richtig',
    created: 'Erstelltes Datum',
    clone_modal: 'Kurs duplizieren',
    cloning_course: 'Kurs wird dupliziert...',
    cloning: 'duplizieren...',
    cloning_course_desc:
      'Dieser Prozess wird einige Zeit dauern. Bitte haben Sie Geduld',
    cloning_success: 'Kurs "<0/>" wurde erfolgreich dupliziert!',
    description: 'Beschreibung',
    disclaimer: 'Haftungsausschluss',
    drop_file: 'Datei hier ablegen...',
    duration: 'Dauer',
    edit: 'Bearbeiten',
    email: 'E-mail-Adresse',
    event: 'Event',
    event_all: 'Alle seine Events',
    event_date: 'Live Event Lokales Datum/Uhrzeit',
    event_this: 'Dieses Event',
    expire: 'Verfällt am',
    expiry_date: 'Ablaufdatum',
    forgot: 'Passwort vergessen?',
    group: 'Gruppe',
    groups_list: 'Liste der Gruppen',
    host: 'Leiter',
    id_annotation: 'Anmerkungs-ID',
    id_quiz: 'Quiz-ID',
    incorrect: 'Falsch',
    interests: 'Interessen',
    invited: 'Eingeladen',
    live_chat: 'Live-Diskussion',
    live_stream_limit: 'Live-Übertragungs-Minuten',
    contact_text:
      'Um Ihr monatliches Live-Übertragungs-Limit zu ändern, wenden Sie sich bitte an uns',
    contact_admin:
      '<0>Wenn Sie Ihr monatliches Live-Übertragungs-Limit ändern möchten, wenden Sie sich bitte an</0> <1>admin@sharelook.com</1>',
    limit_stream_text:
      'Verbleibende Live-Übertragungs-Minuten:<0>{{ limit }}</0> Minuten <1/><2/> <3>Um Ihr monatliches Live-Übertragungs-Limit zu ändern, wenden Sie sich bitte an</3> <4>admin@sharelook.com</4>',
    location: 'Standort',
    lessons: 'Lektionen',
    location_broadcast: 'Hostserver-Standort',
    location_broadcast_subtitle:
      'Hinzufügen eines Standorts, der dem Standort des Broadcast-Hosts am nächsten liegt, um die audiovisuelle Verzögerung zu verringern',
    media_manager: 'Medienmanager',
    minutes: 'Minuten',
    name: 'Name',
    online_quiz: 'Online Quiz',
    organiser: 'Autor',
    organization: 'Organisation',
    overall_emotion: 'Gesamterfahrung:',
    organizations_list: 'Liste von Organisationen',
    password: 'Passwort',
    participants: 'Teilnehmer',
    picture: 'Bild (16:9)',
    phone: 'Telefon',
    photo: 'Bild',
    poll: 'Umfrage',
    position: 'Position',
    processing: 'Verarbeitung',
    privacy_settings: 'Datenschutzeinstellungen',
    question: 'Frage',
    quiz_create: 'Neues Quiz erstellen',
    quiz_name: 'Quiz Name',
    quiz_update: 'Quiz aktualisieren',
    select_organization: 'Auswählen einer Organisation',
    settings: 'Einstellungen',
    show: 'Zeigen',
    show_graph: 'Ergebnis im Diagramm anzeigen',
    signin: 'Anmelden',
    signup: 'Registrieren',
    sort_by: 'Sortieren nach',
    start_date: 'Startdatum',
    tags: 'Verlinkungen',
    terms: 'Ich stimme diesen <1>Geschäftsbedingungen</1> zu.',
    title: 'Titel',
    topics: 'Themen',
    topic: 'Thema',
    total_comments: 'Alle Kommentare',
    username: 'Benutzername',
    users_list: 'Liste der Benutzer',
    users_emails: 'Einfügen bestimmter Benutzer-E-Mail-Adressen',
    description_specifiction_email:
      'Bitte geben Sie 1 E-Mail-Adresse pro Zeile ein, um es mit mehreren bestimmten Benutzern zu teilen.',
    message_specific_email:
      'Bitte geben Sie die E-mail-Adresse eines bestimmten Nutzers ein',
    viewers: 'Zuschauer',
    edit_course: 'Bearbeiten',
    edit_assessment: 'Bearbeiten',
    edit_event: 'Bearbeiten',
    delete_course: 'Löschen',
    delete_event: 'Löschen',
    delete_assessment: 'Löschen',
    view_course: 'Ansehen',
    view_event: 'Ansehen',
    view_assessment: 'Ansehen',
    date_event: 'Live-Event-Datum',
    date_assessment: 'Live-Bewertungs-Datum',
    clone_of: 'Duplizieren',
    clone_course:
      'Erstellen Sie ein Duplikat dieses Kurses, den Sie unabhängig vom Original ändern können, einschließlich aller Lektionen und Seiten.',
    make: 'Machen',
    available_to: 'für jeden ShareLook-Benutzer verfügbar',
    uploaded_by: 'Hochgeladen von: ',
    course: 'Kurs',
    assessment: 'Bewertung',
    user_not_exist:
      'Benutzer existiert nicht, möchten Sie eine Einladung senden?',
    check_user: 'Vermerken',
    user_not_exist_in_org:
      'Der Benutzer existiert in dieser Organisation nicht, möchten Sie eine Einladung senden?',
    title_modal_stream: 'Ändern des Livestream-Limits der Organisation',
    des_warning_stream: 'Sie sind dabei etwas zu ändern',
    monthly_stream: 'monatliches Live-Streaming-Limit:',
    min_per_month: 'min/Monat',
    broadcast_label: 'Ich möchte:',
    hosts_emails: 'Einfügen bestimmter E-Mails des Leiters',
    attendee_emails: 'Einfügen bestimmter Teilnehmer-E-Mails',
    description_host_specifiction_email:
      'Bitte geben Sie 1 E-Mail-Adresse pro Zeile ein.',
    presenter_label: 'Moderator',
    presenter_label_conference: 'keine Abwesenden',
    event_privacy: 'Konferenzmodus'
  },
  broadcastOptions: {
    stream_from_phone: 'Live-Übertragung mit meinem Handy',
    other_webrtc: 'Webinar von meinem PC aus',
    multihost: 'Multicast-Webinar von meinem PC aus',
    peer2peer: 'Trainings-Sitzung',
    conference: 'Live-Konferenz'
  },
  lessoncreate: {
    take_a_tour: 'Tour starten',
    title: 'Hinzufügen von Lektionsdetails',
    subtitle:
      'Benennen Sie Ihre Lektion und sagen Sie Ihrem Publikum, was Sie davon lernen können.',
    input_label_title: 'Titel der Lektion',
    input_label_topics: 'Thema der Lektion',
    input_label_description: 'Lektionsbeschreibung',
    delete_warning: 'Möchten Sie diese Seite wirklich löschen?'
  },
  lessonoverview: {
    title: 'Hinzufügen von Lektion',
    subtitle:
      'Hinzufügen vorhandener Lektionen oder Erstellen einer neuen Lektion',
    new_lesson: 'Erstellen einer neuen Lektion',
    new_lesson_sub: 'Erstellen Sie eine brandneue Lektion von Grund auf neu!',
    existing_lesson: 'Vorhandene Lektion auswählen',
    existing_lesson_sub:
      'Wenn Sie eine Verknüpfung zu einer vorhandenen Lektion herstellen, wirken sich die an dieser Lektion vorgenommenen Änderungen auch auf diese Lektion in anderen Kursen aus.',
    clone_lesson: 'Vorhandene Lektion duplizieren',
    clone_lesson_sub:
      'Machen Sie eine einzelne Kopie der Lektion in diesem Kurs, Änderungen an dieser Lektion wirken sich nicht auf die ursprüngliche Lektion aus.',
    clone_lesson_modal_sub:
      'Klicken Sie auf die Schaltfläche "Duplizieren" unter der Lektion, die Sie Ihrem Kurs hinzufügen möchten.'
  },
  management: {
    groups_title: 'Verwalten von Gruppen',
    delete_warning: 'Bist Sie sicher?',
    organizations_title: 'Meine Organisationen',
    organizations_subtitle: 'Hinzufügen von Organisationen zu Ihrer Liste',
    users_title: 'Verwalten von Benutzern',
    users_position: 'Senior Account Manager',
    user_not_found: 'Benutzer nicht gefunden',
    select_org:
      'Suchen und Auswählen einer Organisation zum Verwalten von Benutzern'
  },
  audio: {
    modal_title: 'Einfügen von einer Audio',
    list_view: 'Listenansicht',
    create_audio_modal_title: 'Erstellen von einer Audio',
    edit_audio_modal_title: 'Audio bearbeiten',
    public_audio_not_found: 'Audio wurde nicht gefunden.',
    private_audio_not_found: 'Sie haben noch keine Audio hochgeladen',
    are_you_sure_to_delete: 'Möchten Sie das wirklich löschen?',
    type_something: 'Geben Sie etwas ein',
    select_voice: 'Auswählen',
    file_name: 'Dateiname',
    description: 'Beschreibung',
    topic: 'Thema',
    key_words_tag: 'Schlagworte Tag',
    mp3_audio: 'MP3 Audio',
    created: 'Erstellt',
    duration: 'Dauer',
    close: 'Schließen'
  },
  image: {
    modal_title: 'Bild einfügen',
    image: 'Bild',
    pixel: 'Pixel',
    dimension: 'Dimension',
    public_image_not_found: 'Bild wurde nicht gefunden.',
    private_image_not_found: 'Sie haben noch kein Bild hochgeladen'
  },
  annotation: {
    modal_title: 'Anmerkung'
  },
  text: {
    modal_title: 'Texteditor'
  },
  video: {
    modal_title: 'Einfügen von Videos',
    image: 'Video',
    mp4_video: 'MP4 Video',
    public_video_not_found: 'Video wurde nicht gefunden.',
    private_video_not_found: 'Sie haben noch kein Video hochgeladen'
  },
  media: {
    title: 'Mediathek',
    subtitle: 'Bibliothek Ihrer Dateien',
    modal_title: 'Hochladen von Medien',
    delete_warning: 'Bestätigen des löschens',
    delete_message:
      'Gelöschte Medien werden weiterhin auf den Seiten angezeigt, auf denen sie verwendet wurden',
    dropzone_text: 'oder Drag and Drop',
    delete_success: 'Medien wurden erfolgreich gelöscht',
    upload_file: 'Datei hochladen',
    drag_drop: 'oder Drag and Drop',
    import_file: 'Importieren Sie Dateien von Ihrem Computer',
    no_media: 'Sie haben noch keine Medien hochgeladen',
    media_type: 'Medientyp',
    video: 'Video',
    image: 'Bild',
    audio: 'Audio',
    gif: 'GIF',
    transcribed_text: 'Transcribed Text',
    media_not_found: 'Medien wurden nicht gefunden.',
    of: 'von',
    disclaimer:
      'Ich versichere, dass meine Medien nicht:\n    - die Rechte dritter Parteien verletzen\n    - gesetzeswidrigen, rufschädigenden, obszönen, unsittlichen, anzüglichen, pornografischen, gewalttätigen, beleidigenden, unverschämten, drohenden oder diskriminierenden Inhalt                                    enthalten, dieser wird auch nicht mit Sternchen verborgen\n    - persönliche verbale Angriffe enthalten\n    -Imitationen von anderen Teilnehmern, öffentlicher Personen oder Berühmtheiten enthalten\n    -Aufnahmen von persönlichen Informationen einer Person ohne dessen Zustimmung enthalten       \n     und dass keine Datenschutzverordnungen in irgendeinem Land der Welt verletzt werden\n    -gewerbliche Werbung oder sonstige Arten von “Spam” enthalten',
    my_media: 'Meine Medien',
    public_library: 'Öffentliche Bibliothek',
    organization_library: 'Organisationsbibliothek',
    upload_from_computer: 'Hochladen vom Computer',
    create: 'Anlegen',
    all: 'Alle',
    male: 'Männlich',
    female: 'Weiblich',
    processing_audio: 'Verarbeitung von Audio',
    create_annotation: 'Annotation erstellen',
    popup_over_lesson_text:
      'Die Anmerkung wird nach dem Klicken über der Lektionsseite eingeblendet',
    edit_detail: 'Detail bearbeiten',
    delete: 'Löschen',
    go_create_audio: 'Gehen Sie Audio erstellen',
    show_more_details: 'mehr Details anzeigen',
    show_less_details: 'weniger Details anzeigen',
    drop_files: 'Dateien ablegen und hochladen',
    or: 'Oder',
    import_files: 'Dateien vom Computer importieren'
  },
  navigation: {
    account: 'Konto',
    assessments: 'Bewertungen',
    dashboard: 'Dashboard',
    groups: 'Gruppenmanagement',
    logout: 'Ausloggen',
    organisations: 'Organisationen',
    organizations_users: 'Organisationen & Benutzer',
    reports: 'Meldungen',
    schedule: 'Zeitplan',
    training: 'Training',
    nowLive: 'Übertragung',
    users: 'Benutzer',
    workshop: 'Mein Workshop'
  },
  onboarding: {
    step1_title: 'Schritt 1 : Erzählen Sie uns ein wenig über sich selbst',
    step1_subtitle: 'Wie heißen Sie? Woher kommen Sie? Was ist Ihr Beruf?',
    step2_title:
      'Schritt 2 : Wählen Sie einige Fertigkeiten, die Sie an Ihnen verbessern könnten',
    step2_subtitle:
      'Als nächstes sagen Sie uns bitte, was Sie besser verstehen möchten. Vielleicht etwas, was Sie noch nicht komplett verstanden haben? Ein neues Interessenfeld? Was Ihr Partner macht?'
  },
  pagebuilder: {
    title: 'Lektion erstellen',
    subtitle:
      'Es ist an der Zeit, den Inhalt für Ihre Zielgruppe zu erstellen, von dem Sie von Ihnen lernen können.Fügen Sie doch Bilder, Videos und Diagramme hinzu',
    select_layout: 'Wählen Sie ein Seitenlayout',
    template1: 'leer',
    template2: 'Titel & Untertitel',
    template3: 'Titel & Text',
    template4: 'Titel, Medien & Text',
    template5: 'Titel & Medien',
    template6: 'Titel & Quiz'
  },
  pageconstructor: {
    title: 'Erstellen und Duplizieren von Lektionen',
    subtitle:
      ' Es ist an der Zeit, den Inhalt für Ihre Zielgruppe zu erstellen, von dem Sie von Ihnen lernen können.Fügen Sie doch Bilder, Videos und Diagramme hinzu '
  },
  passwordreset: {
    success_coded:
      'Wir haben einen Bestätigungscode an die von Ihnen angegebene E-Mail-Adresse gesendet, kopieren Sie bitte den Code in das Feld, um ein neues Passwort festzulegen.',
    success_changed:
      'Sie haben erfolgreich ein neues Kennwort festgelegt. Sie können sich jetzt anmelden.'
  },
  placeholders: {
    search: 'Suche',
    answer: 'Antwort',
    chat: 'Sag etwas...',
    code: 'Code',
    criterion: 'Kriterium',
    date_event: 'Datum & Uhrzeit auswählen',
    date_start: 'Startdatum',
    date_expire: 'Ablaufdatum',
    description: 'Beschreibung',
    elements: 'Sortieren von Elementen',
    email: 'E-Mail-Adresse',
    feedback_correct: 'positives Feedback',
    feedback_incorrect: 'Feedback von zu verbessernden Sachen',
    host: 'Leiter',
    keywords: 'Suche Schlüsselwörter',
    lesson_description: 'Lektionsbeschreibung',
    location: 'Standort',
    minutes: 'Minuten',
    name: 'Name',
    organiser: 'Autor',
    organization: 'Organisation',
    password: 'Passwort',
    phone: 'Telefonnumer',
    photo: 'Bild',
    picture: 'Foto',
    point: 'Punkt',
    position: 'Position',
    question: 'Frage',
    quiz: 'Quiz-Name',
    search_course: 'Suche nach einem Kurs',
    search_media: 'Suche nach Medien',
    search_name: 'Suche nach einem Namen',
    search_title: 'Suche nach einem Titel',
    search_training: 'Suche ein Training',
    settings: 'Einstellungen',
    tags: 'Tags',
    title: 'Titel',
    topics: 'Themen',
    username: 'Benutzername',
    keyword: 'Schlüsselwörter',
    max_500_characters: 'Max. 500 Zeichen ',
    no_description: 'Diese Datei enthält keine Beschreibung',
    no_keyword: 'Diese Datei hat keine Schlüsselwörter',
    no_topics: 'Für diese Datei ist kein Thema festgelegt.',
    feedback: 'Nachricht',
    contact: 'Wie können wir helfen?'
  },
  publishsettings: {
    title: 'Einstellungen zur Veröffentlichung',
    event_subtitle:
      'Hinzufügen von Einstellungen zu Ihrem Event, wer im Event angezeigt wird und wer mit Ihnen interagieren kann',
    assessment_subtitile:
      'Benennen Sie Ihre Bewertung und sagen Sie Ihrem Publikum, was Sie davon lernen können',
    course_subtitle:
      'Hinzufügen von Einstellungen zu Ihrem Kurs, wer angezeigt werden kann und wer mit Ihnen interagieren kann',
    disclaimer:
      '\n    1.\tRegistrierung\n\n    Mit der Registrierung als Nutzer/der Erstellung eines Kontos erklären Sie sich mit unseren [Benutzervereinbarung] eiverstanden und erkennen unsere [Datenschutzrichtlinien] an.\n\n    2.\tKurs erstellen\n\n    Durch die Nutzung unserer Tools und die Erstellung von Kursinhalten erklären Sie sich mit unseren [Benutzervereinbarung] einverstanden und erkennen unsere [Datenschutzrichtlinien] an.\n\n    3.\tEvent erstellen\n\n    Durch die Nutzung unserer Tools und die Erstellung eines Events erklären Sie sich mit unseren [Benutzervereinbarung] einverstanden und erkennen unsere [Datenschutzrichtlinien] an.\n\n    4.\tErstellen einer Bewertung\n\n    Durch die Nutzung unserer Tools und die Erstellung einer Bewertung erklären Sie sich mit unseren [Benutzervereinbarung] einverstanden und erkennen unsere [Datenschutzrichtlinien] an.',
    dates_validation_error: 'Beide Datenh sollten ausgefüllt werden.',
    course_dates_validation_error: 'Bitte geben Sie das Start- und Ablaufdatum für diesen Kurs ein.',
    emails_validation_error: 'Die E-Mail-Liste ist ungültig.',
    specific_email_validation_error: 'Es ist nur eine E-Mail-Adresse zulässig.',
    i_agree_to_these: 'Ich stimme diesen zu ',
    terms_and_conditions: 'Geschäftsbedingungen.',
    PublicDescription:
      'Freie unabhängige Benutzer: (private und öffentliche Optionen).Ihr [Kurs| Event | Bewertung] wurde gespeichert und gilt standardmäßig als privat. Dies bedeutet, dass nur Sie diesen Inhalt sehen können. Um diesen Inhalt zu veröffentlichen, können Sie unten auswählen, ob er veröffentlicht werden soll. Dies bedeutet, dass der Kurs für alle Benutzer auf der Plattform verfügbar sein wird.',
    OrganisationsDescription:
      'Org-Benutzer: (Anstelle von ""Beenden"" verwenden Sie ""Veröffentlichen"" und sie werden zur  Veröffentlichungsseite wie andere Benutzer geleitet, aber ohne die Veröffentlichungsoptionen.) Ihr [Kurs| Event | Bewertung] wurde gespeichert und ist Privat. Dies bedeutet, dass nur Sie und die Administratoren in Ihrer Organisation es sehen können. Als Benutzer können Sie Ihre Inhalte nicht selbst in Ihrer Organisation veröffentlichen, da dies Administratorrechte erfordert. Wenden Sie sich an einen Ihrer Administratoren, und bitten Sie ihn, Ihre Inhalte öffentlich zu machen. Entweder in der gesamten Organisation, in bestimmten Gruppen innerhalb Ihrer Organisation oder für bestimmte Benutzer.',
    OrganisationGroupsDescription:
      'Org-Admins: (Für Inhalte, die innerhalb der Organisation gemacht werden: Privat, öffentlich, Organisation, Gruppen, für bestimmte Benutzer):Dieser [Kurs| Event | Bewertung] wurde gespeichert und gilt standardmäßig als privat. Dies bedeutet, dass nur Sie (und der Inhaltsersteller) diesen Inhalt sehen können. Um diesen Inhalt zu veröffentlichen, können Sie eine der folgenden Optionen auswählen. Das Veröffentlichen des Kurses unter "Öffentlich" bedeutet, dass er für alle Benutzer auf der Plattform verfügbar ist , auch für Benutzer außerhalb Ihrer Organisation. Die Veröffentlichung in der Organisation bedeutet, dass alle Benutzer innerhalb der Organisation es sehen können. Sie können es auch in 1 oder mehr Gruppen veröffentlichen, d. h., nur die Benutzer innerhalb dieser Gruppen können sie sehen.  Schließlich haben Sie die Möglichkeit, es für bestimmte Benutzer innerhalb und außerhalb Ihrer Organisation unter Verwendung ihrer E-Mail-Adresse des Sharelook-Kontos zu veröffentlichen.',
    SpecificUsersDescription:
      'Zahlende unabhängige Benutzer: (private, öffentliche und spezifische Benutzer). Ihr [Kurs| Event | Bewertung] wurde gespeichert und gilt standardmäßig als privat. Dies bedeutet, dass nur Sie diesen Inhalt sehen können. Um diesen Inhalt zu veröffentlichen, können Sie eine der folgenden Optionen auswählen. Die Veröffentlichung Ihres Kurses unter "Öffentlich" bedeutet, dass er allen Benutzern auf der Plattform zur Verfügung steht. Mit der Option Spezifische Benutzer können Sie Ihren Kurs mit bestimmten Benutzern teilen, indem Sie die E-Mail-Adresse verwenden, die mit ihrem Sharelook-Konto verknüpft ist.'
  },
  quiz: {
    quiz_empty: 'Sie haben noch kein Quiz erstellt',
    questions_empty: 'Sie haben noch keine Frage erstellt'
  },
  regions: {
    asia_pacific_australia: 'Australien',
    asia_pacific_india: 'Indien',
    asia_pacific_japan: 'Japan',
    asia_pacific_s_korea: 'Südkorea',
    asia_pacific_singapore: 'Singapur',
    asia_pacific_taiwan: 'Taiwan',
    eu_belgium: 'Belgien',
    eu_germany: 'Deutschland',
    eu_ireland: 'Irland',
    south_america_brazil: 'Brasilien',
    us_central_iowa: 'Iowa',
    us_east_s_carolina: 'South Carolina',
    us_east_virginia: 'Virginia',
    us_west_california: 'California',
    us_west_oregon: 'Oregon'
  },
  reports: {
    title: 'Meldungen',
    workshop_report: 'Workshop-Bericht',
    user_report: 'Benutzer-Bericht',
    organization_workshop: 'organisation werkstatt',
    course: 'Kurs',
    live_event: 'Live-Veranstaltung',
    workShop_graph: 'Grafik Werkstatt',
    organization_account: 'Konto Organisation',
    all: 'Alle',
    name: 'Name',
    id_number: 'ID-Nummer',
    email: 'Email',
    search_user_report: 'Benutzerbericht suchen',
    participant: 'Teilnehmer',
    participants: 'Teilnehmer',
    host: 'Gastgeber',
    username: 'Benutzername',
    event: 'Ereignis',
    quiz: 'Quiz',
    assessment: 'Bewertung',
    time: 'Zeit',
    no_recent_activity: 'Keine jüngste Aktivität',
    workshops: 'Workshops',
    courses: 'Kurse',
    live_events: 'Live-Veranstaltungen',
    live_assessments: 'Live-Bewertungen',
    quizzes: ' Ratespiele',
    overview: 'Überblick',
    by: ' von',
    views: 'Ansichten',
    status: 'Status',
    poll: 'Umfrage',
    comment: 'Kommentar',
    comments: 'Kommentare',
    no_comments: 'Keine Kommentare',
    no_polls: 'Keine Umfragen',
    live_date: 'Live-Datum',
    score: 'Partitur',
    question: 'Frage',
    submit: 'Einreichen',
    recent_activity: 'Jüngste Aktivität',
    ago: 'Vorbei',
    no_data_found: 'Keine Daten gefunden',
    start_end_live: 'Start / Ende live',
    join_leave_date: 'Beitreten / Verlassen',
    watched_time: 'Beobachtete Zeit',
    complete: 'Vollständig',
    in_complete: 'Un vollständig',
    today: 'Heute',
    seven_days: '7 Tage',
    last_month: 'Letzter Monat',
    one_year: '1 Jahr',
    all_time: 'Alle Zeit',
    report: 'Bericht',
    from_date: 'Von-Datum',
    to_date: 'Bis dato',
    all_workshop: 'Alle Workshop',
    all_participants: 'Alle Teilnehmer',
    live_assessment: 'Live-Beurteilung',
    users: 'Benutzer',
    download: 'herunterladen',
    recent: 'Kürzlich',
    WorkShop: 'Werkstatt',
    Activity: 'Aktivität',
    created_date: 'Erstellungsdatum',
    lessons: 'Lektionen',
    lesson: 'Lektion',
    completed: 'Abgeschlossen',
    report_download: 'Bericht herunterladen',
    this_month: 'Diesen Monat',
    search_course: 'Kurs suchen',
    participants_graph: 'Grafik Teilnehmer',
    viewed: 'Gesehen',
    enrolled: 'Eingeschrieben',
    description: 'Beschreibung',
    topic: 'Thema',
    analytic: 'Analytisch',
    quiz_list: 'Quiz-Liste',
    select_one: 'Eine auswählen',
    group_status: 'Gruppenstatus',
    duration_min: 'Dauer(min)',
    submit_poll: 'Umfrage einreichen',
    download_events: 'Veranstaltungen herunterladen',
    search_event: 'Veranstaltung suchen',
    duration: 'Dauer',
    total_participants: 'Total Teilnehmer',
    message: 'Nachricht',
    avg_message: 'Durchschnitt. Nachricht',
    per_message: 'per_Nachricht: '
  },
  signup: {
    success_step1:
      'Wir haben einen Bestätigungscode an die von Ihnen angegebene E-Mail-Adresse gesendet, kopieren Sie bitte den Code in das Feld, um Ihre Registrierung zu bestätigen.',
    success_step2: 'Danke. Sie sind erfolgreich registriert.',
    privacy:
      "Ich stimme Sharelook's <1> Allgemeine Geschäftsbedingungen</1> und <3> Datenschutzrichtlinien </3> zu"
  },
  stream: {
    emotion_impressive: 'Beeindruckend',
    emotion_unimpressive: 'nicht beeindruckend',
    message_not_started: 'Erscheint bald',
    message_running: 'Live',
    message_processing:
      'Wir verarbeiten derzeit die Live-Aufnahme für die Wiedergabe. Bitte schauen sie später nochmal vorbei um das Video zu sehen znd Bewertungen und Feedack zu schreiben.'
  },
  tabs: {
    audience: 'Publikum',
    course: 'Kursübersicht',
    details: 'Live-Event-Details',
    description: 'Beschreibung',
    host: 'Leiter',
    lesson: 'Lektionsübersicht',
    lessons: 'Lektionen',
    overview: 'Übersicht',
    page: 'Seiten-Editor',
    publish: 'Veröffentlichen',
    settings: 'Einstellungen zum Veröffentlichen',
    total_views: 'Alle Aufrufe',
    live_participates: 'Live-Teilnehmer',
    live_chats: 'Live-Chats',
    live_quiz: 'Live-Umfragen',
    trainer_rating: 'Trainerbewertung',
    trainer_times: 'Trainer Zeiten',
    courses_quizzes: 'Kurs-Quizze',
    user_list: 'Benutzerliste',
    discussion: 'Diskussion',
    notes: 'Meine Notizen'
  },
  topics: {
    SALES_TRAINING: 'Verkaufstraining',
    NEGOTIATION_TRAINING: 'Verhandlungstraining',
    CROSS_CULTURAL_AWARENESS: 'Interkulturelles Bewusstsein',
    NETWORKING_SKILLS: 'Netzwerkfähigkeiten',
    SOFTWARE_ARCHITECTURE: 'Softwarearchitektur',
    PROJECT_MANAGEMENT: 'Projektmanagement',
    DIGITAL_TRANSFORMATION: 'Digitale Transformation',
    IT_CONSULTING: 'IT-Beratung',
    MANAGEMENT_CONSULTING: 'Management-Beratung',
    HR_CONSULTING: 'HR-Beratung',
    INTERNET_OF_THINGS: 'Internet of Things (IoT)',
    CYBERSECURITY: 'Cybersecurity',
    PRIVACY_AND_GDRP: 'Datenschutz und DSGVO'
  },
  training: {
    title: 'Training',
    title_assessment: 'Bewertungen',
    subtitle: 'Kurse und Live-Events',
    enrolled_title: 'Eingeschriebene Kurse und Live-Events',
    enrolled_subtitle:
      'Kurse und Live-Events, für die Sie sich angemeldet haben',
    enrolled_message:
      'Sie sind derzeit nicht an Kursen und Veranstaltungen angemeldet.',
    past_live_event_title: 'Vergangene Live-Events',
    past_live_event_subTitle: 'Abgeschlossene Live-Events',
    past_live_event: 'Es gibt derzeit keine vergangenen Live-Events',
    recomended_title: 'Empfohlene Kurse und Live-Events',
    now_live_event_title: 'Jetzt Live',
    now_live_event_subTitle:
      'Events, die live sind oder sehr bald live sein werden',
    now_live_event: 'Derzeit gibt es keine Live-Events.',
    webinar_event_title: 'Webinar-Kanal',
    webinar_event_subTitle: 'Abgeschlossene Webinare',
    webinar_event: 'Derzeit gibt es keine Webinare.',
    p2p_event_title: 'Coaching-Sitzung',
    p2p_event_subTitle: 'Abgeschlossene Coaching-Sitzungen',
    p2p_event: 'Derzeit gibt es keine Coaching-Sitzung.',
    now_live_assessment_title: 'Jetzt Live',
    now_live_assessment_subTitle:
      'Bewertungen, die live sind, oder bald live sein werden',
    now_live_assessment_message: 'Derzeit gibt es keine Live-Bewertungen.',
    upcoming_assessment_title: 'Geplante Live-Bewertungen',
    upcoming_assessment_subtitle: 'Geplante Live-Bewertungen',
    upcoming_assessment_message:
      'Derzeit gibt es keine geplanten Live-Bewertungen.',
    past_live_assessment_title: 'Vergangene Live-Bewertungen',
    past_live_assessment_subTitle: 'Abgeschlossene Live-Bewertungen',
    past_live_assessment_message:
      'Es gibt derzeit keine vergangenen Live-Bewertungen.',
    recomended_subtitle:
      'Wir haben Kurse und Live-Events basierend auf Ihrem <0><0/></0> ausgewählt',
    search: 'Training suchen',
    search_assessment: 'Bewertung suchen',
    recomended_message: 'Derzeit gibt es keine empfohlenen Kurse und Events.'
  },
  warnings: {
    delete: 'Sind Sie sicher?'
  },
  workshop: {
    title: 'Mein Workshop',
    subtitle:
      'Erstellen Sie einen Kurs oder veranstalten Sie ein eigenes Live-Event',
    new_course: 'Erstellen eines neuen Kurs',
    new_event: 'Erstellen eines neuen Live-Events',
    new_assessment: 'Erstellen einer neuen Live-Bewertung',
    courses_title: 'Erstellte Kurse & Live-Events',
    courses_subtitle:
      'Bearbeiten & Veröffentlichen Ihres erstellten Kurses und Planen von Live-Events',
    tags_course: 'Kurs',
    tags_live: 'Live-Event',
    tags_assessment: 'Live-Bewertung'
  },
  help_center: {
    sidebar: {
      title: 'Wie können wir Ihnen helfen?',
      back_to: 'Dashboard'
    },
    menu: {
      help_center: 'Hilfe-Center',
      whats_new: 'Was gibt es Neues?',
      feedback: 'Feedback',
      feedback_title: 'Senden Sie feedback an sharelook',
      terms_and_conditions: 'Allgemeine Geschäftsbedingungen',
      privacy_policy: 'Datenschutzrichtlinien',
      contact_us: 'kontaktieren Sie uns'
    },
    get_started: {
      title: 'Starten Sie mit share look',
      description: {
        main:
          'WIR HABEN DAS LIVE-VIDEO IN EINEN BENUTZERFREUNDLICHEN KURS-BUILDER INTEGRIERT',
        tagline:
          'Mit dem patentierten Live-Übertragungs-System von ShareLook können Sie Engagement aufbauen, lernen und den Wissensaustausch maximieren..'
      }
    },
    whats_new: {
      title: 'Starten Sie mit share look',
      description: {
        main:
          'Wussten Sie, dass das Erstellen von Storytelling-Stil-Lernen in kurzer Zeit und nicht so teuer möglich ist?  Sie sollten den ShareLook Kurs-Builder und die Ihre entsprechenden Talente kombinieren. Sie können uns fragen: "WIE”',
        tagline: ''
      }
    },
    create_workshop: 'So erstellen Sie einen Workshop',
    create_course: 'So erstellen Sie einen Kurs',
    create_user: 'So erstellen Sie ein Benutzerkonto',
    create_group: 'So erstellen Sie eine Gruppe',
    create_webinar: 'Erstellen eines Webinars',
    create_live_event: 'Wie man ein Live-Event erstellt',
    create_live_assessment: 'So erstellen Sie Live-Bewertungen',
    create_live_on_mobile: 'Live auf Mobilgeräten erstellen',
    personalize_profile: 'Personalisieren eines Profils',
    manage_group: 'Gruppe verwalten',
    report: 'Melden',
    add_annotations: 'Hinzufügen von Anmerkungen/Popups',
    add_audio: 'Wie man Audio hinzufügt',
    add_header_and_footer: 'Hinzufügen von Header & Footer',
    add_image: 'Wie man ein Bild hinzufügt',
    add_quiz_content: 'So fügen Sie Quizinhalte hinzu',
    add_text_content: 'Hinzufügen von Textinhalten',
    add_user: 'Wie man Benutzer hinzufügt',
    add_video: 'Wie man ein Video hinzufügt',
    clone_course: 'Wie man den Kurse dupliziert',
    find_live_broadcast: 'So finden Sie Live-Übertragungen',
    contact_us: {
      title: 'kontaktieren Sie uns',
      subject_placeholder: 'Geben Sie ein Betreff ein*',
      content_placeholder: 'Geben Sie eine Nachricht ein*',
      subject_required: '*Betreff ist erforderlich',
      content_required: '*Nachricht ist erforderlich',
      submit: 'Senden',
      cancel: 'Abbrechen',
      sent: 'gesendet'
    },
    feedback: {
      title: 'Senden Sie feedback an sharelook',
      attach_title: 'Anfügen einer Datei',
      choose: 'Datei auswählen',
      detail: 'Die Datei wird mit dem Support-Team geteilt',
      content_placeholder: 'Geben Sie eine Nachricht ein*',
      content_required: '*Nachricht ist erforderlich',
      submit: 'Senden',
      cancel: 'Abbrechen',
      sent: 'gesendet'
    }
  },
  discussion: {
    join_discussion: 'Der Diskussion beitreten'
  },
  notes: {
    title: 'Meine Notizen',
    add_note: 'Neue Notiz hinzufügen'
  }
}
